webpackJsonp([6],[
/* 0 */
/***/ (function(module, exports) {


var isIE = function isIE() {
	return !!window.ActiveXObject || "ActiveXObject" in window;
},
    ltIE9 = function ltIE9() {
	var browser = navigator.appName,
	    b_version = navigator.appVersion,
	    version = b_version.split(";");

	if (version.length > 1) {
		var trim_Version = parseInt(version[1].replace(/[ ]/g, "").replace(/MSIE/g, ""));
		if (trim_Version < 9) {
			return true;
		}
	}

	return false;
},
    loadAsync = function loadAsync(src, callback) {
	if (typeof src === 'string') {
		src = [src];
	}

	for (var i = 0; i < src.length; i++) {
		var script = document.createElement('script');
		script.src = src[i];

		if (callback && $.type(callback) === 'function' && i + 1 === src.length) {
			script.onreadystatechange = function () {
				if (script.readyState === 'loaded' || script.readyState === 'complete') {
					callback();
				}
			};
		}
		document.body.appendChild(script);
	}
},
    queryString = function queryString(name, targetStr) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	var r;
	if (!targetStr) {
		r = window.location.search.substr(1).match(reg);
	} else {
		r = targetStr.match(reg);
	}
	return r != null ? unescape(r[2]) : null;
},
    addDays = function addDays(d1, num, sep) {
	sep = sep || '-';
	num = num || 0;
	if (typeof d1 === 'string') d1 = new Date(d1.replace(/-/g, '/'));
	return new Date(+d1 + num * 24 * 60 * 60 * 1000).Format('yyyy' + sep + 'MM' + sep + 'dd');
},
    throttle = function throttle(func, option, timeGap, context) {

	timeGap = timeGap || 300;

	clearTimeout(func.tId);

	func.tId = setTimeout(function () {
		func.call(context, option);
	}, timeGap);
},
    login = function login() {
	location.href = '/user/home.do';
},
    tipShowAndHide = function tipShowAndHide(_this, msg, options) {
	var tip = layer.tips(msg, _this, $.extend(true, {
		time: 0,
		tips: [1, '#FFFFF3']
	}, options));

	_this.one('mouseleave', function () {
		layer.close(tip);
	});
},
    formatOne = function formatOne(str) {
	return str.replace(/\//g, '-');
},
    CloseWebPage = function CloseWebPage() {
	if (navigator.userAgent.indexOf("MSIE") > 0) {
		if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
			window.opener = null;
			window.close();
		} else {
			window.open('', '_top');
			window.top.close();
		}
	} else if (navigator.userAgent.indexOf("Firefox") > 0) {
		window.location.href = 'about:blank ';
	} else {
		window.opener = null;
		window.open('', '_self', '');
		window.close();
	}
};

module.exports = {
	isIE: isIE,
	ltIE9: ltIE9,
	login: login,
	addDays: addDays,
	loadAsync: loadAsync,
	queryString: queryString,
	throttle: throttle,
	tipShowAndHide: tipShowAndHide,
	formatOne: formatOne,
	CloseWebPage: CloseWebPage
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(10);

module.exports = function (option) {
	var loginTpl = __webpack_require__(11)();
	var event = window.event || arguments.callee.caller.arguments[0];

	if (!option) {
		layer.open({
			type: 1,
			title: false,
			area: ['360px', '422px'],

			content: loginTpl,
			success: function success() {
				__webpack_require__(2).run();
			}
		});
	}

	if (option) {
		if (option.position === 'mask') {
			layer.open({
				type: 1,
				title: false,
				area: ['360px', '422px'],

				content: loginTpl,
				success: function success() {
					__webpack_require__(2).run();
				}
			});
		} else if (option.position === 'below') {
			if (!option.target) {
				option.target = event.target || event.srcElement;
			}

			var left = +$(option.target).offset().left,
			    top = +$(option.target).offset().top,
			    height = +$(option.target).height();

			if ($('body .login-box').length <= 0) {
				$('body').append(loginTpl);
			} else {
				$('div').remove('.login-box');
				return;
			}

			$('.login-box').css({
				'position': 'absolute',
				'left': left - 180 + 'px',
				'top': top + height + 'px',
				'z-index': '19950311'
			});
		}
	}
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

var firstPageApi = {
	login: '/user/loginfzg.do',
	isLogin: '/user/getCurrentUser.do',
	loginout: '/user/loginoutfzg.do'
};

function loginJl() {
	$('#loginIn').click(function () {
		$('.err-msg').text('');

		$('#loginJl>ul>li').removeClass('li-error');

		$(this).text('登录中…');

		var allInput = $('#loginJl').find('input[emptymsg]');

		var loginFlag = "true";
		for (var aI = 0; aI < allInput.length; aI++) {
			var $requireInput = $(allInput[aI]);
			if (!$requireInput.val()) {
				loginFlag = "false";
				$('.err-msg').text($requireInput.attr('emptymsg'));

				$requireInput.parent().addClass('li-error');

				$(this).text('登录');
				break;
			}
		}

		if (loginFlag == "true") {
			var rememberMe = '';
			if ($('input[name="rememberMe"]').is(':checked')) {
				rememberMe = 'true';
			} else {
				rememberMe = 'false';
			}
			var paramObj = {
				accountCode: $.trim($('#accountCode').val()),
				username: $.trim($('#username').val()),
				password: $('#password').val(),
				checkcode: $('#checkcode').val(),
				rememberMe: rememberMe
			};

			$.post(firstPageApi.login, paramObj, function (data) {
				if (data.returnCode) {
					if (data.returnCode != 1) {
						$('.err-msg').text('*' + data.returnMsg);
						$('.yzm-img').trigger('click');
						$('#loginIn').text('登录');
					} else {
						if ($.trim(paramObj.accountCode).length > 0) {
							var record_data = encodeURIComponent(paramObj.accountCode.toUpperCase());
							$.get("/count/record.do?t=ActiveDistrb&d=" + record_data);
						}

						var loginAccount = localStorage.getItem("LoginAccount");
						if (!loginAccount || loginAccount != paramObj.accountCode) {
							localStorage.setItem("LoginAccount", paramObj.accountCode);
						}
						var LoginUsername = localStorage.getItem("LoginUsername");
						if (!LoginUsername || LoginUsername != paramObj.username) {
							localStorage.setItem("LoginUsername", paramObj.username);
						}

						layer.closeAll();
						location.reload();
					}
				} else {
					alert('系统繁忙，请稍后重试');
					$('#loginIn').text('登录');
				}
			});
		}

		return false;
	});
}

function other() {
	$('.yzm-img').click(function () {
		$(this).attr('src', '/user/getCheckcodeImg.do?time=' + new Date().getTime());
	});
}

function getCookie(name) {
	var strcookie = document.cookie;
	var arrcookie = strcookie.split("; ");
	for (var i = 0; i < arrcookie.length; i++) {
		var arr = arrcookie[i].split("=");
		if (arr[0] == name) {
			return arr[1];
		}
	}
	return "";
}

module.exports = {
	run: function run() {
		if (getCookie('login_account_code_cookie')) {
			$('input[name="accountCode"]').val(getCookie('login_account_code_cookie'));
			$('input[name="username"]').val(decodeURIComponent(getCookie('login_user_name_cookie')));
			$('input[name="rememberMe"]').attr('checked', 'true');
		}

		loginJl();

		other();
	}
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(7);
__webpack_require__(8);

function validate_1(accountCode, flag) {
    return common_validate(accountCode, "f-error1", "公司账号不能为空！", flag);
}

function validate_2(username, flag) {
    return common_validate(username, "f-error2", "用户名不能为空！", flag);
}

function validate_3(password, flag) {
    return common_validate(password, "f-error3", "密码不能为空！", flag);
}

function validate_4(checkcode, flag) {
    return common_validate(checkcode, "f-error4", "验证码不能为空！", flag);
}

function validate(param, flag) {

    if (!validate_1(param.accountCode, flag)) return false;

    if (!validate_2(param.username, flag)) return false;

    if (!validate_3(param.password, flag)) return false;

    if (!validate_4(param.checkcode, flag)) return false;
    if ($("#validateMsg" + flag).hasClass("f-error1") || $("#validateMsg" + flag).hasClass("f-error2") || $("#validateMsg" + flag).hasClass("f-error3") || $("#validateMsg" + flag).hasClass("f-error4")) return false;

    return true;
}

function login(param, flag) {
    if (!validate(param, flag)) {
        $('.yzmlogin').attr('src', '/user/getCheckcodeImg.do?time=' + new Date().getTime());
        return false;
    }

    $("#loadingImg" + flag).removeClass("hidden");
    $("#p1_RightBody" + flag + " .loginBody").addClass("hidden");

    if (param && param.accountCode && param.username && param.password && param.checkcode) {
        $.post("/user/loginfzg.do", param, function (data) {
            if (data.returnCode === 1) {
                if ($.trim(param.accountCode).length > 0) {
                    $.get("/count/record.do?t=ActiveDistrb&d=" + param.accountCode.toUpperCase());
                }

                var loginAccount = localStorage.getItem("LoginAccount");
                if (!loginAccount || loginAccount != param.accountCode) {
                    localStorage.setItem("LoginAccount", param.accountCode);
                }
                var LoginUsername = localStorage.getItem("LoginUsername");
                if (!LoginUsername || LoginUsername != param.username) {
                    localStorage.setItem("LoginUsername", param.username);
                }

                $("#div_User").attr('data-distrb', param.accountCode);
                sessionStorage.setItem('login', 'login');
                layer.closeAll();

                location.reload();
            } else {
                $('.yzmlogin').attr('src', '/user/getCheckcodeImg.do?time=' + new Date().getTime());
                showErrorMsg(data.msg, flag);
            }

            $("#loadingImg" + flag).addClass("hidden");
            $("#p1_RightBody" + flag + " .loginBody").removeClass("hidden");
        });
    }
}

function removeErrorMsg(flag) {
    $("#validateMsg" + flag).html("");
    $("#validateMsg" + flag).addClass("hidden");

    if (flag == 1) {
        $("#p1_RightBody1 .loginBody").css("height", "277px");
        $("#loginBody2").css("padding-top", "22px");
    } else if (flag == 2) {
        $("#p1_RightBody2 .loginBodyRow").css("margin-top", "15px");
    }
}

function showErrorMsg(msg, flag) {
    $("#validateMsg" + flag).html("* " + msg);
    $("#validateMsg" + flag).removeClass("hidden");

    if (flag == 1) {
        $("#p1_RightBody1 .loginBody").css("height", "305px");
        $("#loginBody2").css("padding-top", "14px");
    } else if (flag == 2) {
        $("#p1_RightBody2 .loginBodyRow").css("margin-top", "12px");
    }
}

function handleErrorMsg(flag) {
    if ($("#validateMsg" + flag).hasClass("f-error1")) {
        showErrorMsg("公司账号不能为空！", flag);
        return false;
    }

    if ($("#validateMsg" + flag).hasClass("f-error2")) {
        showErrorMsg("用户名不能为空！", flag);
        return false;
    }

    if ($("#validateMsg" + flag).hasClass("f-error3")) {
        showErrorMsg("密码不能为空！", flag);
        return false;
    }

    if ($("#validateMsg" + flag).hasClass("f-error4")) {
        showErrorMsg("验证码不能为空！", flag);
        return false;
    }

    removeErrorMsg(flag);
    return true;
}

function common_validate(value, className, errorMsg, flag) {
    if (value === "") {
        $("#validateMsg" + flag).addClass(className);
        showErrorMsg(errorMsg, flag);
        return false;
    } else {
        $("#validateMsg" + flag).removeClass(className);
        handleErrorMsg(flag);
    }
    return true;
}

function initEvents() {
    var bind_name = 'input';
    var ver = navigator.userAgent;
    if (ver.indexOf("MSIE 6.0") != -1 || ver.indexOf("MSIE 7.0") != -1 || ver.indexOf("MSIE 8.0") != -1) {
        bind_name = 'propertychange';
    }

    $(".accountCode").bind(bind_name, function () {
        var flag = this.parentElement.parentElement.attributes["data-flag"].value;
        validate_1($("#p1_RightBody" + flag + " .accountCode").val().replace(" ", ""), flag);
    });

    $(".username").bind(bind_name, function () {
        var flag = this.parentElement.parentElement.attributes["data-flag"].value;
        validate_2($("#p1_RightBody" + flag + " .username").val().replace(" ", ""), flag);
    });

    $(".password").bind(bind_name, function () {
        var flag = this.parentElement.parentElement.attributes["data-flag"].value;
        validate_3($("#p1_RightBody" + flag + " .password").val().replace(" ", ""), flag);
    });

    $(".varificationCode").bind(bind_name, function () {
        var flag = this.parentElement.parentElement.attributes["data-flag"].value;
        validate_4($("#p1_RightBody" + flag + " .varificationCode").val().replace(" ", ""), flag);
    });

    $(document).delegate(".yzmlogin", 'click', function () {
        $(this).attr('src', '/user/getCheckcodeImg.do?time=' + new Date().getTime());
    });

    $(document).delegate(".registerBtn", 'click', function () {
        location.href = "/login/html/register.jsp";
    });

    $(document).delegate('#login_layer .loginBtn', 'click', function () {
        login({
            'accountCode': $("#p1_RightBody2 .accountCode").val().replace(" ", ""),
            'username': $("#p1_RightBody2 .username").val().replace(" ", ""),
            'password': $("#p1_RightBody2 .password").val().replace(" ", ""),
            'checkcode': $("#p1_RightBody2 .varificationCode").val().replace(" ", ""),
            'rememberMe': $("#rememberMe").is(':checked') === true ? "true" : "false"
        });
    });

    $(".accountCode,.username,.password,.varificationCode").on("keydown", function (e) {
        if (e.keyCode == 13) {
            $(this).closest(".loginBody").find(".loginBtn").click();
        }
    });
}

function loginFirst() {
    layer.open({
        type: 1,
        shade: ['0.25', 'rgb(0,0,0)'],
        title: false,
        content: __webpack_require__(9)(),
        area: ["290px", "350px"],
        cancel: function cancel(index) {
            layer.close(index);
        },
        success: function success(layero, index) {
            initEvents();
        }
    });
}

module.exports = {
    initEvents: initEvents,
    loginFirst: loginFirst
};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(6);

var Util = __webpack_require__(0);

module.exports = {
    run: function run() {
        if (Util.ltIE9()) {
            alert('为了更好的使用体验，请不要使用IE浏览器，谢谢！');
        }
    }
};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!-- 登录模块模板 -->\r\n<div id="login_layer">\r\n	<div id="p1_RightTop">\r\n		<span id="p1_RightTopSpan">会员登录</span>\r\n		<i id="loginTriangle" class="iconfont icon-triangle-down"></i>\r\n	</div>\r\n	\r\n	<div id="p1_RightBody2">\r\n		<form>\r\n			<div class="loginBody" data-flag="2">\r\n				<p id="validateMsg2" class="hidden">* 请输入验证码</p>\r\n				<div class="loginBodyRow">\r\n					<i class="iconfont icon-user"></i>\r\n					<i class="divider"></i>\r\n					<input placeholder="公司账号" title="公司账号" class="accountCode" name="account" />\r\n				</div>\r\n				<div class="loginBodyRow">\r\n					<i class="iconfont icon-user"></i>\r\n					<i class="divider"></i>\r\n					<input placeholder="用户名" title="用户名" class="username" name="username" />\r\n				</div>\r\n				<div class="loginBodyRow">\r\n					<i class="iconfont icon-password"></i>\r\n					<i class="divider"></i>\r\n					<input type="password" placeholder="密码" title="密码" class="password" name="password" />\r\n				</div>\r\n				<div class="loginBodyRow">\r\n					<i class="iconfont icon-varification"></i>\r\n					<i class="divider"></i>\r\n					<input class="varificationCode" />\r\n					<div>\r\n						<img src="/user/getCheckcodeImg.do?time=' +
((__t = ( new Date().getTime() )) == null ? '' : __t) +
'" class="yzmlogin" style="" />\r\n					</div>\r\n				</div>\r\n				<div id="rememberPW">\r\n					<span>\r\n						<input id="rememberMe" type="checkbox" />\r\n						<span>记住我...</span>\r\n					</span>\r\n					<a id="forgetPW" href="/user/password/toForgetPage.do"><span>忘记密码？</span></a>\r\n				</div>\r\n				<div class="loginBodyRow loginBtnGroup">\r\n					<a href="javascript:void(0);" class="registerBtn">注册</a>\r\n					<a href="javascript:void(0);" class="loginBtn submitBtn">登 录</a>\r\n				</div>\r\n			</div>\r\n		</form>\r\n	</div>\r\n</div>';

}
return __p
}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="login-box">\r\n    <form id="loginJl">\r\n        <!--<h2>房掌柜登录</h2>-->\r\n        <ul>\r\n            <li>\r\n                <i class="login-icon login-icon-1"></i>\r\n                <input placeholder="企业编号" id="accountCode" title="企业编号" name="accountCode" autocomplete="off" emptymsg="* 企业编号不能为空" type="text">\r\n            </li>\r\n            <li>\r\n                <i class="login-icon login-icon-2"></i>\r\n                <input placeholder="用户名/手机号/邮箱" id="username" title="用户名/手机号/邮箱" name="username" autocomplete="off" emptymsg="* 用户名不能为空" type="text">\r\n            </li>\r\n            <li>\r\n                <i class="login-icon login-icon-3"></i>\r\n                <input placeholder="密码" id="password" title="密码" name="password" autocomplete="off" emptymsg="* 请输入密码" type="password">\r\n            </li>\r\n            <li class="yzm-box">\r\n                <i class="login-icon login-icon-4"></i>\r\n                <input placeholder="请输入验证码" id="checkcode" title="请输入验证码" name="checkcode" emptymsg="* 请输入验证码" type="text" autocomplete="off">\r\n                <img class="yzm-img" src="/user/getCheckcodeImg.do?time=' +
((__t = (new Date().getTime())) == null ? '' : __t) +
'" alt=""/>\r\n            </li>\r\n        </ul>\r\n        <p class="err-msg"></p>\r\n        <button id="loginIn">登录</button>\r\n        <div class="login-bottom">\r\n            <input id="remberCode" name="rememberMe" type="checkbox" value="true">\r\n            <label for="remberCode">记住账号</label>\r\n            <a class="find-password" href="/user/password/toForgetPage.do">忘记密码？</a>\r\n            <a class="register" href="/user/toRegister.do" target="_blank" data-track="房掌柜首页_登录框_免费注册">免费注册</a>\r\n        </div>\r\n    </form>\r\n</div>';

}
return __p
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(13);
var Util = __webpack_require__(0);
var loginModel = __webpack_require__(3);
var CloseWebPage = __webpack_require__(0).CloseWebPage;

var VACATION_PRODUCT_SESSION_KEY = 'FZG_SHOW_VACATION_PRODUCT';

function applyVacationProductMenu(isShow) {
    if (isShow) {
        $('.vacation-product-menu').show();
    } else {
        $('.vacation-product-menu').hide();
    }
}

function applyVacationProductMenuFromSession() {
    try {
        if (sessionStorage.getItem(VACATION_PRODUCT_SESSION_KEY) === 'true') {
            applyVacationProductMenu(true);
            return true;
        }
    } catch (e) {}
    return false;
}

function toggleVacationProductMenu() {
    if (applyVacationProductMenuFromSession()) {
        return;
    }

    $.post('/myinfo/selectShowVacationProduct.do', {}, function (res) {
        var isShow = res && res.result === true;
        if (isShow) {
            try {
                sessionStorage.setItem(VACATION_PRODUCT_SESSION_KEY, 'true');
            } catch (e) {}
        }
        applyVacationProductMenu(isShow);
    }, 'noAnimation');
}

if (typeof $ !== 'undefined') {
    applyVacationProductMenuFromSession();
}

function getCurUser(pagename) {
    $('.i-t-n-group').find('li[data-module="' + pagename + '"]').attr('checked', 'checked');

    $.post('/user/getCurrentUser.do', {}, function (res) {
        if (res.returnCode == 1) {
            getSales();

            $('.i-t-n-user-wrap').hover(function () {
                $('.i-t-n-user-wrap:hover .i-t-n-drops').css('display', 'none');
            });

            window.hasLoginFzg = 'true';

            var noticeHtml = '\n            <a href="/myinfo/toMyInfoHome.do?index=17" class="link-href-a">\n                <div class="gonggao-icon"></div>\n            </a>\n            ';
            $('.notice-icon-container').append(noticeHtml);

            window.distrbCode = res.data.distributorAccount.distrbCode;
            window.isAdmin = res.data.user.isAdmin;
            if (res.data.temporaryDemand1470) {
                window.temporaryDemand1470 = JSON.parse(res.data.temporaryDemand1470);
            }

            if (window.isAdmin == null) window.isAdmin = 'null';

            $(".i-t-n-user").html(res.data.user.customerUserName).attr('data-distrbid', res.data.distributorAccount.distrbId).attr('data-type', res.data.user.type).attr('data-suppid', res.data.user.suppId).attr('data-isadmin', res.data.user.isAdmin);
            sessionStorage.setItem('login', 'login');

            if (pagename === 'toolDataIn') {
                if (res.data.distributorAccount.distrbCode.toUpperCase() !== 'SZ2747') {
                    alert('您不被允许进入该页面', {
                        closeBtn: 0
                    }, function () {
                        CloseWebPage();
                    });
                }
            } else if (pagename === 'toolOperateHotel') {
                if (res.data.user.isAdmin !== 1) {
                    alert('您不被允许进入该页面', {
                        closeBtn: 0
                    }, function () {
                        CloseWebPage();
                    });
                }
            }

            if (res.data.isFirstLoginAfterRegister) {
                __webpack_require__(14)();
            }
        } else if (res.returnCode == -400001) {
            window.hasLoginFzg = 'false';

            var _noticeHtml = '\n            <div class="gonggao-icon is-link-show"></div>\n            ';
            $('.notice-icon-container').append(_noticeHtml);

            $('.index-concern-order-outer').css('display', 'none');

            $('.need-to-hide-without-login').hide();

            if (pagename === 'index' || pagename === 'register' || pagename === 'noLogin' || pagename === 'hotelList2' || pagename === 'ticket' || pagename === 'groupRoom' || pagename === 'package') {

                $('.i-t-n-triangle').hide();

                $('.i-t-n-user-wrap').hover(function () {
                    $('.i-t-n-user-wrap:hover .i-t-n-drop').css('display', 'none');
                }).click(function () {
                    __webpack_require__(1)();
                });
            } else {
                Util.login();
            }
        }
    }, 'noAnimation');
}

function getSales() {
    $.post('/myinfo/getMyInfo.do', { salesman: 1 }, function (res) {
        if (res.returnCode == 1) {
            var html = '\n                <div class="number-css">\n                    <div class="bold-css">\u4E13\u5C5E\u9500\u552E\u7ECF\u7406\uFF1A</div>\n                </div>\n                <div class="lianxi-all">\n                    <div class="lianxi-ren">\n                        <div class="people-icon"></div>\n                        <div class="concat-over">' + (res.data.salesman.realname || " -") + '</div>\n                    </div>\n                    <div class="lianxi-ren">\n                        <div class="phone-icon"></div>\n                        <div class="concat-over">' + (res.data.salesman.cellphone || " -") + '</div>\n                    </div>\n                    <div class="lianxi-ren">\n                        <div class="email-icon"></div>\n                        <div class="concat-over">' + (res.data.salesman.email || " -") + '</div>\n                    </div>\n                </div>\n            ';
            $(".mySalesMan").append(html);
        } else {}
    }, "noAnimation");
}

function initLogout() {
    $("#logout").on('click', function () {
        var loginoutConfirm = confirm('是否确定退出？', function () {
            $.post('/user/loginoutfzg.do', {}, function (res) {
                if (res && res.returnCode == 1) {
                    $(".i-t-n-user").html("请登录");
                    layer.close(loginoutConfirm);
                    location.reload();
                }
            });
        });
    });
}

function navbarLink() {
    $('.i-t-n-group>li[name="i-t-n-radio"]>a').click(function () {
        if ($(this).attr('data-module') === 'group') {
            __webpack_require__(1)();

            return false;
        }
    });
}

function initClick() {
    $('.i-t-n-drops').click(function (event) {
        window.open("http://en-cn.jl-tour.com/");
        event.stopPropagation();
        event.preventDefault();
    });
}

function clickNoticeIcon() {
    $(document).delegate(".is-link-show", "click", function () {
        layer.msg('请先登录');

        window.setTimeout(function () {
            __webpack_require__(1)();
        }, 1000);
    });
}

module.exports = {
    run: function run(pagename) {
        toggleVacationProductMenu();

        getCurUser(pagename);

        initLogout();

        navbarLink();

        clickNoticeIcon();
    }
};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(15);

module.exports = function (option) {
    var str = __webpack_require__(16)();

    if (!option) {
        layer.open({
            type: 1,
            title: false,

            content: str
        });
    }
};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="prompt-box">\r\n    <div class="prompt-head">\r\n        <h6 class="prompt-title">温馨提示</h6>\r\n    </div>\r\n\r\n    <div class="prompt-content">为避免账户信息泄露， 建议您前往个人中心修改初始密码</div>\r\n\r\n    <button class="jump-btn">\r\n        <a href="/myinfo/toMyInfoHome.do?resetPassword=true">立即修改</a>\r\n    </button>\r\n</div>';

}
return __p
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(21);

var initConcernEvent = function initConcernEvent() {
	var flag = true;

	$('body').delegate('.icon-gz-on', 'click', function (e) {
		var _this = $(this),
		    collectParam = {
			categoryId: 0,
			infoId: _this.data('hotelid')
		},
		    collectUrl = '/fzgCustomerFavorite/removeFavorite.do';

		e.preventDefault();
		e.stopPropagation();
		if (!flag) return;
		flag = false;

		$.post(collectUrl, collectParam, function (data) {
			flag = true;
			if (data.returnCode !== 1) {
				layer.msg(data.returnMsg);
			} else {
				_this.removeClass('icon-gz-on').addClass('icon-gz-off');


				var $iconfont = _this.children('.iconfont');
				var $tips = _this.children('.icon-gz-on-tips');

				if ($iconfont && $tips) {
					$iconfont.removeClass('icon-favorite-fill').addClass('icon-favorite');
					$tips.text('未收藏');
				}
			}
		}, 'noAnimation');
	}).delegate('.icon-gz-off', 'click', function (e) {
		var _this = $(this),
		    collectParam = {
			categoryId: 0,
			infoId: _this.data('hotelid')
		},
		    collectUrl = '/fzgCustomerFavorite/saveFavorite.do';

		e.preventDefault();
		e.stopPropagation();
		if (!flag) return;
		flag = false;

		$.post(collectUrl, collectParam, function (data) {
			flag = true;
			if (data.returnCode !== 1) {
				layer.msg(data.returnMsg);
			} else {
				_this.removeClass('icon-gz-off').addClass('icon-gz-on');


				var $iconfont = _this.children('.iconfont');
				var $tips = _this.children('.icon-gz-on-tips');

				if ($iconfont && $tips) {
					$iconfont.removeClass('icon-favorite').addClass('icon-favorite-fill');
					$tips.text('已收藏');
				}
			}
		}, 'noAnimation');
	});
};

module.exports = initConcernEvent();

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(19);
var sideBarTpl = __webpack_require__(20),
    Util = __webpack_require__(0);

function initSideBarHTML() {

				$('body').append(sideBarTpl({
								concernList: {
												dataList: []
								},
								pageNum: 0
				}));
}

function myConcern() {
				$('body').delegate('.side-item-gz', 'click', function (e) {
								if ($('.sidebar-gz-outer').css('right') === '-336px') {
												$('.sidebar-gz-outer').animate({ right: 0 });
												$('.sidebar-gz-mask').show();
												initConcernShow(1);
								} else {
												$('.sidebar-gz-outer').animate({ right: '-336px' });
												$('.sidebar-gz-mask').hide();
								}
				}).delegate('.sidebar-gz-mask', 'click', function (e) {
								$('.sidebar-gz-outer').animate({ right: '-336px' });
								$('.sidebar-gz-mask').hide();
				}).delegate('.sidebar-gz-outer', 'click', function (e) {
								return false;
				}).delegate('.sidebar-hotel-link', 'click', function () {
								$(this).attr('href') ? window.open($(this).attr('href')) : alert('该酒店已删除');
				}).delegate('.side-bar-item[data-rank]', 'mouseenter', function () {
								$('.side-content>li').eq($(this).data('rank')).removeClass('sidebar-hidden');
				}).delegate('.side-bar-item[data-rank]', 'mouseleave', function () {
								$('.side-content>li').eq($(this).data('rank')).addClass('sidebar-hidden');
				});
}

function initConcernShow(pageNum) {
				var params = {
								categoryId: 0,
								pageNum: pageNum,
								pageSize: 8
				};

				$.post('/fzgCustomerFavorite/getMyFavoriteList.do', params, function (data) {
								if (data.returnCode === 1) {
												var concernStr = sideBarTpl({
																concernList: data,
																pageNum: pageNum
												});

												$(concernStr).replaceAll('.side-bar-wrap');
												$('.sidebar-gz-outer').css({ 'right': 0 });
												$('.sidebar-gz-mask').show();
								}

								getReallyPrice(data);
				}, 'noAnimation');
}

function initConcernHide() {
				$('body').delegate('.sidebar-gz-icon-hide', 'click', function () {
								$('.sidebar-gz-outer').animate({ right: '-336px' }, function () {});

								$('.sidebar-gz-mask').hide();
				});
}

function getMoreConcern() {
				$('body').delegate('.sidebar-get-more', 'click', function () {
								var pageNum = +$('.side-item-gz').data('page') + 1;

								var params = {
												categoryId: 0,
												pageNum: pageNum,
												pageSize: 8
								};

								$.post('/fzgCustomerFavorite/getMyFavoriteList.do', params, function (data) {
												if (data.returnCode === 1) {
																var concernStr = '';
																for (var i = 0; i < data.dataList.length; i++) {
																				var item = data.dataList[i];

																				if (item.hasOwnProperty('infoName') && item.infoName !== '' && item.infoName !== undefined && item.infoName !== null) {

																								concernStr += '<li class="sidebar-gz-item" data-hotelid="' + item.infoId + '">' + '<a href="' + item.detailLink + '" class="sidebar-hotel-link">' + '<div class="sidebar-gz-content-wrap">' + '<div class="sidebar-gz-img">' + '<img src="' + (item.picSrc === '/common/images/nopic.png' ? 'https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1560999493874.png' : item.picSrc) + '" alt="">' + '</div>' + '<div class="sidebar-gz-info">' + '<p class="sidebar-gz-hotel-name">' + item.infoName + '</p>' + '<p class="sidebar-gz-hotel-price">' + (item.minPrice ? '￥' + item.minPrice + '起' : '加载中<img src="https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1520825964429.gif" class="price-loading" alt="">') + '</p>' + '<i class="sidebar-gz-icon icon-gz-on"></i>' + '</div>' + '</div>' + '</a>' + '</li>';
																				}
																}

																$('.side-item-gz').data('page', pageNum);
																$(concernStr).insertBefore('.sidebar-get-more');
																if (data.pageTotal <= pageNum) {
																				$('.sidebar-get-more').remove();
																				$('.sidebar-gz-list').append('<li class="sidebar-no-more">没有更多了</li>');
																}

																getReallyPrice(data);
												}
								}, 'noAnimation');
				});
}

function getReallyPrice(data) {
				var listArr = data.dataList;
				if (listArr !== undefined) {
								for (var i = 0; i < listArr.length; i++) {
												var o = listArr[i];
												if (!o.hasOwnProperty('minPrice') || +o.minPrice === 0) {
																if (o.hasOwnProperty('detailLink')) {
																				(function () {
																								var param = {
																												hotelId: o.infoId,
																												checkInDate: Util.addDays(new Date(), 0),
																												checkOutDate: Util.addDays(new Date(), 1),
																												roomNum: 1,
																												adultNum: 2,
																												childrenNum: 0,
																												childrenAgesStr: ''
																								};

																								$.post('/hotel/getHotelPriceList.do', param, function (data) {
																												if (data.returnCode === 1) {
																																if (data.data.hasOwnProperty('priceMin') && data.data.priceMin !== 0) {
																																				$('.sidebar-gz-list>.sidebar-gz-item[data-hotelid="' + param.hotelId + '"]').find('.sidebar-gz-hotel-price').html('￥' + data.data.priceMin + '起');
																																} else {
																																				$('.sidebar-gz-list>.sidebar-gz-item[data-hotelid="' + param.hotelId + '"]').find('.sidebar-gz-hotel-price').html('暂无价格');
																																}
																												} else {
																																$('.sidebar-gz-list>.sidebar-gz-item[data-hotelid="' + param.hotelId + '"]').find('.sidebar-gz-hotel-price').html('暂无价格');
																												}
																								}, 'noAnimation');
																				})();
																}
												}
								}
				}
}

window.addEventListener("scroll", function (e) {
				var scrollDistance = window.scrollY;
				if (scrollDistance > 400) {
								$('.to-page-top').css('height', '83px');
				} else {
								$('.to-page-top').css('height', '0');
				}
});

window.onresize = function () {
				var pageWidth = window.innerWidth;
				if (pageWidth < 1400) {
								$(".side-bar-wrap").css("display", "none");
				} else {
								$(".side-bar-wrap").css("display", "block");
				}
};

function getPageWidth() {
				var pageWidth = window.innerWidth;
				if (pageWidth < 1400) {
								$(".side-bar-wrap").css("display", "none");
				} else {
								$(".side-bar-wrap").css("display", "block");
				}
}

function initUpBtnClick() {
				$('body').delegate('.to-page-top', 'click', function () {
								$('html,body').animate({
												scrollTop: 0
								}, 100);
				});
}

module.exports = {
				run: function run() {
								initSideBarHTML();

								myConcern();

								getMoreConcern();

								initConcernHide();

								initUpBtnClick();

								getPageWidth();

								__webpack_require__(17);
				}
};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\r\n<!-- 侧边栏模板 -->\r\n<section class="side-bar-wrap">\r\n    <div class="side-bar-c-b">\r\n        <ul class="side-bar-group">\r\n            <li class="side-bar-item side-item-gz" data-page="' +
((__t = ( pageNum )) == null ? '' : __t) +
'">\r\n                <div class="side-bar-inner sidebar-gz"></div>\r\n            </li>\r\n            <li class="side-bar-item" data-rank="1">\r\n                <div class="side-bar-inner sidebar-wxdf"></div>\r\n                <!--<div class="sidebar-erweima-outer">-->\r\n                    <!--<div class="sidebar-erweima"></div>-->\r\n                <!--</div>-->\r\n            </li>\r\n\r\n            <li class="side-bar-item concact-all">\r\n                <div class="side-bar-inner contact-me"></div>\r\n                <div class="sidebar-kefu-outer">\r\n                    客服电话（7×24小时）：0755-32904551；备用电话：021-31264898、021-31264890\r\n                </div>\r\n            </li>\r\n\r\n            <li class="side-bar-item to-page-top" data-track="公共_侧边栏_返回顶部">\r\n                <div class="side-bar-inner sidebar-up"></div>\r\n            </li>\r\n        </ul>\r\n\r\n    </div>\r\n\r\n    <ul class="side-content">\r\n        <li>\r\n            <div class="sidebar-gz-outer">\r\n                <div class="sidebar-gz-inner">\r\n                    <div class="sidebar-gz-title">\r\n                        <h1>我的关注</h1>\r\n                        <i class="sidebar-gz-icon-hide"></i>\r\n                    </div>\r\n\r\n                    ';
 if (concernList.dataList.length <= 0 ){ ;
__p += '\r\n                    <div class="sidebar-gz-no-content"></div>\r\n                    ';
 }else{ ;
__p += '\r\n\r\n                    <ul class="sidebar-gz-list">\r\n                        ';

                        for(var i = 0;i < concernList.dataList.length; i++){
                            var o = concernList.dataList[i];
                        ;
__p += '\r\n                        <li class="sidebar-gz-item" data-hotelid="' +
((__t = ( o.infoId )) == null ? '' : __t) +
'">\r\n                            <a href="' +
((__t = ( o.detailLink )) == null ? '' : __t) +
'" class="sidebar-hotel-link">\r\n                                <div class="sidebar-gz-content-wrap">\r\n                                    <div class="sidebar-gz-img">\r\n                                        <img src="' +
((__t = ( o.picSrc === '/common/images/nopic.png' ? 'https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1560999493874.png' : o.picSrc )) == null ? '' : __t) +
'" alt="">\r\n                                    </div>\r\n                                    <div class="sidebar-gz-info">\r\n                                        <p class="sidebar-gz-hotel-name">' +
((__t = ( o.infoName )) == null ? '' : __t) +
'</p>\r\n                                        <p class="sidebar-gz-hotel-price">' +
((__t = ( o.minPrice ? '￥' + o.minPrice + '起' : '加载中<img src="https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1520825964429.gif" class="price-loading" alt="">' )) == null ? '' : __t) +
'</p>\r\n                                        <i class="sidebar-gz-icon icon-gz-on" data-hotelid="' +
((__t = ( o.infoId )) == null ? '' : __t) +
'"></i>\r\n                                    </div>\r\n                                </div>\r\n                            </a>\r\n                        </li>\r\n                        ';
 } ;
__p += '\r\n\r\n                        ';
 if (concernList.pageTotal > 1 ){ ;
__p += '\r\n                        <li class="sidebar-get-more">\r\n                            加载更多\r\n                            <i class="get-more-gz"></i>\r\n                        </li>\r\n                        ';
 } ;
__p += '\r\n                    </ul>\r\n                    ';
 } ;
__p += '\r\n                </div>\r\n            </div>\r\n            <!-- 遮罩 -->\r\n            <div class="sidebar-gz-mask"></div>\r\n        </li>\r\n        <li class="sidebar-hidden">\r\n            <div class="sidebar-erweima-outer">\r\n                <div class="sidebar-erweima"></div>\r\n            </div>\r\n        </li>\r\n        <li></li>\r\n    </ul>\r\n</section>\r\n';

}
return __p
}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(32);

module.exports = function (options) {

	var event = window.event || arguments.callee.caller.arguments[0];

	if (!options) {
		options = {
			target: event.target || event.srcElement
		};
	}

	if (!options.target) {
		options.target = event.target || event.srcElement;
	}

	if (options.target.tagName === 'I') {
		options.target = $(options.target).prev('*')[0];
	}

	var target = options.target;
	if (!target.mySelect) {
		target.mySelect = __webpack_require__(25)(options);
	}

	if (options.reload) {
		target.mySelect.remove();
		target.mySelect = __webpack_require__(25)(options);
	} else {
			if (target.mySelect.element.closest('.my-select-list').css('display') != 'none') {
				target.mySelect.hide();
			} else {
				target.mySelect.show();
			}
		}
};

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


var queryString = __webpack_require__(0).queryString;

var addDays = __webpack_require__(0).addDays;
var sortFnc = __webpack_require__(73).invokeAPIs;

function isHotelOnline(callback) {
    var checkParams = {
        suppId: queryString('suppId'),
        infoId: queryString('infoId')
    };

    $.post('/ticketController/check.do', checkParams, function (data) {
        callback(data);
    });
}

function getInitData(comfirmDay, params, callback) {
    var checkParams = {
        carType: params.carType,
        isRealName: params.isRealName,
        validDate: comfirmDay,
        ticketRangeId: params.ticketRangeId,
        stockId: params.stockId,
        formulaType: params.formulaType,
        paymentType: params.paymentType,
        priceType: params.priceType,
        ticketType: params.ticketType,
        suppName: params.suppName,
        suppId: params.suppId,
        itemId: params.itemId,
        infoId: params.infoId
    };
    $.post('/ticketController/orderFit.do', checkParams, function (data) {
        callback(data);
    });
}

function getCanlendarPrice(days, callback) {

    var params = {
        ticketRangeId: queryString('ticketRangeId'),

        priceType: queryString('priceType'),
        paymentType: queryString('paymentType'),
        itemId: queryString('itemId'),
        formulaType: queryString('formulaType'),
        startDateStr: addDays(days, 0, '-'),
        endDateStr: addDays(days, 30, '-'),
        ticketType: queryString('ticketType')
    };

    $.post('/ticketController/searcCalendarPrice.do', params, function (res) {
        callback(res);
    });
}

function getOrderDec(params, callback) {
    $.post('/ticketController/findTicketRemmind.do', params, function (res) {
        callback(res);
    });
}

function getNationalMsg(key, callback) {
    $.post('/order/countrySuggest.do', { 'key': key }, function (data) {
        callback(data);
    });
}

function isProperMarket(countryId, callback) {
    $.get('/order/properMarket.do', { 'suppId': queryString('supplierId'), 'countryId': countryId }, function (data) {
        callback(data);
    });
}

function checkThePrice(params, callback) {
    var paramsSer = $.param(params);
    $.ajax({
        type: 'POST',
        url: '/ticketController/orderSave.do',
        data: params,
        dataType: 'json',
        success: callback
    });
}

function saveOrder(params, callback) {
    $.post('/order/saveOrder.do', params, function (data) {
        callback(data);
    });
}

function loadBBN(cb, flag) {
    var params = {
        startDate: queryString('startDate'),
        endDate: queryString('endDate'),
        infoId: queryString('staticInfoId'),
        suppId: queryString('supplierId'),
        roomtypeId: queryString('roomId'),
        roomNum: queryString('roomNum'),
        typeId: flag
    };

    $.post('/order/surchargeRoom.do', params, function (res) {
        cb(res);
    });
}

function renderBBN(context, htmlStr, option) {
    if (!$.orderInfo) {
        return setTimeout(function () {
            renderBBN(context, htmlStr, option);
        }, 100);
    }

    $('.main').find(context).show().html(htmlStr);

    if (option) {
        option.cb(option.params);
    }
}

module.exports = {
    isHotelOnline: isHotelOnline,
    getCanlendarPrice: getCanlendarPrice,
    getInitData: getInitData,
    getOrderDec: getOrderDec,
    getNationalMsg: getNationalMsg,
    isProperMarket: isProperMarket,
    checkThePrice: checkThePrice,
    saveOrder: saveOrder,
    loadBBN: loadBBN,
    renderBBN: renderBBN
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {



var addDays = __webpack_require__(0).addDays,
    mySelectPanel = __webpack_require__(33),
    _default = {
    show: function show() {
        this.setPos();

        var element = this.element;
        setTimeout(function () {
            element.show();
        }, 10);
    },
    hide: function hide() {
        this.element.find('.selected-flag').addClass('selected').removeClass('selected-flag');
        this.element.hide();
    },
    remove: function remove() {
        this.element.remove();
    },
    setPos: function setPos() {
        var target = this.target,
            parent = $(target).parent(),
            targetRect = parent[0].getBoundingClientRect(),
            left = targetRect.left + (this.left || 0) + $(document).scrollLeft(),
            top = targetRect.bottom + 2 + (this.top || 0) + $(document).scrollTop(),
            width = this.width || targetRect.width || parent[0].scrollWidth,
            widthBorder = document.body.scrollWidth - 180;

        this.element.css('left', left > widthBorder ? widthBorder : left).css('top', top).css('width', width).css('display', 'none');
    },
    starVal: '',

    setSelectVal: function setSelectVal(_this) {
        if (!_this.hasClass('selected') && !_this.hasClass('selected-flag')) {
            var parent = _this.closest('.my-select-list'),
                target = $(this.target),
                newVal = _this.attr('data-value'),
                newText = _this.text();

            parent.find('.selected').removeClass('selected');
            parent.find('.selected-flag').removeClass('selected-flag');
            _this.addClass('selected');
            target.attr('data-value', newVal);

            this.target.tagName == 'INPUT' ? target.val(newText) : target.html(newText);

            $(this.target).trigger('change');
        }

        this.hide();
    }
},
    initEvents = function initEvents(mySelect, options) {
    var element = mySelect.element;
    $(document).on('mousedown', function (e) {
        var event = window.event || e,
            target = event.target || event.srcElement,
            isScrollBar = target.tagName === 'HTML' || !target.tagName;

        if (!$(target).closest('.my-select-list').length && target !== mySelect.target && !isScrollBar) {
            mySelect.hide();
        }
    });

    element.on('mouseover', function () {
        mySelect.element.find('.selected').addClass('selected-flag').removeClass('selected');
    });

    element.find('li').on('click', function () {
        mySelect.setSelectVal($(this));

        options.fn && options.fn($(this).attr('data-value'));
    });
},
    setDefaultSelect = function setDefaultSelect(options, element) {
    var _thisVal = $(options.target).attr('data-value');

    if (_thisVal) {
        var liArr = element.find('li');
        for (var i = 0; i < liArr.length; i++) {
            var li = $(liArr[i]);
            if (li.attr('data-value') === _thisVal) {
                li.addClass('selected');
            }
        }
    }
},
    selectFactory = function selectFactory(options) {

    var element = $(mySelectPanel({
        options: options.options
    }));

    setDefaultSelect(options, element);

    var mySelect = $.extend({}, _default, options);
    mySelect.element = element;
    mySelect.setPos();

    if (options.addClassName) {
        element.addClass(options.addClassName);
    }
    $("body").append(element);

    return mySelect;
};

module.exports = function (options) {
    var mySelect = selectFactory(options);

    initEvents(mySelect, options);

    mySelect.show();

    return mySelect;
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


function getDaysForeachMonth(year) {
	return new Array(31, _leap(year), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
}

function _leap(year) {
	return 28 + (year % 4 == 0 && year % 100 != 0 || year % 400 == 0 ? 1 : 0);
}

function oneDayTime() {
	return 24 * 60 * 60 * 1000;
}

function getOneMonthHTML(y, m, dayCount) {

	var firstDay = new Date(y + '/' + m + '/1'),
	    daysPrev = firstDay.getDay() || 7,
	    firstDayTime = firstDay.getTime() - daysPrev * oneDayTime(),
	    daysAfter = 42 - daysPrev - dayCount,
	    i,
	    tdArr = [],
	    monthStr = y + '/' + m,
	    headStr = y + '年' + m + '月',
	    bodyStr = '',
	    oneMonthTemplate = __webpack_require__(37);

	for (i = 0; i < 42; i++) {
		var dayStr = new Date(firstDayTime + i * oneDayTime()).Format('yyyy/MM/dd'),
		    isValidDay = daysPrev <= i && i < 42 - daysAfter,
		    isWeekend = i % 7 === 0 || i % 7 === 6;

		tdArr.push({
			dayStr: dayStr,
			isValidDay: isValidDay,
			isWeekend: isWeekend
		});
	}

	return oneMonthTemplate({
		month: monthStr,
		head: headStr,
		tdArr: tdArr
	});
}

function buildMonths(y, m) {

	var today = new Date(),
	    thisYear = y || today.getFullYear(),
	    thisMonth = today.getMonth(),
	    dayArr = getDaysForeachMonth(thisYear);

	if (y && m) {
		return getOneMonthHTML(y, m, dayArr[m - 1]);
	} else {
		var monthStr1 = getOneMonthHTML(thisYear, thisMonth + 1, dayArr[thisMonth]),
		    monthStr2 = thisMonth == 11 ? getOneMonthHTML(thisYear + 1, 1, 31) : getOneMonthHTML(thisYear, thisMonth + 2, dayArr[thisMonth + 1]);

		return monthStr1 + monthStr2;
	}
}

module.exports = function (y, m) {
	return buildMonths(y, m);
};

/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(34);

module.exports = function (options) {

	var event = window.event || arguments.callee.caller.arguments[0];

	if (!options) {
		options = {
			target: event.target || event.srcElement
		};
	}

	if (!options.target) {
		options.target = event.target || event.srcElement;
	}

	var target = options.target;
	if (!target.myCalendar) {
		target.myCalendar = __webpack_require__(35)(options);
	} else {
			target.myCalendar.show();
		}
};

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {


var queryString = __webpack_require__(0).queryString;

function changeToPage() {
	var infoId = queryString('infoId'),
	    ch = queryString('ch');

	var url = '/ticketController/toTicketDetail.do?ticketInfoId=' + infoId + '&ch=' + ch;

	window.location.href = url;
}

function CloseWebPage() {
	if (navigator.userAgent.indexOf("MSIE") > 0) {
		if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
			window.opener = null;
			window.close();
		} else {
			window.open('', '_top');
			window.top.close();
		}
	} else if (navigator.userAgent.indexOf("Firefox") > 0) {
		window.location.href = 'about:blank ';
	} else {
		window.opener = null;
		window.open('', '_self', '');
		window.close();
	}
}

module.exports = {
	changeToPage: changeToPage,
	CloseWebPage: CloseWebPage
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


var getOrderDec = __webpack_require__(24).getOrderDec;
var orderNeedKnow = __webpack_require__(58);
var ticketCalendarPrice = __webpack_require__(74).run;

var write = $.orderInfo;

var InitValidator = __webpack_require__(75);

var isComplete = __webpack_require__(76);

function ticketNumAdd() {
    $('.t-o-c-number-add').click(function () {
        var nums = $('#ticketNum').val();
        $('#ticketNum').val(parseInt(nums) + 1);
        ticketTotalMoney(true);
        addUserInfoInput(true);
        changeIdType();
    });
}

function ticketNumDic() {
    $('.t-o-c-number-decrease').click(function () {
        var nums = $('#ticketNum').val();
        $('#ticketNum').val(parseInt(nums) - 1);
        ticketTotalMoney(true);
        addUserInfoInput();
        changeIdType();
    });
}

function ticketNumChange() {
    $(document).delegate('#ticketNum', 'blur', function () {
        ticketTotalMoney(true);
    });
}

function ticketTotalMoney(add) {
    ticketLimit(add);
    var nums = $('#ticketNum').val();
    var price = $('.t-o-c-price').text().substr(1);

    var balance = $.orderInfo.data.distributorAccount.balance;
    var totalMoney = parseInt(nums) * Number(price);
    $('#usePerPayment').val(balance >= totalMoney ? totalMoney : balance);

    $('.theTotalMoney').text(isNaN(totalMoney) ? '输入错误' : totalMoney.toFixed(2));
    $('.theTotalNums').text(isNaN(parseInt(nums)) ? '' : '(' + nums + '\u5F20)');
    var str = $.orderInfo.data.ticketPriceModel.clauseDescShow;
    $('.cancelRule').text(str);
}

function ticketLimit(add) {
    var nums = parseInt($('#ticketNum').val());
    var numMin = parseInt($.orderInfo.data.minStockCount) || 1;
    var numMax = parseInt($.orderInfo.data.maxStockCount) || 20;

    $('#ticketNum').val(numMin);
    if (numMin || numMax) {
        if (nums < numMin) {
            $('#ticketNum').val(numMin);
            if (add) {
                layer.open({
                    title: '提示',
                    content: '门票数量最少选择' + numMin + '张'
                });
            }
        } else if (nums > numMax) {
            $('#ticketNum').val(numMax);
            if (add) {
                layer.open({
                    title: '提示',
                    content: '门票数量最多选择' + numMax + '张'
                });
            }
        } else if (nums <= numMax && nums >= numMin) {
            $('#ticketNum').val(nums);
        } else {
            console.log(nums);
            if (nums == 0) {
                $('#ticketNum').val(1);
            } else if (nums < 0) {
                $('#ticketNum').val(1);
            } else if (nums > 20) {
                $('#ticketNum').val(20);
            }
        }
    }
}

function addUserInfoInput(add) {
    var data = $.orderInfo.data;
    console.log(data);
    if (data.isRealName !== 1) {
        return;
    }

    var calcNum = 1;
    if (data.isRealNameNum) {
        calcNum = data.isRealNameNum.split('_').reduce(function (total, cur) {
            return Number(total) + Number(cur);
        });
    }
    var manPerTicket = calcNum > 0 ? calcNum : 1;

    var ticketNumInfo = $('#ticketNum').val() * manPerTicket;
    var ticketTotalNum = $('.t-o-c-ticket-userinfo').find('.ticketUserInfoDetail').length;

    if (add) {
        for (var j = 0; j < ticketNumInfo - ticketTotalNum; j++) {
            var copyParent = $('.ticketUserInfoDetail').eq(0);
            var copyChild = copyParent.clone();

            copyChild.find(".inputCardId").attr('name', 'voucherCard');

            copyChild.find('input').each(function (i, e) {
                $(e).val('');
            });
            copyParent.after(copyChild);
            $('.ticketUserInfoTitle').each(function (i, e) {
                $(e).find('.touristIndex').html('\u6E38\u5BA2' + (i + 1));
            });
        }
    } else {
        for (var i = 0; i < ticketTotalNum - ticketNumInfo; i++) {
            $('.ticketUserInfoDetail').last().remove();
        }
    }
}

function ticketUserInfoDetail() {
    $('.useUserInfoBtn').click(function () {
        if ($('.useUserInfo').prop('checked')) {
            var name = $('.t-o-c-userFirstName').val().trim() + $('.t-o-c-userLastName').val().trim();
            var tel = $('.ticketTel').val();
            var mail = $('.ticketMail').val();
            $('.connectionName').val(name);
            $('.connectionTel').val(tel);
            $('.connectionMail').val(mail);
        } else {
            $('.connectionName').val('');
            $('.connectionTel').val('');
            $('.connectionMail').val('');
        }
    });
}

function removeUserInfo() {
    $(document).delegate('.removeUserInfo', 'click', function (e) {
        $(e.target).parent().parent().remove();
    });
}

function changePayMethod() {
    $('#balance-way').change(function () {

        var method = $(this).find('option[value = ' + this.value + ']').text().trim();
        $(this).attr('data-method', method);
    });
}

function ticketOrderInfo() {
    $(document).undelegate('.t-o-c-button', 'click').delegate('.t-o-c-button', 'click', function (e) {
        var _this = $(this);
        var params = {};
        if ($.orderInfo) {
            params.ticketTypeId = $.orderInfo.data.ticketPriceModel.ticketType;
            params.rateTypeId = $.orderInfo.data.ticketPriceModel.priceType;
            params.ticketRangeId = $.orderInfo.data.ticketPriceModel.ticketRangeId;
        } else {
            params.ticketTypeId = _this.parent().parent().find('.jump-order-btn').attr('data-tickettype');
            params.rateTypeId = _this.parent().parent().find('.jump-order-btn').attr('data-pricetype');
            params.ticketRangeId = _this.parent().parent().find('.jump-order-btn').attr('data-ticketrangeid');
        }

        getOrderDec(params, function (res) {
            if (res.returnCode === 1) {
                if (res.data) {
                    res.data.pickTime ? res.data.pickTime : res.data.pickTime = '';
                    res.data.pointAdress ? res.data.pointAdress : res.data.pointAdress = '';
                    res.data.effectiveDesc ? res.data.effectiveDesc : res.data.effectiveDesc = '';
                    res.data.pickMode ? res.data.pickMode = res.data.pickMode.replace(/[\u9a74\u5988\u5988]{3}/, '') : '';
                    res.data.pointAdress ? res.data.pointAdress = res.data.pointAdress.replace(/[\u9a74\u5988\u5988]{3}/, '') : '';
                    res.data.remark ? res.data.remark = res.data.remark.replace(/[\u9a74\u5988\u5988]{3}/, '') : '';

                    layer.open({
                        type: 1,
                        area: ['860px'],
                        title: '购买详情须知',
                        content: orderNeedKnow(res.data),
                        skin: 'alert-content',
                        maxHeight: '700px',
                        scrollbar: false
                    });
                    $('.importantNotice').html(res.data.remark);
                    $('.t-o-c-pop').parent().css({ 'overflow-y': 'scroll' });
                } else {
                    alert('暂无详情');
                }
            } else {
                alert(res.errinfo);
            }
        });
    });
}

function changeConfirmWay() {
    $('.other-confirm-way').click(function () {
        var confirmWay = $(this).attr('confirm-way');
        var confirmId = '#' + $(this).attr('confirm-way');

        $('.confirm-way-msg li input').val('').siblings('i').hide();

        $('.confirm-way-msg').find(confirmId).val(write.content.distributor[confirmWay]).siblings('i').show();

        $('input[name^=voucher]').each(function (i, n) {
            $(n).rules('remove', 'required');

            if ($(n).hasClass('usingPlaceHolder')) {
                n.value = '';
            }

            $(n).focus();
            $(n).blur();
        });

        $(confirmId).rules('add', {
            required: true, messages: {
                required: $(confirmId).attr('title') + '不能为空'
            }
        });
    });
}

function validateTheSame() {
    $('.guest').on('keyup blur', 'input', function () {
        if ($(this).closest('.guest').find('input').val()) {
            $(this).closest('.guest').find('input').valid();
        } else {
            $(this).closest('.guest').find('input').valid(false);
        }
    });
}

function validateConnection() {
    var _this2 = this;

    $('.useUserInfo').change(function () {
        if ($(_this2).prop('checked') == true) {
            $(_this2).closest('.t-o-c-ticket-connection').find('.warning-txt').each(function (i, e) {
                $(e).hide();
            });
        }
    });
}

function limitPerPayment() {
    $('#usePerPayment').keyup(function () {
        var totalPayment = Number($('.theTotalMoney').text());

        var maxPayment = $.orderInfo.data.distributorAccount.balance > totalPayment ? totalPayment : $.orderInfo.data.distributorAccount.balance;

        var payMent = +$(this).val();

        if (payMent > maxPayment) {
            $('#usePerPayment').rules('add', { max: maxPayment });
            $('#usePerPayment').valid();
        }
    });
}

function customerCode() {
    $('input[name="customerOrderCode"]').keyup(function () {
        $(this).valid();
    });
}

function changeIdType() {
    $('.cardTypeChosse').each(function (i, e) {
        $(e).on("change", function () {
            var $info = $(this).closest(".confirm-way-msg").find("#cardIdInfo");

            if ($(this).val() === '1') {
                $info.attr('name', 'voucherCard');
            } else {
                $info.attr('name', 'voucherOtherCard');
            }
        });
    });
}

module.exports = {
    run: function run() {
        ticketTotalMoney();
        ticketNumAdd();
        ticketNumDic();
        ticketNumChange();
        ticketCalendarPrice();

        addUserInfoInput(true);
        removeUserInfo();
        ticketUserInfoDetail();

        changeIdType();

        changePayMethod();

        ticketOrderInfo();

        InitValidator();

        validateTheSame();

        changeConfirmWay();

        limitPerPayment();

        isComplete();

        customerCode();
    },
    validateTheSame: validateTheSame,
    ticketTotalMoney: ticketTotalMoney,
    ticketOrderInfo: ticketOrderInfo
};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!-- 自定义 select 面板 -->\r\n<ul class="my-select-list">\r\n    ';
 for(var i = 0; i < options.length; i++){ var option = options[i]; ;
__p += '\r\n    <li data-value="' +
((__t = ( option.value )) == null ? '' : __t) +
'" class="' +
((__t = ( option.attr )) == null ? '' : __t) +
'" >' +
((__t = ( option.text )) == null ? '' : __t) +
'</li>\r\n    ';
 } ;
__p += '\r\n</ul>';

}
return __p
}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(36);

var Util = __webpack_require__(0),
    addDays = Util.addDays,
    monthStr = __webpack_require__(26)(),
    calendarPanel = __webpack_require__(38),
    buildMonths = __webpack_require__(26),
    _default = {
    setPos: function setPos() {
        var target = this.target,
            targetRect = target.getBoundingClientRect(),
            left = targetRect.left + (this.left || 0) + $(document).scrollLeft(),
            top = targetRect.bottom + 2 + (this.top || 0) + $(document).scrollTop(),
            widthBorder = document.body.scrollWidth - 745;

        this.element.css('left', left > widthBorder ? widthBorder : left).css('top', top).css('display', 'none');
    },

    show: function show() {
        this.setPos();
        this.element.show();
        this.element.removeClass('fixed');
    },

    hide: function hide() {
        if (this.target.value.length == 13) {
            var checkin = this.target.value.split(' - ')[0];
            var checkout = addDays(checkin, 1, '/');
            this.target.value += checkout;
            $(this.target).trigger('datePicked');
        }
        this.element.hide('fast');
    },

    initCheckinCheckout: function initCheckinCheckout() {
        if (!this.target.checkin) {
            this.cityType == 3 ? (this.target.checkin = addDays(new Date(), 1, '/'), this.target.checkout = addDays(new Date(), 2, '/')) : (this.target.checkin = addDays(new Date(), 0, '/'), this.target.checkout = addDays(new Date(), 1, '/'));
        }

        var tds = this.element.find('.calendar-td-inner');

        for (var i = 0; i < tds.length; i++) {
            var o = $(tds[i]),
                dateStr = Util.formatOne(o.attr('data-day'));

            if (!o.hasClass('day-grayed')) {
                if (dateStr === this.target.checkin) {
                    o.addClass('checkin');
                } else if (dateStr === this.target.checkout) {
                    o.addClass('checkout');
                }
            }
        }

        this.setCheckBetween(this.element, tds);
    },

    setTargetText: function setTargetText(v1, v2) {
        this.target.value = (v1 || '') + ' - ' + (v2 || '');
        this.target.checkin = v1;
        this.target.checkout = v2 ? v2 : null;
    },

    setTmpGray: function setTmpGray() {

        var checkin = this.target.checkin;
        var checkout = this.target.checkout;

        if (checkin && !checkout) {

            var dayArr = this.element.find('.calendar-td-inner');
            var lastValidDay = new Date(addDays(checkin, this.validDays, '/') + ' 23:59:59');

            dayArr.removeClass('tmp-grayed');

            for (var i = 0; i < dayArr.length; i++) {
                var _date = new Date($(dayArr[i]).attr('data-day'));
                if (lastValidDay < _date) {
                    $(dayArr[i]).addClass('tmp-grayed');
                }
            }
        }
    },

    dayClick: function dayClick(_this) {

        if (_this.hasClass('day-grayed') || _this.hasClass('tmp-grayed')) return;

        var cal = this.element,
            thisDayStr = _this.attr('data-day'),
            dayArr = cal.find('.calendar-td-inner'),
            checkin = $($.grep(dayArr, function (o) {
            return $(o).hasClass('checkin');
        })),
            checkout = $($.grep(dayArr, function (o) {
            return $(o).hasClass('checkout');
        })),
            checkBetween = $($.grep(dayArr, function (o) {
            return $(o).hasClass('between-check');
        }));

        if (!checkin.length) {
            _this.addClass('checkin');
            this.setTargetText(thisDayStr);
            this.setTmpGray();
        } else if (checkin.length && !checkout.length) {

                if (_this.hasClass('checkin')) return;

                if (new Date(thisDayStr + ' 23:59:59') < new Date(checkin.attr('data-day'))) {
                    checkin.removeClass('checkin');
                    _this.addClass('checkin');
                    this.setTargetText(thisDayStr);
                    this.setTmpGray();
                } else {
                    _this.addClass('checkout');
                    this.setCheckBetween(cal, dayArr);
                    dayArr.removeClass('tmp-grayed');
                    this.setTargetText(checkin.attr('data-day'), thisDayStr);
                    this.hide();
                    $(this.target).trigger('datePicked');
                }
            } else {
                    checkin.removeClass('checkin');
                    checkout.removeClass('checkout');
                    checkBetween.removeClass('between-check');
                    _this.addClass('checkin');
                    this.setTargetText(thisDayStr);
                    this.setTmpGray();
                }
    },

    dayPicked: function dayPicked() {},

    setCheckBetween: function setCheckBetween(target, dayArr) {

        var checkin = +new Date(target.find('.checkin').attr('data-day') + ' 00:00:00'),
            checkout = +new Date(target.find('.checkout').attr('data-day') + ' 23:59:59');

        for (var i = 0; i < dayArr.length; i++) {
            var o = dayArr[i],
                oTime = +new Date($(o).attr('data-day'));

            if (checkin <= oTime && oTime <= checkout && !$(o).hasClass('day-grayed')) {
                $(o).addClass('between-check');
            }
        }
    },

    switchLeft: function switchLeft(options) {
        var cal = this.element,
            currentMonthArr = cal.find('.calendar-one-month-wrap.current'),
            hiddenAhead = $(currentMonthArr[0]).prevAll('.calendar-one-month-wrap.hidden');

        if (options.allDate || options.minDate) {
            if (hiddenAhead.length) {
                $(currentMonthArr[1]).removeClass('current').addClass('hidden');
            } else {
                var headMonthStr = $(currentMonthArr[0]).attr('data-month'),
                    cYear = +headMonthStr.split('/')[0],
                    cMonth = +headMonthStr.split('/')[1],
                    newMonthDom = cMonth == 1 ? $(buildMonths(cYear - 1, 12)) : $(buildMonths(cYear, cMonth - 1));

                if (options.minDate) {
                    var newMonthDays = newMonthDom.find('.calendar-td-inner');
                    for (var i = 0; i < newMonthDays.length; i++) {
                        var _date = new Date($(newMonthDays[i]).attr('data-day'));
                        if (new Date(options.minDate) > _date) {
                            $(newMonthDays[i]).addClass('day-grayed');
                        }
                    }
                }
                cal.find('.calendar-one-month-wrap').eq(0).before(newMonthDom);

                this.setTmpGray();
            }
        } else {
            if (hiddenAhead.length < 2) {
                cal.find('.month-left').addClass('hidden');
            }
        }

        $(currentMonthArr[1]).removeClass('current').addClass('hidden');
        $(currentMonthArr[0]).prev('.calendar-one-month-wrap.hidden').removeClass('hidden').addClass('current');
    },

    switchRight: function switchRight() {
        var cal = this.element,
            currentMonthArr = cal.find('.calendar-one-month-wrap.current'),
            hiddenAhead = $(currentMonthArr[0]).prevAll('.calendar-one-month-wrap.hidden'),
            hiddenBehind = $(currentMonthArr[currentMonthArr.length - 1]).nextAll('.calendar-one-month-wrap.hidden');

        cal.find('.month-left').removeClass('hidden');
        $(currentMonthArr[0]).removeClass('current').addClass('hidden');

        if (hiddenBehind.length) {
            $(hiddenBehind[0]).removeClass('hidden').addClass('current');
        } else {
            var lastMonthStr = $(currentMonthArr[1]).attr('data-month'),
                cYear = +lastMonthStr.split('/')[0],
                cMonth = +lastMonthStr.split('/')[1],
                newMonthDom = cMonth == 12 ? $(buildMonths(cYear + 1, 1)) : $(buildMonths(cYear, cMonth + 1));

            cal.append(newMonthDom);

            this.setTmpGray();
        }
    }
};

function initEvents(myCalendar, options) {
    var cal = myCalendar.element;

    $(document).on('mousedown', function (e) {
        var event = window.event || e,
            target = event.target || event.srcElement,
            isScrollBar = target.tagName === 'HTML' || !target.tagName;

        if (!$(target).closest('.calendar-wrap').length && target !== myCalendar.target && !isScrollBar) {
            myCalendar.hide();
        }
    });

    cal.delegate('.calendar-td-inner', 'click', function () {
        myCalendar.dayClick($(this));
    });

    cal.find('.month-switch-bar.month-left').on('click', function () {
        myCalendar.switchLeft(options);
    });

    cal.find('.month-switch-bar.month-right').on('click', function () {
        myCalendar.switchRight();
    });
}

function createComponent_c(options) {
    var element = $(calendarPanel({
        monthStr: monthStr
    }));

    var myCalendar = $.extend({}, _default, options);
    myCalendar.element = element;
    myCalendar.setPos();

    if (options.allDate) {
        myCalendar.element.find('.month-left').removeClass('hidden');
    } else if (options.minDate) {
        myCalendar.element.find('.month-left').removeClass('hidden');

        if (new Date(options.minDate) < new Date()) {
            setDayGrayedBeforeToday(myCalendar, options.minDate);
        }
    } else {
        setDayGrayedBeforeToday(myCalendar);
    }

    $("body").append(element);

    return myCalendar;
}

function setDayGrayedBeforeToday(myCalendar, minDate) {
    var isBeforeSix = new Date().getHours() < 6;

    if (myCalendar.cityType == 4) {
        isBeforeSix = new Date().getHours() < 24;
    }

    var beginDate = new Date((myCalendar.cityType == 3 ? addDays(new Date(), isBeforeSix ? 0 : 1, '/') : addDays(new Date(), isBeforeSix ? -1 : 0, '/')) + ' 00:00:00');

    if (minDate) {
        beginDate = new Date(minDate);
    }
    var calendarTds = myCalendar.element.find('.calendar-td-inner');

    for (var i = 0; i < calendarTds.length; i++) {
        var _date = new Date($(calendarTds[i]).attr('data-day'));
        if (beginDate > _date) {
            $(calendarTds[i]).addClass('day-grayed');
        }
    }
}

module.exports = function (options) {
    var myCalendar = createComponent_c(options);

    initEvents(myCalendar, options);

    myCalendar.initCheckinCheckout();
    myCalendar.show();

    setTimeout(function () {
        myCalendar.element.dragable('.calendar-head-bg .calendar-month-head');
    }, 10);

    return myCalendar;
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

(function ($) {

	$.fn.dragable = function (selector) {

		var dragTarget,
		    dragstart = false,
		    draging = false,
		    dragOffsetX = 0,
		    dragOffsetY = 0,
		    _this = this,
		    that = this[this.length - 1],
		    _rect = that.getBoundingClientRect(),
		    thisWidth = _rect.right - _rect.left,
		    thisHeight = _rect.bottom - _rect.top,
		    turnToDraging = function turnToDraging(e) {

			var targetRect = e.currentTarget.getBoundingClientRect();

			dragstart = true;
			dragTarget = e.target || e.srcElement;

			dragOffsetX = e.clientX - targetRect.left;
			dragOffsetY = e.clientY - targetRect.top;
		};

		_this.mousedown(function (e) {
			var selArr = selector ? selector.split(' ') : [],
			    target = e.target || e.srcElement,
			    sel;

			if (selector) {
				for (var i = 0; i < selArr.length; i++) {
					sel = selArr[i].replace(/^[.#]/, '');
					if ($(target).hasClass(sel) || $(target).attr('id') == sel) {
						turnToDraging(e);
						break;
					}
				}
			} else {
				turnToDraging(e);
			}
		});

		$(document).mousemove(function (e) {
			if (dragstart) {
				draging = true;

				var newX = e.clientX - dragOffsetX;
				var newY = e.clientY - dragOffsetY;

				newX = newX < 0 ? 0 : newX;
				newY = newY < 0 ? 0 : newY;
				newX = newX > document.documentElement.clientWidth - thisWidth ? document.documentElement.clientWidth - thisWidth : newX;
				newY = newY > document.documentElement.clientHeight - thisHeight ? document.documentElement.clientHeight - thisHeight : newY;

				_this.css({
					left: newX + "px",
					top: newY + "px"
				});

				_this.addClass('fixed');
			}
		});

		$(document).mouseup(function (e) {
			dragstart = false;

			if (draging) {
				draging = false;
				$(dragTarget).trigger('draged');
			}
		});
	};
})(jQuery);

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!-- 一个月的字符串模板 -->\n<div class="calendar-one-month-wrap current" data-month="' +
((__t = ( month )) == null ? '' : __t) +
'">\n    <h1 class="calendar-month-head no-track-click" data-track="公共_日历_拖拽">' +
((__t = ( head )) == null ? '' : __t) +
'</h1>\n    <table>\n        <thead class="calendar-month-thead">\n            <tr>\n                <th class="weekend">日</th>\n                <th>一</th>\n                <th>二</th>\n                <th>三</th>\n                <th>四</th>\n                <th>五</th>\n                <th class="weekend">六</th>\n            </tr>\n        </thead>\n        <tbody>\n            ';
 for(var i = 0; i < 6; i++){ ;
__p += '\n            <tr class="calendar-row">\n                ';
 for(var j = 0; j < 7; j++){ var td = tdArr[i * 7 + j]; ;
__p += '\n                <td class="' +
((__t = ( td.isWeekend ? 'weekend' : '' )) == null ? '' : __t) +
'">\n                    <div class="calendar-td-inner' +
((__t = ( td.isValidDay ? '' : ' day-grayed' )) == null ? '' : __t) +
'" data-day="' +
((__t = ( td.dayStr )) == null ? '' : __t) +
'" data-track="公共_日历_选择日期">\n                        <p class="calendar-day-num">\n                            ' +
((__t = ( parseInt(td.dayStr.split('/')[2]) )) == null ? '' : __t) +
'\n                        </p>\n                    </div>\n                </td>\n                ';
 } ;
__p += '\n            </tr>\n            ';
 } ;
__p += '\n        </tbody>\n    </table>\n</div>\n';

}
return __p
}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!-- 日历 -->\r\n<section class="calendar-wrap" onselectstart="return false;">\r\n    <div class="calendar-head-bg no-track-click" data-track="公共_日历_拖拽"></div>\r\n\r\n    <div class="month-switch-bar-wrap">\r\n        <div class="month-switch-bar month-left hidden" data-track="公共_日历_月份_上一月"></div>\r\n        <div class="month-switch-bar month-right" data-track="公共_日历_月份_下一月"></div>\r\n    </div>\r\n\r\n    <!-- 各月份的字符串 -->\r\n    ' +
((__t = ( monthStr )) == null ? '' : __t) +
'\r\n</section>';

}
return __p
}

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<form id="orderForm">\n    <div class="t-o-c-ticket-detail">\n        <h2><span class="needASpance"></span>' +
((__t = ( data.ticketInfoModel.ticketName )) == null ? '' : __t) +
'  <span style="font-size:14px;font-weight: normal;margin-left: 10px;"> ' +
((__t = ( data.ticketPriceModel.ticketTypeName )) == null ? '' : __t) +
'</span> </h2>\n        <div>\n            <label>平日成人票</label><b>：</b>\n            <span class="t-o-c-price">￥' +
((__t = ( data.ticketPriceModel.salePrice )) == null ? '' : __t) +
'</span><span>/张</span>\n        </div>\n        <div>\n            <label for="">日期</label><b>：</b>\n            <input type="text" name="datePaker" id="ticketCalenderPrice">\n        </div>\n        <div class="t-o-c-number">\n            <label for="">数量</label><b>：</b>\n            <span class="t-o-c-number-decrease">-</span>\n            <input type="text" value="1" id="ticketNum" data-required="required" name="willUsedBalance">\n            <span class="t-o-c-number-add">+</span>\n            <i class="error-msg-outer hidden">\n                <i class="icon-warning"></i>\n                <i class="warning-txt">请输入数字</i>\n            </i>\n        </div>\n        ';
 if(data.isScreening === 0 ) { ;
__p += '\n        <div>\n          <label>场次信息</label><b>：</b>\n          <select name="screening" class="screeningChosse">\n            ';
 data.lyShow.forEach(function(item){;
__p += '\n              <option value="' +
((__t = (item.ShowId )) == null ? '' : __t) +
'">' +
((__t = (item.ShowName )) == null ? '' : __t) +
'</option>\n          ';
 }) ;
__p += '\n          </select>\n          <i class="confirm-way-required">*</i>\n      </div>\n      ';
 } ;
__p += '\n    </div>\n    <div class="calendarPrice"></div>\n    <div class="t-o-c-ticket-userinfo">\n        <h2><span class="needASpance"></span>用户信息 <span class="playerinfo">每张门票请填写一位游玩人的信息</span></h2>\n        <div class="ticketUserInfoDetail">\n            <div class="ticketUserInfoTitle">\n                <span class="touristIndex">游客1</span><span class="removeUserInfo hidden">删除</span>\n            </div>\n            <ul class="confirm-way-msg">\n                <li>\n                    <label>姓</label><b>：</b>\n                    <input onblur="this.value=this.value.toUpperCase()" type="text" name="userName" placeholder="请输入姓" data-required="required"\n                           class="t-o-c-userFirstName">\n                    <i class="confirm-way-required">*</i>\n                    <span class="error-msg-outer hidden">\n                        <i class="icon-warning"></i>\n                        <span class="warning-txt">该项不能为空</span>\n                    </span>\n                </li>\n                <li>\n                    <label>名</label><b>：</b>\n                    <input onblur="this.value=this.value.toUpperCase()" type="text" name="userName" placeholder="请输入名" data-required="required"\n                           class="t-o-c-userLastName">\n                    <i class="confirm-way-required">*</i>\n                    <span class="error-msg-outer hidden">\n                        <i class="icon-warning"></i>\n                        <span class="warning-txt">该项不能为空</span>\n                    </span>\n                </li>\n                <li>\n                  <label>手机</label><b>：</b>\n                  <input class="ticketTel" type="text" name="voucherMobile" placeholder="请输入手机号码"\n                         data-required="required">\n                  <i class="confirm-way-required">*</i>\n                  <span class="error-msg-outer hidden">\n                      <i class="icon-warning"></i>\n                      <span class="warning-txt">该项不能为空</span>\n                  </span>\n              </li>\n              ';
 if(data.isNeedIdCard === 0 ) { ;
__p += '\n              <li>\n                  <label>证件类型</label><b>：</b>\n                  <select name="cardType" class="cardTypeChosse">\n                      <option value=\'1\'>大陆身份证</option>\n                      <option value=\'2\'>港澳通行证</option>\n                      <option value=\'4\'>护照</option>\n                      <option value=\'6\'>台湾通行证</option>\n                  </select>\n                  <i class="confirm-way-required">*</i>\n                  <span class="error-msg-outer hidden">\n                      <i class="icon-warning"></i>\n                      <span class="warning-txt">该项不能为空</span>\n                  </span>\n              </li>\n              <li>\n                  <label>证件号码</label><b>：</b>\n                  <input type="text" name="voucherCard" placeholder="请输入证件号码" data-required="required"   id="cardIdInfo" class="inputCardId" >\n                  <i class="confirm-way-required">*</i>\n                  <span class="error-msg-outer hidden">\n                      <i class="icon-warning"></i>\n                      <span class="warning-txt">该项不能为空</span>\n                  </span>\n              </li>\n              ';
 } ;
__p += '\n\n                <!-- ';
 if(data.ticketPriceModel.isRealName == 1) { ;
__p += '\n                ';
 if(data.ticketPriceModel.carType.indexOf(1) != -1 && data.isNeedIdCard === 0 ) { ;
__p += '\n                <li>\n                    <label>证件类型</label><b>：</b>\n                    <select name="cardType" class="cardTypeChosse">\n                        <option value=\'1\'>大陆身份证</option>\n                        <option value=\'2\'>港澳通行证</option>\n                        <option value=\'3\'>香港身份证</option>\n                        <option value=\'4\'>护照</option>\n                        <option value=\'5\'>驾驶证</option>\n                        <option value=\'6\'>台湾通行证</option>\n                    </select>\n                    <i class="confirm-way-required">*</i>\n                    <span class="error-msg-outer hidden">\n                        <i class="icon-warning"></i>\n                        <span class="warning-txt">该项不能为空</span>\n                    </span>\n                </li>\n                <li>\n                    <label>证件号码</label><b>：</b>\n                    <input type="text" name="voucherCard" placeholder="请输入证件号码" data-required="required">\n                    <i class="confirm-way-required">*</i>\n                    <span class="error-msg-outer hidden">\n                        <i class="icon-warning"></i>\n                        <span class="warning-txt">该项不能为空</span>\n                    </span>\n                </li>\n                ';
 } ;
__p += '\n                ';
 if(data.ticketPriceModel.ticketRangeId != -1 && data.ticketPriceModel.carType.indexOf(2) != -1 ) { ;
__p += '\n                <li>\n                    <label>手机</label><b>：</b>\n                    <input class="ticketTel" type="text" name="voucherMobile" placeholder="请输入手机号码"\n                           data-required="required">\n                    <i class="confirm-way-required">*</i>\n                    <span class="error-msg-outer hidden">\n                        <i class="icon-warning"></i>\n                        <span class="warning-txt">该项不能为空</span>\n                    </span>\n                </li>\n                ';
 } ;
__p += '\n                ';
 if(data.ticketPriceModel.ticketRangeId == -1 ) { ;
__p += '\n                ';
 if(data.ticketPriceModel.ticketRatetype) { ;
__p += '\n                ';
 if(!(data.ticketPriceModel.ticketRatetype.bookerMobile == "false" && data.ticketPriceModel.ticketRatetype.travelMobile == "TRAV_NUM_NO")) { ;
__p += '\n                <li>\n                    <label>手机</label><b>：</b>\n                    <input class="ticketTel" type="text" name="voucherMobile" placeholder="请输入手机号码" data-required="required">\n                    <i class="confirm-way-required">*</i>\n                    <span class="error-msg-outer hidden">\n                        <i class="icon-warning"></i>\n                        <span class="warning-txt">该项不能为空</span>\n                    </span>\n                </li>\n                ';
 } ;
__p += '\n                ';
 if(!(data.ticketPriceModel.ticketRatetype.bookerEmail == "false" && data.ticketPriceModel.ticketRatetype.travelEmail == "TRAV_NUM_NO")) { ;
__p += '\n                <li>\n                    <label>邮箱</label><b>：</b>\n                    <input class="ticketMail" type="text" name="voucherEmail" placeholder="请输入邮箱" data-required="required">\n                    <i class="confirm-way-required">*</i>\n                    <span class="error-msg-outer hidden">\n                        <i class="icon-warning"></i>\n                        <span class="warning-txt">该项不能为空</span>\n                    </span>\n                </li>\n                ';
 } ;
__p += '\n                ';
 if(data.ticketPriceModel.ticketRatetype.credentials == 'TRAV_NUM_ONE' || data.ticketPriceModel.ticketRatetype.credentials == 'TRAV_NUM_ALL') { ;
__p += '\n                <li>\n                    ';
 if(data.ticketPriceModel.ticketRatetype.credentialsType == 'ID_CARD') { ;
__p += '\n                    <label>身份证</label><b>：</b>\n                    <input type="text" name="voucherCard" placeholder="身份证" data-value="1" data-required="required">\n                    ';
 } ;
__p += '\n                    ';
 if(data.ticketPriceModel.ticketRatetype.credentialsType == 'GANGAO') { ;
__p += '\n                    <label>港澳通行证</label><b>：</b>\n                    <input type="text" name="voucherCard" placeholder="港澳通行证" data-value="2" data-required="required">\n                    ';
 } ;
__p += '\n                    ';
 if(data.ticketPriceModel.ticketRatetype.credentialsType == 'HUZHAO') { ;
__p += '\n                    <label>护照</label><b>：</b>\n                    <input type="text" name="voucherCard" placeholder="护照" data-value="4" data-required="required">\n                    ';
 } ;
__p += '\n                    ';
 if(data.ticketPriceModel.ticketRatetype.credentialsType == 'TAIBAO') { ;
__p += '\n                    <label>台湾通行证</label><b>：</b>\n                    <input type="text" name="voucherCard" placeholder="台湾通行证" data-value="6" data-required="required">\n                    ';
 } ;
__p += '\n                    ';
 if(data.ticketPriceModel.ticketRatetype.credentialsType != 'ID_CARD' && data.ticketPriceModel.ticketRatetype.credentialsType != 'GANGAO'
                            && data.ticketPriceModel.ticketRatetype.credentialsType != 'HUZHAO' && data.ticketPriceModel.ticketRatetype.credentialsType != 'TAIBAO') { ;
__p += '\n                    <label>身份证</label><b>：</b>\n                    <input type="text" name="voucherCard" placeholder="身份证" data-value="1" data-required="required">\n                    ';
 } ;
__p += '\n                    <i class="confirm-way-required">*</i>\n                    <span class="error-msg-outer hidden">\n                        <i class="icon-warning"></i>\n                        <span class="warning-txt">该项不能为空</span>\n                    </span>\n                </li>\n                ';
 } ;
__p += '\n                ';
 } ;
__p += '\n                ';
 } ;
__p += '\n                ';
 if(data.ticketPriceModel.carType.indexOf(3) != -1 ) { ;
__p += '\n                <li>\n                    <label>邮箱</label><b>：</b>\n                    <input class="ticketMail" type="text" name="voucherEmail" placeholder="请输入邮箱" data-required="required">\n                    <i class="confirm-way-required">*</i>\n                    <span class="error-msg-outer hidden">\n                        <i class="icon-warning"></i>\n                        <span class="warning-txt">该项不能为空</span>\n                    </span>\n                </li>\n                ';
 } ;
__p += '\n                ';
 if(data.ticketPriceModel.carType.indexOf(4) != -1 ) { ;
__p += '\n                <li>\n                    <label>性别</label><b>：</b>\n                    <input type=\'radio\' value="0" class=\'ticketDiv\' name=\'sex\'/>男\n                    <input type=\'radio\' value="1" class=\'ticketDiv\' name=\'sex\'/>女\n                    <i class="confirm-way-required">*</i>\n                    <span class="error-msg-outer hidden">\n                        <i class="icon-warning"></i>\n                        <span class="warning-txt">该项不能为空</span>\n                    </span>\n                </li>\n                ';
 } ;
__p += '\n                ';
 if(data.ticketPriceModel.carType.indexOf(5) != -1 ) { ;
__p += '\n                <li>\n                    <label>出生地</label><b>：</b>\n                    <input type=\'text\' class=\'ticketDiv\' name=\'birthPlace\' data-required="required" placeholder="请输入出生地">\n                    <i class="confirm-way-required">*</i>\n                    <span class="error-msg-outer hidden">\n                        <i class="icon-warning"></i>\n                        <span class="warning-txt">该项不能为空</span>\n                    </span>\n                </li>\n                ';
 } ;
__p += '\n                ';
 if(data.ticketPriceModel.carType.indexOf(6) != -1 ) { ;
__p += '\n                <li>\n                    <label>签发地</label><b>：</b>\n                    <input type=\'text\' class=\'ticketDiv\' name=\'airPlace\' data-required="required" placeholder="请输入签发地">\n                    <i class="confirm-way-required">*</i>\n                    <span class="error-msg-outer hidden">\n                        <i class="icon-warning"></i>\n                        <span class="warning-txt">该项不能为空</span>\n                    </span>\n                </li>\n                ';
 } ;
__p += '\n                ';
 } ;
__p += ' -->\n            </ul>\n            <hr/>\n        </div>\n        <!-- <div class="addUserInfo">\n            <span class="addUserNum">+</span>新增用户信息\n        </div> -->\n\n\n    </div>\n    <div class="t-o-c-ticket-connection">\n        <h2><span class="needASpance"></span>联系人信息</h2>\n        <div>\n            <label for="">姓名</label><b>：</b>\n            <input onblur="this.value=this.value.toUpperCase()" class="connectionName" name="userName" data-required="required" type="text" placeholder="请输入姓名">\n            <i class="confirm-way-required">*</i>\n            <span class="useUserInfoBtn"><input type="checkbox" class="useUserInfo">使用用户信息</span>\n            <span class="error-msg-outer hidden">\n                <i class="icon-warning"></i>\n                <span class="warning-txt">该项不能为空</span>\n            </span>\n        </div>\n        <div>\n            <label for="">手机号码</label><b>：</b>\n            <input class="connectionTel" name="voucherMobile" type="text" data-required="required" placeholder="请输入手机号码">\n            <i class="confirm-way-required">*</i>\n            <span class="error-msg-outer hidden">\n                <i class="icon-warning"></i>\n                <span class="warning-txt">该项不能为空</span>\n            </span>\n        </div>\n        <div>\n            <label for="">邮箱</label><b>：</b>\n            <input class="connectionMail" name="voucherEmail" type="text" placeholder="请输入的邮箱">\n            <span class="error-msg-outer hidden">\n                <i class="icon-warning"></i>\n                <span class="warning-txt">该项不能为空</span>\n            </span>\n        </div>\n    </div>\n    <div class="t-o-c-ticket-final">\n        <h2><span class="needASpance"></span>结算信息</h2>\n        <div>\n            <label for="">客户订单号</label><b>：</b>\n            <input id="useOrderNum" name="useOrderNum" data-required="required" type="text" placeholder="请输入客户订单号">\n            <span class="error-msg-outer hidden">\n                <i class="icon-warning"></i>\n                <span class="warning-txt">该项不能为空</span>\n            </span>\n        </div>\n        <div>\n            <label for="">结算方式</label><b>：</b>\n            ';
 if(data.ticketPriceModel.paymentType == 0){ ;
__p += '\n            <select name="paymentTermSon" id="balance-way">\n                ';
 if(data.distributorAccount.paymentTerm == 0){ ;
__p += '\n                <option value="0">单结</option>\n                ';
 }else{ ;
__p += '\n                <option value="' +
((__t = ( data.distributorAccount.paymentTerm )) == null ? '' : __t) +
'" selected>\n                    ' +
((__t = ( data.distributorAccount.paymentTermName[data.distributorAccount.paymentTerm + 1] )) == null ? '' : __t) +
'\n                </option>\n                <option value="0">单结</option>\n                ';
 } ;
__p += '\n            </select>\n            ';
 } ;
__p += '\n        </div>\n        ';
 if(data.distributorAccount.paymentTerm == 0){ ;
__p += '\n        <div class="isUseMoney">\n            <label for="">使用预付款</label><b>：</b>\n            <input id="usePerPayment" name="willUsedBalance" type="text">\n            <b class="per-payment-prompt"></b>\n            <span class="error-msg-outer hidden">\n                <i class="icon-warning"></i>\n                <span class="warning-txt">该项不能为空</span>\n            </span>\n        </div>\n        ';
 } ;
__p += '\n        <div>\n            <label for="">剩余预收款</label><b>：</b>\n            <span>RMB <span id="maxPayment">' +
((__t = ( data.distributorAccount.balance )) == null ? '' : __t) +
'</span></span>\n        </div>\n    </div>\n\n</form>\n';

}
return __p
}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="t-o-c-notice">\n  <h2>购票须知</h2>\n\n  <ul>\n    <li>\n      <div>\n        <h3>取消条款</h3>\n        <div class=\'cancelRule\'>' +
((__t = (data.ticketPriceModel.clauseDescShow)) == null ? '' : __t) +
'</div>\n      </div>\n    </li>\n\n  </ul>\n  <div class="t-o-c-button">\n    <div>购买详情须知 ></div>\n  </div>\n  <div class="t-o-c-total">\n    <span>订单总金额：</span>\n    <span class="theTotalLogo">￥</span>\n    <span class="theTotalMoney"></span>\n    <span class="theTotalNums"></span>\n  </div>\n</div>\n\n';

}
return __p
}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<ul class="t-o-c-pop">\n  <li>\n    <label for="">费用包含</label>\n    <p>' +
((__t = ( payIn || '' )) == null ? '' : __t) +
'</p>\n  </li>\n  <li>\n    <label for="">票种说明</label>\n    <p><span>取票时间:</span>' +
((__t = ( pickTime || '' )) == null ? '' : __t) +
'</p>\n    <p><span>取票方法:</span>' +
((__t = ( pickMode || '' )) == null ? '' : __t) +
'</p>\n    <p><span>入园地址:</span>' +
((__t = ( pointAdress || '' )) == null ? '' : __t) +
'</p>\n    <p><span>门票有效说明:</span>' +
((__t = ( effectiveDesc || '' )) == null ? '' : __t) +
'</p>\n  </li>\n\n  <li>\n    <label for="">重要提示</label>\n    <p class="importantNotice"></p>\n  </li>\n</ul>\n';

}
return __p
}

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__(68);

module.exports = function (options) {

	var event = window.event || arguments.callee.caller.arguments[0];

	if (!options) {
		options = {
			target: event.target || event.srcElement
		};
	}

	if (!options.target) {
		options.target = event.target || event.srcElement;
	}

	if (options.target.tagName === 'I') {
		options.target = $(options.target).prev('*')[0];
	}

	var target = options.target;
	if (!target.adultChildrenSelect) {
		target.adultChildrenSelect = __webpack_require__(69)(options);
	} else {
			if (target.adultChildrenSelect.element.closest('.ac-select-wrap').css('display') != 'none') {
				target.adultChildrenSelect.hide();
			} else {
				target.adultChildrenSelect.show();
			}
		}
};

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {


var adultChildrenSelectPanel = __webpack_require__(70),
    childrenAgeSelector = __webpack_require__(71),
    mySelect = __webpack_require__(22),
    _default = {
    adultNum: 2,
    childrenNum: 0,
    childrenAgesStr: '',
    setPos: function setPos() {
        var target = this.target,
            targetRect = target.getBoundingClientRect(),
            left = targetRect.left + (this.left || 0) + $(document).scrollLeft(),
            top = targetRect.bottom + 2 + (this.top || 0) + $(document).scrollTop(),
            widthBorder = document.body.scrollWidth - 376;

        this.element.css('left', left > widthBorder ? widthBorder : left).css('top', top).css('display', 'none');
    },
    show: function show(options) {
        if (options && options.target) {
            this.adultNum = options.target.adultNum || 2;
            this.childrenNum = options.target.childrenNum || 0;
            this.childrenAgesStr = options.target.childrenAgesStr || '';
        }

        this.setPos();

        var element = this.element;
        setTimeout(function () {
            element.show();
        }, 10);
    },
    hide: function hide() {
        this.element.hide();
    },

    setTargetText: function setTargetText() {
        this.target.value = this.adultNum + '成人，' + this.childrenNum + '小孩';
    },

    resetChildrenAgeSelect: function resetChildrenAgeSelect() {
        var _this = this.element,
            newSelectStr = '',
            newChildrenAgeStr = '',
            rowTwo = _this.find('.ac-select-row.row-two'),
            childrenAgeSelectWrap = _this.find('.ac-select-children-age-wrap'),
            childrenNum = parseInt(_this.find('.ac-select-children').attr('data-value'));

        for (var i = 0; i < childrenNum; i++) {
            newSelectStr += childrenAgeSelector();
            newChildrenAgeStr += '0,';
        }

        childrenAgeSelectWrap.html(newSelectStr);
        this.childrenAgesStr = newChildrenAgeStr.replace(/,$/, '');
        this.target.childrenAgesStr = newChildrenAgeStr.replace(/,$/, '');

        childrenNum > 0 ? rowTwo.slideDown('fast') : rowTwo.slideUp('fast');
    },

    setChildrenAgeStr: function setChildrenAgeStr() {
        var _this = this.element,
            newChildrenAgeStr = '',
            childrenAgeSelects = _this.find('.ac-select-children-age');

        for (var i = 0; i < childrenAgeSelects.length; i++) {
            var o = childrenAgeSelects[i];
            newChildrenAgeStr += $(o).attr('data-value') + ',';
        }

        this.childrenAgesStr = newChildrenAgeStr.replace(/,$/, '');
        this.target.childrenAgesStr = newChildrenAgeStr.replace(/,$/, '');
    }
};

function initEvents(adultChildrenSelect) {

    var element = adultChildrenSelect.element;

    var adultNum = adultChildrenSelect.target.adultNum;
    var childrenNum = adultChildrenSelect.target.childrenNum;
    var childrenAgesStr = adultChildrenSelect.target.childrenAgesStr;

    if (adultNum && adultNum > 0) {
        element.find('.ac-select-adult').html(adultNum + '人');
        element.find('.ac-select-adult').attr('data-value', adultNum);
    }
    if (childrenNum && childrenNum > 0 && childrenAgesStr) {
        element.find('.ac-select-children').html(childrenNum + '人');
        element.find('.ac-select-children').attr('data-value', childrenNum);

        var childrenAgeSelectWrap = element.find('.ac-select-children-age-wrap');
        var newSelectStr = '';
        for (var i = 0; i < childrenNum; i++) {
            newSelectStr += childrenAgeSelector();
        }
        childrenAgeSelectWrap.html(newSelectStr);

        var _select = childrenAgeSelectWrap.find(".drag-down-wrap").find(".ac-select-children-age");
        var childrenAgesArr = childrenAgesStr.split(',');
        $.each(_select, function (i, o) {
            $(o).html(childrenAgesArr[i] + '岁');
            $(o).attr('data-value', childrenAgesArr[i]);
        });

        element.find('.ac-select-row.row-two').slideDown('fast');
    }

    $(document).on('mousedown', function (e) {
        var event = window.event || e,
            target = event.target || event.srcElement,
            isScrollBar = target.tagName === 'HTML' || !target.tagName;

        if (!$(target).closest('.ac-select-wrap').length && target !== adultChildrenSelect.target && !isScrollBar && !$(target).closest('.my-select-list').length) {
            adultChildrenSelect.hide();
        }
    });

    element.find('.ac-select-adult').on('mousedown', function () {
        mySelect({
            options: [{ text: '1人', value: '1' }, { text: '2人', value: '2' }, { text: '3人', value: '3' }, { text: '4人', value: '4' }, { text: '5人', value: '5' }, { text: '6人', value: '6' }, { text: '7人', value: '7' }]
        });
    });

    element.find('.ac-select-children').on('mousedown', function () {
        mySelect({
            options: [{ text: '0人', value: '0' }, { text: '1人', value: '1' }, { text: '2人', value: '2' }, { text: '3人', value: '3' }, { text: '4人', value: '4' }]
        });
    });

    element.delegate('.ac-select-children-age', 'mousedown', function () {
        mySelect({
            options: [{ text: '&lt;1岁', value: '0' }, { text: '1岁', value: '1' }, { text: '2岁', value: '2' }, { text: '3岁', value: '3' }, { text: '4岁', value: '4' }, { text: '5岁', value: '5' }, { text: '6岁', value: '6' }, { text: '7岁', value: '7' }, { text: '8岁', value: '8' }, { text: '9岁', value: '9' }, { text: '10岁', value: '10' }, { text: '11岁', value: '11' }, { text: '12岁', value: '12' }, { text: '13岁', value: '13' }, { text: '14岁', value: '14' }, { text: '15岁', value: '15' }, { text: '16岁', value: '16' }, { text: '17岁', value: '17' }]
        });
    });

    element.find('.ac-select-adult').on('change', function () {
        adultChildrenSelect.adultNum = $(this).attr('data-value');
        adultChildrenSelect.target.adultNum = $(this).attr('data-value');
        adultChildrenSelect.setTargetText();
    });

    element.find('.ac-select-children').on('change', function () {
        adultChildrenSelect.childrenNum = $(this).attr('data-value');
        adultChildrenSelect.target.childrenNum = $(this).attr('data-value');
        adultChildrenSelect.setTargetText();
        adultChildrenSelect.resetChildrenAgeSelect();
    });

    element.delegate('.ac-select-children-age', 'change', function () {
        adultChildrenSelect.setChildrenAgeStr();
    });

    element.delegate('.ac-select-info', 'mouseover', function () {
        this.tip = layer.tips('18周岁及以上为成人，<br>0-17周岁未成年请参照各酒店入住政策。', this, {
            tips: [2, '#FF5722'],
            area: '237px',
            time: 0
        });
    });

    element.delegate('.ac-select-info', 'mouseout', function () {
        layer.close(this.tip);
    });
}

function acsFactory(options) {
    var element = $(adultChildrenSelectPanel());

    var adultChildrenSelect = $.extend({}, _default, options);
    adultChildrenSelect.element = element;
    adultChildrenSelect.setPos();

    $("body").append(element);

    return adultChildrenSelect;
}

module.exports = function (options) {
    var adultChildrenSelect = acsFactory(options);

    initEvents(adultChildrenSelect);

    adultChildrenSelect.show(options);

    return adultChildrenSelect;
};

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '\r\n<!-- 成人小孩选择组件模板 -->\r\n<section class="ac-select-wrap">\r\n    <div class="ac-select-row">\r\n        <div class="ac-select-item-wrap">\r\n            <label class="ac-select-item-label">成人</label>\r\n            <div class="drag-down-wrap">\r\n                <my-select class="ac-select-adult select" unselectable="on" data-value="2" data-track="公共_成人小孩_成人">2人</my-select>\r\n                <i class="drag-down"></i>\r\n            </div>\r\n            <span class="ac-select-note-text">18岁及以上</span>\r\n        </div>\r\n\r\n        <div class="ac-select-item-wrap m-l">\r\n            <label class="ac-select-item-label">小孩</label>\r\n            <div class="drag-down-wrap">\r\n                <my-select class="ac-select-children select" unselectable="on" data-value="0" data-track="公共_成人小孩_小孩">0人</my-select>\r\n                <i class="drag-down"></i>\r\n            </div>\r\n            <span class="ac-select-note-text">0-17岁</span>\r\n            <i class="ac-select-info"></i>\r\n        </div>\r\n    </div>\r\n\r\n    <div class="ac-select-row row-two">\r\n        <div class="ac-select-item-wrap">\r\n            <label class="ac-select-item-label">儿童入住时年龄</label>\r\n            <div class="ac-select-children-age-wrap"></div>\r\n        </div>\r\n    </div>\r\n\r\n    <!-- <div class="ac-select-btn-group">\r\n        <button class="ac-select-btn cancel">取消</button>\r\n        <button class="ac-select-btn confirm">确定</button>\r\n    </div> -->\r\n</section>\r\n';

}
return __p
}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!-- 单个儿童年龄选择框组件&lt; -->\n<div class="drag-down-wrap">\n    <my-select class="ac-select-children-age select" unselectable="on" data-value="0" data-track="公共_成人小孩_小孩年龄"><1岁</my-select>\n    <i class="drag-down"></i>\n</div>';

}
return __p
}

/***/ }),
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {


var Util = __webpack_require__(0),
    orderMain = __webpack_require__(56),
    guestMsg = __webpack_require__(57),
    isHotelOnline = __webpack_require__(24).isHotelOnline,
    getCanlendarPrice = __webpack_require__(24).getCanlendarPrice,
    getInitData = __webpack_require__(24).getInitData,
    changeToPage = __webpack_require__(30).changeToPage,
    addDays = Util.addDays,
    queryString = Util.queryString,
    CloseWebPage = __webpack_require__(30).CloseWebPage;

function initPage() {
  isHotelOnline(function (res) {

    if (typeof res === 'string') {
      res = window.JSON.parse(res);
    }

    if (res.returnCode === 1) {
      $.validateIsComplete = 'true';
    } else if (res.returnCode === -400001) {
      $.validateIsComplete = 'false';
      alert('请先登录', { closeBtn: 0 }, function () {
        location.href = '/user/bookHotel.do?';
      });
    } else {
      $.validateIsComplete = 'false';

      alert(res.errinfo, { closeBtn: 0 }, function () {
        changeToPage();
      });
    }
  });

  invokeAPIs();
}

function invokeAPIs(initHtml) {

  var days = addDays(queryString('today'));

  getCanlendarPrice(days, function (res) {
    if (res.returnCode === 1) {
      var dateArr = [];
      var daysArr = [];
      var dayObj = {};
      if (res.data) {
        for (var key in res.data) {
          dayObj = {
            key: key,
            val: res.data[key].length
          };
          dateArr.push(dayObj);
          daysArr.push(res.data[key].length);
        }
        dateArr.sort(function (a, b) {
          return Date.parse(a.key) - Date.parse(b.key);
        });
        if (daysArr.indexOf(1) >= 0) {
          for (var _key in dateArr) {
            if (dateArr[_key].val == 1) {
              getOrderInitData(dateArr[_key].key, res.data[dateArr[_key].key][0]);
              return;
            }
          }
        } else {
          getCanlendarPrice(addDays(days, 31, '-'), function (res) {
            if (res.returnCode === 1) {
              if (res.data) {
                for (var _key2 in res.data) {
                  dayObj = {
                    key: _key2,
                    val: res.data[_key2].length
                  };
                  dateArr.push(dayObj);
                  daysArr.push(res.data[_key2].length);
                }
                dateArr.sort(function (a, b) {
                  return Date.parse(a.key) - Date.parse(b.key);
                });
                if (daysArr.indexOf(1) >= 0) {
                  for (var _key3 in dateArr) {
                    if (dateArr[_key3].val == 1) {
                      getOrderInitData(dateArr[_key3].key, res.data[dateArr[_key3].key][0]);
                      return;
                    }
                  }
                } else {
                  alert('暂无门票价格价格', function () {
                    changeToPage();
                  });
                }
              }
            } else if (res.returnCode === -400001) {
              alert('请先登录', { closeBtn: 0 }, function () {
                location.href = '/user/bookHotel.do?';
              });
            } else {
              alert(res.errinfo, function () {
                changeToPage();
              });
            }
          });
        }
      }
    } else if (res.returnCode === -400001) {
      alert('请先登录', { closeBtn: 0 }, function () {
        location.href = '/user/bookHotel.do?';
      });
    } else {
      alert(res.errinfo, function () {
        changeToPage();
      });
    }
  });
}

function getValidateTag(errorMsg, newPrcie) {
  var checkValidate = setInterval(function () {
    var validateIsComplete = $.validateIsComplete;

    if (validateIsComplete) {
      clearInterval(checkValidate);
      if (validateIsComplete !== 'false') {
        if (errorMsg === 'isAveragePriceRMBChange') {
          var priceChange = layer.confirm('最新价格为：￥' + newPrcie + '，是否需要继续预订？', function () {
            layer.close(priceChange);
          }, function () {
            changeToPage();
          });
        } else {
          alert(errorMsg, { closeBtn: 0 }, function () {
            changeToPage();
          });
        }
      }
    }
  }, 100);
}

function getOrderInitData(day, params) {

  getInitData(day, params, function (res) {

    if (res.returnCode === 1) {

      $.orderInfo = res;

      res.data.distributorAccount.paymentTermName = ["客人前台现付", '单结', '周结', '半月结', '月结', '不固定', '三日结', '十日结', '额度结'];

      $('.t-o-c-ticket-user').html(orderMain({ data: res.data }));

      $('.t-o-c-ticket-needKnow').html(guestMsg({ data: res.data }));

      $('#ticketCalenderPrice').val(addDays(day, 0, '-'));

      loadScriptsAsync();
    } else {
      getValidateTag(res.errinfo);
    }
  });
}

function loadScriptsAsync() {
  if (Util.ltIE9()) {
    var initActive = __webpack_require__(31).run;

    Util.loadAsync(['../../webpacked/static/js/validator/validatorPacked.js'], initActive);
  } else {

    __webpack_require__.e/* require.ensure */(0).then((function () {
      var initActive = __webpack_require__(31).run;

      __webpack_require__(90);

      initActive();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}

module.exports = {
  run: initPage,
  invokeAPIs: invokeAPIs
};

/***/ }),
/* 74 */
/***/ (function(module, exports) {


function calendarPrice() {
  $(document).delegate('#ticketCalenderPrice', 'focus', function () {
    console.log(1111);
    var parent = $(this).closest('section');
    parent.find('.chidren-select-wrap').show();
    parent.find('.calendar-price-wrap').slideToggle('fast');
  });
}

module.exports = {
  run: function run() {}
};

/***/ }),
/* 75 */
/***/ (function(module, exports) {

function addValidateMethods() {
    $.validator.addMethod('demostic', function (value, element) {

        value = value.replace(/^\s+|\s+$/g, '');
        var demostic = /^([\u4e00-\u9fa5a-zA-Z]+)$/;

        return this.optional(element) || demostic.test(value);
    }, '只能输入中文或英文字母');

    $.validator.addMethod('required_m', function (value, element) {

        var holder = $(element).attr('placeholder');

        if ($(element).attr('data-required') === 'required') {
            return value != '' && value != holder;
        }

        return true;
    }, '请输入该信息');

    $.validator.addMethod('required_iphone', function (value, element) {

        var exg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;

        return this.optional(element) || exg.test(value);
    }, '请输入正确的手机号');

    $.validator.addMethod('required_idcard', function (value, element) {

        var exg = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;

        return this.optional(element) || exg.test(value);
    }, '请填写正确的18位身份证号码');

    $.validator.addMethod('required_otherCard', function (value, element) {

        var exg = /^[a-zA-Z0-9]{0,20}$/;

        return this.optional(element) || exg.test(value);
    }, '必须为20位以内的字母或数字');

    $.validator.addMethod('subRequired', function (value, element) {

        value = value.replace(/^\s+|\s+$/g, '');
        var holder = $(element).attr('placeholder');

        if (value != '' && value != holder) return true;

        var inputs = $(element).closest('.guest').find('input');

        for (var i = 0; i < inputs.length; i++) {

            var o = inputs[i];

            var n_value = o.value.replace($(o).attr('placeholder'), '').replace(/^\s+|\s+$/g, '');

            if (n_value != '') return false;
        }

        return true;
    }, '请输入该信息');

    $.validator.addMethod('most2pointnum', function (value, element) {

        var most2pointnum = /^(\d+(.\d{1,2})?)$/;

        return this.optional(element) || most2pointnum.test(value);
    }, '最多只允许输入小数点后两位');

    $.validator.addMethod('allowNumAndWord', function (value, element) {

        var allowNumAndWord = /^[A-Za-z0-9]+$/;

        return this.optional(element) || allowNumAndWord.test(value);
    }, '最多只允许输入小数点后两位');

    $.validator.addMethod('byteRangeLength', function (value, element, param) {
        var length = value.length;
        for (var i = 0; i < value.length; i++) {
            if (value.charCodeAt(i) > 127) {
                length += 2;
            }
        }
        return this.optional(element) || length >= param[0] && length <= param[1];
    }, $.validator.format('最多允许输入64位字符'));

    $.validator.addMethod('customerCode', function (value, element) {

        var customerCode = /^[a-zA-Z0-9/-]{0,64}$/;

        return this.optional(element) || customerCode.test(value);
    }, '不能超过64个字符，仅支持字母、数字、"/"、"-"');
}

function InitValidator() {

    if (!$.orderInfo) {
        return setTimeout(function () {
            InitValidator();
        }, 100);
    }

    addValidateMethods();

    var o = {
        rules: {
            surname: {
                required_m: true,
                subRequired: true
            },
            userName: {
                required_m: true,
                subRequired: true
            },
            countryId: {
                required_m: true,
                subRequired: true
            },
            voucherEmail: {
                required_m: true,
                email: true,
                rangelength: [0, 64]
            },
            voucherMobile: {
                number: true,
                required_m: true,
                required_iphone: true,
                rangelength: [11, 11]
            },
            willUsedBalance: {
                number: true,
                min: 0,
                most2pointnum: true
            },
            marketingRemark: {
                required: true,
                number: true,
                rangelength: [6, 14]
            },
            voucherCard: {
                required: true,
                rangelength: [0, 64],
                required_idcard: true
            },
            voucherOtherCard: {
                required: true,
                rangelength: [0, 64],
                required_otherCard: true
            },
            useOrderNum: {
                customerCode: true
            }
        },
        messages: {
            voucherEmail: {
                email: '请输入正确的邮箱地址',
                rangelength: '超过最大输入长度'
            },
            voucherMobile: {
                number: '请填写正确的手机号码',
                rangelength: '手机号码长度必须为11位'
            },
            willUsedBalance: {
                number: '请输入数字',
                min: '请输入一个至少大于0的数字',
                max: '您的余额不足或预付款超出本次消费总金额'
            },
            marketingRemark: {
                required: '此项为必填',
                number: '请填写正确的手机号码',
                rangelength: '手机号码长度必须为6位到14位之间'
            },
            voucherCard: {
                required: '此项为必填',
                rangelength: '超过最大输入长度'
            },
            useOrderNum: {
                customerCode: '不能超过64个字符，仅支持字母、数字、"/"、"-"'
            }
        }
    };

    var o1 = {};
    if ($.orderInfo.data.ticketInfoModel.cityType == 0) {
        o1 = {
            rules: {
                surname: {
                    demostic: true,
                    rangelength: [1, 30]
                },
                userName: {
                    demostic: true,
                    rangelength: [1, 30]
                }
            },
            messages: {
                surname: {
                    rangelength: '请输入1-30个汉字或字母'
                },
                userName: {
                    rangelength: '请输入1-30个汉字或字母'
                }
            }
        };
    } else {
        o1 = {
            rules: {
                surname: {
                    letter: true,
                    rangelength: [1, 30]
                },
                userName: {
                    letter: true,
                    rangelength: [1, 30]
                }
            },
            messages: {
                surname: {
                    letter: '请输入英文或拼音',
                    rangelength: '请输入1-30个字母'
                },
                userName: {
                    letter: '请输入英文或拼音',
                    rangelength: '请输入1-30个字母'
                }
            }
        };
    }

    $.extend(true, o, o1);
    $('#orderForm').validate(o);
}

module.exports = InitValidator;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var confirmOrderMsg = __webpack_require__(77),
    addDays = __webpack_require__(0).addDays;

CloseWebPage = __webpack_require__(30).CloseWebPage;

function isComplete() {
  $('.t-o-c-ticket-button').click(function () {

    if (!$("#orderForm").myValid()) {
      var failedTest = $('.error')[0].offsetTop - 80;

      $('body, html').animate({
        scrollTop: failedTest + "px"
      }, 200);

      return;
    } else {
      var list = $(".ticketUserInfoDetail .ticketTel");
      var tels = [];
      for (var i = 0; i < list.length; i++) {
        tels.push(list[i].value);
      }
      if (isRepeat(tels)) {
        layer.open({
          title: '提示',
          content: '每个游客电话号码要求唯一'
        });
        return;
      }

      alertConfirmMsg();
    }
  });
}

function isRepeat(arr) {
  var hash = {};
  for (var i in arr) {
    if (hash[arr[i]]) {
      return true;
    }
    hash[arr[i]] = true;
  }
  return false;
}

function alertConfirmMsg() {
  var formObj = {};

  var o = $.orderInfo.data;
  formObj.clauseDesc = o.ticketPriceModel.clauseDesc;
  formObj.innerRemark = '';
  formObj.supplierRemark = 'aa';
  formObj.distrbId = o.ticketPriceModel.distrbId;
  formObj.distrbName = o.ticketPriceModel.distrbName;
  formObj.customId = o.ticketPriceModel.customId;
  formObj.customName = o.ticketPriceModel.customName;
  formObj.distrbName = o.ticketPriceModel.distrbName;
  formObj.infoId = o.ticketPriceModel.infoId;
  formObj.itemId = o.ticketPriceModel.itemId;
  formObj.ticketRangeId = o.ticketPriceModel.ticketRangeId;
  formObj.itemName = o.ticketPriceModel.infoName;
  formObj.suppId = o.ticketPriceModel.suppId;

  formObj.suppName = o.ticketPriceModel.suppName;
  formObj.acount = $('#ticketNum').val();
  formObj.paymentTerm = $('#balance-way').val();
  formObj.suppPaymentTerm = o.ticketPriceModel.suppPaymentTerm;
  formObj.currency = o.currency;
  formObj.currencyRate = o.currencyRate;
  formObj.basePrice = parseFloat(o.ticketPriceModel.basePrice * formObj.acount);
  formObj.salePrice = parseFloat(o.ticketPriceModel.salePrice * formObj.acount);
  formObj.paymentStatus = 0;
  formObj.customerOrderCode = $('#useOrderNum').val();
  var useBalanceAmount = parseFloat($('#usePerPayment').val());
  if (useBalanceAmount) {
    formObj.useBalanceAmount = useBalanceAmount;
  }
  var connectionName = $('.connectionName').val().toUpperCase();
  var connectionTel = $('.connectionTel').val();
  var connectionMail = $('.connectionMail').val();
  if (connectionName) {
    formObj.bookerUserCheckInName = connectionName;
  }
  if (connectionTel) {
    formObj.bookerUserMobilePhone = connectionTel;
  }
  if (connectionMail) {
    formObj.bookerUserEmail = connectionMail;
  }

  formObj.orderUser = {};
  var divTr = $(".ticketUserInfoDetail");
  var userSize = divTr.length;
  var nameArr = [];
  if (divTr.length > 0) {

    for (var index = 0; index < userSize; index++) {
      var divs = $(divTr[index]);
      var firstName = divs.find('.t-o-c-userFirstName').val().toUpperCase(),
          lastName = divs.find('.t-o-c-userLastName').val().toUpperCase();
      formObj["orderUserList[" + index + "].userName"] = firstName + lastName;
      formObj["orderUserList[" + index + "].firstName"] = firstName;
      formObj["orderUserList[" + index + "].lastName"] = lastName;
      nameArr.push(firstName.trim() + lastName.trim());

      var sex = divs.find("[name=sex]:checked").val();
      var birthPlace = divs.find("[name=birthPlace]").val();
      var airPlace = divs.find("[name=airPlace]").val();
      var phone = divs.find("[name=voucherMobile]").val();
      var email = divs.find("[name=voucherEmail]").val();
      var cardType = divs.find("[name=cardType]").val();
      var card = cardType === "1" ? divs.find("[name=voucherCard]").val() : divs.find("[name=voucherOtherCard]").val();
      var cardTypeNum = cardType === "1" ? divs.find("[name=voucherCard]").attr('data-value') : divs.find("[name=voucherOtherCard]").val();

      if (phone) {
        formObj["orderUserList[" + index + "].mobilePhone"] = phone;
      }
      if (email) {
        formObj["orderUserList[" + index + "].email"] = email;
      }
      if (card) {
        formObj["orderUserList[" + index + "].cardNo"] = card;
      }
      if (cardType || cardTypeNum) {
        formObj["orderUserList[" + index + "].cardType"] = cardType || cardTypeNum;
      }
      if (sex) {
        formObj["orderUserList[" + index + "].sex"] = sex;
      }
      if (birthPlace) {
        formObj["orderUserList[" + index + "].birthPlace"] = birthPlace;
      }
      if (airPlace) {
        formObj["orderUserList[" + index + "].airPlace"] = airPlace;
      }

      var isRealName = $("[name=isRealNameHidden]").val();
      if (isRealName) {
        formObj["orderUserList[" + index + "].cardType"] = divs.find("[name=cardType]").val();
        formObj["orderUserList[" + index + "].cardNo"] = divs.find("[name=cardNo]").val();
      }
    }
  }

  formObj.checkInDate = addDays($('#ticketCalenderPrice').val(), 0, '-');
  formObj.ticketPriceModelList = [];
  var ticketPriceModelList = {};
  formObj["ticketPriceModelList[0].stockId"] = o.ticketPriceModel.stockId;
  formObj["ticketPriceModelList[0].validDate"] = addDays($('#ticketCalenderPrice').val(), 0, '-');
  formObj["ticketPriceModelList[0].basePrice"] = o.ticketPriceModel.basePrice;
  formObj["ticketPriceModelList[0].salePrice"] = o.ticketPriceModel.salePrice;
  formObj["ticketPriceModelList[0].ticketType"] = o.ticketPriceModel.ticketType;
  formObj["ticketPriceModelList[0].priceType"] = o.ticketPriceModel.priceType;
  formObj["ticketPriceModelList[0].ticketTypeName"] = o.ticketPriceModel.ticketTypeName;
  formObj["ticketPriceModelList[0].priceTypeName"] = o.ticketPriceModel.priceTypeName;
  formObj["ticketPriceModelList[0].paymentType"] = o.ticketPriceModel.paymentType;
  formObj["ticketPriceModelList[0].formulaType"] = o.ticketPriceModel.formulaType;

  formObj["ticketPriceModelList[0].room"] = formObj.acount;
  formObj["ticketPriceModelList[0].ticketRangeId"] = o.ticketPriceModel.ticketRangeId;
  formObj["ticketPriceModelList[0].itemId"] = o.ticketPriceModel.itemId;

  formObj.ticketType = o.ticketPriceModel.ticketType;
  formObj.priceType = o.ticketPriceModel.priceType;;
  formObj.ticketTypeName = o.ticketPriceModel.ticketTypeName;
  formObj.priceTypeName = o.ticketPriceModel.priceTypeName;
  formObj.paymentType = o.ticketPriceModel.paymentType;
  formObj.formulaType = o.ticketPriceModel.formulaType;
  formObj.checkOutDate = addDays($('#ticketCalenderPrice').val(), 1, '-');
  formObj.originalPrice = o.ticketPriceModel.basePrice;
  formObj.originalBasePrice = o.ticketPriceModel.salePrice;

  formObj.ticketPriceModelList[0] = ticketPriceModelList;

  var screening = $('.screeningChosse').val();
  if (screening) {
    var item = o.lyShow.find(function (item) {
      return item.ShowId === screening;
    });
    formObj.screeningId = item.ShowId;
    formObj.screeningBeginTime = item.ShowBeginTime;
    formObj.screeningEndTime = item.ShowEndTime;
    formObj.screeningName = item.ShowName;
  }
  console.log(formObj);

  var confirmOrderDOM = layer.open({
    type: 1,
    title: false,
    offset: '60px',
    closeBtn: 0,
    move: '.palce-can-move',
    shade: 0.5,
    content: confirmOrderMsg({ data: formObj })
  });
  for (var i in nameArr) {
    $('.t-o-c-player').append('<span>\u6E38\u73A9\u4EBA' + (parseInt(i) + 1) + '</span><p>' + nameArr[i] + '</p>');
  }
  $('.ticketCancelContent').text(o.ticketPriceModel.clauseDescShow);
  var balanceWay = $('#balance-way').attr('data-method') || $('#balance-way').find('option[selected]').text().trim() || $('#balance-way').find('option[value=0]').text().trim();

  $('.ticketBalanceWay').text(balanceWay);

  $('.confirm-order-msg').on('click', '.confirm-order', function () {
    layer.close(confirmOrderDOM);
    sendData(formObj);
  });

  $('.confirm-order-msg').on('click', '.cancel-order', function () {
    layer.close(confirmOrderDOM);
  });

  return false;
}

function sendData(formObj) {
  createOrder(formObj);
}

function createOrder(formObj) {
  var checkThePrice = __webpack_require__(24).checkThePrice;
  checkThePrice(formObj, function (res) {

    if (res.returnCode === 1) {
      if (res.data.nonFinish) {
        location.href = '/pay/toPayOrCharge.do?payMethod=2&orderId=' + res.data.orderInfoId;
      } else {
        location.href = '/ticketController/toTicketOrderSuccess.do?subOrderCode=' + res.data.orderId + '&orderId=' + res.data.orderInfoId;
      }
    } else if (res.returnCode === -400001) {
      alert('请先登录', { closeBtn: 0 }, function () {
        location.href = '/user/home.do';
      });
    } else if (res.returnCode === -401001) {
      layer.confirm(res.returnMsg, {
        btn: ['确定', '取消'] }, function () {
        formObj.isIgnoreSameOrder = 1;
        checkThePrice(formObj, function (res) {
          if (res.returnCode === 1) {
            if (res.data.nonFinish) {
              location.href = '/pay/toPayOrCharge.do?payMethod=2&orderId=' + res.data.orderInfoId;
            } else {
              location.href = '/ticketController/toTicketOrderSuccess.do?subOrderCode=' + res.data.orderId + '&orderId=' + res.data.orderInfoId;
            }
          } else if (res.returnCode === -400001) {
            alert('请先登录', { closeBtn: 0 }, function () {
              location.href = '/user/home.do';
            });
          } else {
            layer.open({
              title: '提示',
              content: res.returnMsg
            });
          }
        });
      });
    } else {
      layer.open({
        title: '提示',
        content: res.returnMsg
      });
    }
  }, "json");
}

module.exports = isComplete;

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!--确认订单信息-->\n<div class="confirm-order-msg">\n  <h5 class="palce-can-move">确认订单信息</h5>\n  <div class="final-order-msg">\n    <ul>\n      <li>\n        <span>预定门票</span>\n        <p>' +
((__t = ( data.itemName )) == null ? '' : __t) +
' --- ' +
((__t = ( data.ticketTypeName)) == null ? '' : __t) +
'</p>\n      </li>\n      <li>\n        <span>门票日期</span>\n        <p>' +
((__t = ( data.checkInDate )) == null ? '' : __t) +
' ' +
((__t = ( data.screeningName )) == null ? '' : __t) +
'</p>\n      </li>\n      <li>\n        <span>预定票数</span>\n        <p>' +
((__t = ( data.acount )) == null ? '' : __t) +
'</p>\n      </li>\n      <li class="t-o-c-player">\n\n      </li>\n      <li>\n        <span>支付方式</span>\n        <p class="ticketBalanceWay">' +
((__t = ( data.salePrice )) == null ? '' : __t) +
'</p>\n      </li>\n      <li>\n        <span>取消条款</span>\n        <p class="ticketCancelContent">' +
((__t = ( data.salePrice )) == null ? '' : __t) +
'</p>\n      </li>\n      <li>\n        <span>订单价格</span>\n        <p>' +
((__t = ( data.salePrice )) == null ? '' : __t) +
'</p>\n      </li>\n    </ul>\n  </div>\n  <div class="confirm-msg-bot">\n    <button class="confirm-order">确认</button>\n    <button class="cancel-order">取消</button>\n  </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(80);
__webpack_require__(81);
__webpack_require__(82);
__webpack_require__(83);

var Util = __webpack_require__(0),
    tipShowAndHide = Util.tipShowAndHide,
    roomInfoTipTmpl = __webpack_require__(84),
    priceDetailTipTmpl = __webpack_require__(85),
    orderClauseTipTmpl = __webpack_require__(86),
    multiBreakfastDetailTipTmpl = __webpack_require__(87),
    setDataForOrderClauseTd = function setDataForOrderClauseTd(orderClauseTd, pList) {
	var dataObj = {},
	    clauses = [];

	for (var i = 0; i < pList.length; i++) {
		var reserveShowArr = pList[i].reserveShow.split(/[|;]/);
		for (var j = 0; j < reserveShowArr.length; j++) {
			var o = reserveShowArr[j];
			~o.indexOf('限住') ? dataObj['限制晚数'] = o : ~o.indexOf('提前') ? dataObj['提前预订'] = o : ~o.indexOf('至少连住') ? dataObj['至少连住'] = o : ~o.indexOf('最大连住') ? dataObj['最大连住'] = o : ~o.indexOf('连住') ? dataObj['连住多晚'] = o : ~o.indexOf('时间') ? dataObj['限时预订'] = o : ~o.indexOf('间数') ? dataObj['限制间数'] = o : dataObj['无预订条款'] = o;
		}
	}

	for (key in dataObj) {
		if (key !== '无预订条款') clauses.push({ name: key, tip: dataObj[key] });
	}

	orderClauseTd[0].clauses = clauses;

	clauses.length === 0 ? orderClauseTd.html('无预订条款').removeClass('hp-order-clause') : clauses.length === 1 ? orderClauseTd.html(clauses[0].name) : orderClauseTd.html('复合条款');
},
    setDataForRoomTypeTd = function setDataForRoomTypeTd(roomTypeTd) {

	$(roomTypeTd).on('mouseover', function () {
		var _this = $(this);
		var hotelId = _this.attr("hotelid");
		var suppId = _this.attr("supplierid");
		var roomId = _this.attr("roomid");
		var roomInfo = window.roomInfoArr[hotelId + '_' + suppId + '_' + roomId];

		if (roomInfo) {
			var msg = roomInfoTipTmpl(roomInfo);
			tipShowAndHide(_this, msg, { area: '245px' });
		} else {
			var params = {
				hotelId: hotelId,
				suppId: suppId,
				roomId: roomId
			};

			$.post("/hotel/roomInfo.do", params, function (res) {
				if (res.success && res.content) {
					window.roomInfoArr[hotelId + '_' + suppId + '_' + roomId] = res.content;
					_this.trigger('mouseover');
				}
			}, 'noAnimation');
		}
	});
},
    initMarketingInfoTips = function initMarketingInfoTips(marketingTd) {
	marketingTd.on('mouseover', function () {
		var msg = decodeURIComponent(marketingTd.attr('data-tip'));
		tipShowAndHide($(this), msg);
	});
};

initOrderClauseTips = function initOrderClauseTips(orderClauseTd) {
	$(orderClauseTd).on('mouseover', function () {
		if (this.clauses.length) {
			var msg = orderClauseTipTmpl({ clauses: this.clauses });
			tipShowAndHide($(this), msg);
		}
	});
}, initHotelPriceTips = function initHotelPriceTips(hotelPriceTd, pList) {

	var isTimeLimitConfirSupplier = hotelPriceTd.closest('tr').find('.hp-store-status').text().indexOf('60秒确认') !== -1;
	var roomNum = $('.s-i-room-num').attr('data-value');

	hotelPriceTd.on('mouseover', function () {

		for (var i = 0; i < pList.length; i++) {
			var o = pList[i];

			if (o.status === 3) {
				o.statusText = '<span class="red">满房</span>';
			} else if (o.status === 2 || o.status === 6) {
				var showText = $(this).closest('tr').find('.hp-store-status').text();


				o.statusText = ~showText.indexOf('剩余') ? '<span class="green">剩' + roomNum + '</span>' : '<span class="purple">待查</span>';
			} else if (o.status === 0 || o.status === 5) {
				o.statusText = isTimeLimitConfirSupplier ? '<span class="blue">60秒确认</span>' : o.stock - o.sellStock < 1 ? '<span class="red">满房</span>' : '<span class="green">剩' + (o.stock - o.sellStock) + '</span>';
			} else if (o.status === 1) {
				o.statusText = isTimeLimitConfirSupplier ? '<span class="blue">60秒确认</span>' : '<span class="green">畅订</span>';
			}
		}

		var msg = priceDetailTipTmpl({ list: pList });

		tipShowAndHide($(this), msg, { area: '300px' });
	});
}, initMultiBreakfastTips = function initMultiBreakfastTips(multiBreakfastTd, pList) {
	multiBreakfastTd.on('mouseover', function () {
		var msg = multiBreakfastDetailTipTmpl({ list: pList });
		tipShowAndHide($(this), msg, { area: '200px' });
	});
}, initCancellationTips = function initCancellationTips(cancellationTd, pList) {
	cancellationTd.on('mouseover', function () {
		var _this = $(this),
		    msg = _this.attr('data-tip');

		tipShowAndHide($(this), msg);
	});
}, initSuppOtaChannelTips = function initSuppOtaChannelTips(suppOtaChannelTd, pList) {
	suppOtaChannelTd.on('mouseover', function () {
		var _this = $(this),
		    msg = _this.attr('data-tip');

		tipShowAndHide($(this), msg);
	});
}, initMultiBreakfastBookClick = function initMultiBreakfastBookClick(td) {
	td.on('click', function (e) {
		if ($(td).hasClass('disabled')) return;

		e.preventDefault();
		var that = $(this);

		confirm('该价格包含多种早餐类型，是否预订？', function (e) {
			$('.layui-layer-btn0').attr('href', that.attr('href'));
			$('.layui-layer-btn0').attr('target', '_blank');
			layer.closeAll();
		});
	});
}, initTips = function initTips(_table) {

	var trs = _table.find('tbody .hotel-price-tr');
	if (!window.roomInfoArr) {
		window.roomInfoArr = {};
	}

	for (var i = 0; i < trs.length; i++) {
		var tr = $(trs[i]),
		    pList = window.JSON.parse(tr.find('.nightlyPriceList').html()),
		    marketingTd = tr.find('.marketing-icon'),
		    orderClauseTd = tr.find('.hp-order-clause'),
		    cancellationTd = tr.find('.hp-cancel-clause'),
		    suppOtaChannelTd = tr.find('.supp-ota'),
		    multiBreakfastTd = tr.find('.multi-breakfast'),
		    hotelPriceTd = tr.find('.hp-currency'),
		    roomTypeTd = tr.find('.first-td').find('.hp-roomName'),
		    roomStatusTd = tr.find('.hp-store-status');

		setDataForOrderClauseTd(orderClauseTd, pList);
		setDataForRoomTypeTd(roomTypeTd);

		initMarketingInfoTips(marketingTd);
		initOrderClauseTips(orderClauseTd, pList);
		initCancellationTips(cancellationTd, pList);
		initSuppOtaChannelTips(suppOtaChannelTd, pList);
		initHotelPriceTips(hotelPriceTd, pList);
		initHotelPriceTips(roomStatusTd, pList);

		if (multiBreakfastTd.length) {
			initMultiBreakfastTips(multiBreakfastTd, pList);
			initMultiBreakfastBookClick(tr.find('.hp-order-btn'));
		}
	}
};

module.exports = {
	initTips: initTips
};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!--房型信息模板-->\r\n\r\n<div class="hotel-info-wrap">\r\n	<ul class="hotel-info-list">\r\n		';
 if(roomName && roomName !== ''){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<i class="iconfont icon-home"></i>\r\n			<h1 class="roomName">' +
((__t = ( roomName )) == null ? '' : __t) +
'</h1>\r\n		</li>\r\n		';
 } ;
__p += '\r\n\r\n		';
 if(floor && floor !== ''){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<label>楼层：</label>\r\n			<span>' +
((__t = ( floor )) == null ? '' : __t) +
'层</span>\r\n		</li>\r\n		';
 } ;
__p += '\r\n\r\n		';
 if(acreage && acreage !== ''){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<label>面积：</label>\r\n			<span>' +
((__t = ( acreage )) == null ? '' : __t) +
'm²</span>\r\n		</li>\r\n		';
 } ;
__p += '\r\n\r\n		';
 if(bedName && bedName !== ''){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<label>床型：</label>\r\n			<span>' +
((__t = ( bedName )) == null ? '' : __t) +
'</span>\r\n		</li>\r\n		';
 } ;
__p += '\r\n\r\n		';
 if(bedWidth && bedWidth !== ''){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<label>床型大小：</label>\r\n			<span>' +
((__t = ( bedWidth )) == null ? '' : __t) +
'm</span>\r\n		</li>\r\n		';
 } ;
__p += '\r\n\r\n		';
 if(maximize && maximize > 0){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<label>最大入住人数：</label>\r\n			<span>' +
((__t = ( maximize )) == null ? '' : __t) +
'人</span>\r\n		</li>\r\n		';
 } ;
__p += '\r\n\r\n		';
 if(facilities && facilities !== ''){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<label>房间设施：</label>\r\n			<span>' +
((__t = ( facilities )) == null ? '' : __t) +
'</span>\r\n		</li>\r\n		';
 } ;
__p += '\r\n\r\n		';
 if(comment && comment !== ''){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<label>房型备注：</label>\r\n			<span>' +
((__t = ( comment )) == null ? '' : __t) +
'</span>\r\n		</li>\r\n		';
 } ;
__p += '\r\n	</ul>\r\n</div>';

}
return __p
}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!--价格详情弹出框模板-->\r\n\r\n<div class="hli-price-detail-wrap">\r\n	<table>\r\n		<thead>\r\n			<tr>\r\n				<th>日期</th>\r\n				<th>价格【房态】</th>\r\n				<th>预订间数</th>\r\n			</tr>\r\n		</thead>\r\n		<tbody>\r\n			';
 for(var i = 0; i < list.length; i++){ var o = list[i]; ;
__p += '\r\n			<tr>\r\n				<td>' +
((__t = ( o.date )) == null ? '' : __t) +
'</td>\r\n				<td>￥' +
((__t = ( o.salePrice )) == null ? '' : __t) +
' /间 【' +
((__t = ( o.statusText )) == null ? '' : __t) +
'】</td>\r\n				<td>' +
((__t = ( o.occupancyStock )) == null ? '' : __t) +
'间</td>\r\n			</tr>\r\n			';
 } ;
__p += '\r\n		</tbody>\r\n	</table>\r\n</div>';

}
return __p
}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!--预订条款 tip 模板-->\r\n\r\n<div class="hli-order-clause-wrap">\r\n	<ul class="hli-order-clause-list">\r\n		';
 for (var i = 0; i < clauses.length; i++) { var clause = clauses[i] ;
__p += '\r\n		<li class="hli-order-clause-item">\r\n			<h2>' +
((__t = ( clause.name )) == null ? '' : __t) +
'</h2>\r\n			<p>' +
((__t = ( clause.tip )) == null ? '' : __t) +
'</p>\r\n		</li>\r\n		';
 } ;
__p += '\r\n	</ul>\r\n</div>';

}
return __p
}

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!--价格详情弹出框模板-->\r\n\r\n<div class="hli-price-detail-wrap">\r\n	<table>\r\n		<thead>\r\n			<tr>\r\n				<th>日期</th>\r\n				<th>早餐类型</th>\r\n			</tr>\r\n		</thead>\r\n		<tbody>\r\n			';
 for(var i = 0; i < list.length; i++){ var o = list[i]; ;
__p += '\r\n			<tr>\r\n				<td>' +
((__t = ( o.date )) == null ? '' : __t) +
'</td>\r\n				<td>' +
((__t = ( o.elongBreakFastName )) == null ? '' : __t) +
'</td>\r\n			</tr>\r\n			';
 } ;
__p += '\r\n		</tbody>\r\n	</table>\r\n</div>';

}
return __p
}

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!--打包价弹出框模板-->\r\n\r\n<div class="hli-package-confirm-wrap">\r\n	<!-- <p>\r\n		<span style="margin-right: 10px;">该产品为打包产品，需提供航班号</span>\r\n		<input type="text" style="width: 80px;padding: 0 5px;" class="hli-package-input" />\r\n		<span class="warning-info hidden">请输入正确的航班号</span>\r\n	</p> -->\r\n\r\n	<p style="line-height: 18px;margin-top: 20px;">该产品禁止在OTA（携程、艺龙、去哪儿、美团、飞猪等）各平台售卖，一经发现将终止与贵司合作并索取不低于2晚的赔付。请各位同行配合，谢谢！</p>\r\n\r\n	<p class="hli-package-btn-wrap">\r\n		<!-- <a href="' +
((__t = ( link )) == null ? '' : __t) +
'" target="_blank" class="hli-package-btn disabled">下一步</a> -->\r\n		<a href="' +
((__t = ( link )) == null ? '' : __t) +
'" target="_blank" class="hli-package-btn">下一步</a>\r\n	</p>\r\n</div>';

}
return __p
}

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(114);

var progressBarTmpl = __webpack_require__(115),
    _default = {
	elem: null,
	target: null,
	animateStart: function animateStart(animating) {
		$('.progress-outer').show();
	},

	end: function end() {
		that = this, $('.progress-outer').slideUp(function () {
			that.target.remove();
			that.elem.progress = null;
		});
	}
},
    progressBarFactory = function progressBarFactory(options) {
	if (options.elem && options.elem.progress) {
		var elem = $(options.elem);
		elem.show();
	} else {
		var target = $(progressBarTmpl(options));
		options.elem.progress = $.extend({}, options, { target: target });
		$(options.elem).html(target).show();
	}

	setTimeout(function () {
		options.elem.progress.animateStart();
	}, 10);

	return options.elem.progress;
};

module.exports = function (options) {
	return progressBarFactory($.extend({}, _default, options));
};

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '\r\n<div class="progress-wrap">\r\n    <div class="detail-price">\r\n        <div class="progress">\r\n            <div class="progress-bar shine">\r\n                <span><a class="circular"></a></span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n';

}
return __p
}

/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(45);
__webpack_require__(78);

var initTips = __webpack_require__(79).initTips,
    packageTmpl = __webpack_require__(88),
    getIsShowBoolean = function getIsShowBoolean(priceObj, frontEndParams) {
    var subIsShow1 = true,
        subIsShow2 = true,
        subIsShow3 = true,
        subIsShow4 = true,
        subIsShow5 = false,
        subIsShow6 = true,
        subIsShow7 = true,
        price1 = +$("#slp_1").val() || 0.01,
        price2 = +$("#slp_2").val() || 999999999,
        avePrice = priceObj.averagePriceRMB;

    if (frontEndParams.immediate) {
        subIsShow1 = false;

        if (~frontEndParams.immediate.indexOf('XS-0')) {
            subIsShow1 |= priceObj.roomStatus === 2;
        }

        if (~frontEndParams.immediate.indexOf('XS-1')) {
            subIsShow1 |= priceObj.isTimeLimitConfirSupplier === 0 && priceObj.confirm === true && priceObj.roomStatus != 3;
        }

        if (~frontEndParams.immediate.indexOf('XS-2')) {
            subIsShow1 |= priceObj.isTimeLimitConfirSupplier === 1;
        }
    }

    if (frontEndParams.canceltype) {
        subIsShow2 = false;

        if (~frontEndParams.canceltype.indexOf('canceltype-0')) {
            subIsShow2 |= priceObj.isCanCancle === 1;
        }

        if (~frontEndParams.canceltype.indexOf('canceltype-1')) {
            subIsShow2 |= priceObj.isCanCancle !== 1;
        }
    }

    if (frontEndParams.bedbreakfast) {
        if (~frontEndParams.bedbreakfast.indexOf('bedbreakfast-0')) {
            subIsShow3 &= priceObj.isHasSurchargeBref === 1;
        }

        if (~frontEndParams.bedbreakfast.indexOf('bedbreakfast-1')) {
            subIsShow3 &= priceObj.isHasSurchargeBed === 1;
        }
    }

    if (frontEndParams.priceRange) {
        subIsShow4 = false;

        var priceRangeArr = frontEndParams.priceRange.split(',');
        for (var i = 0; i < priceRangeArr.length; i++) {
            var p1 = +priceRangeArr[i].split('-')[0] || 1;
            var p2 = +priceRangeArr[i].split('-')[1] || 1;

            subIsShow4 |= p1 <= avePrice && avePrice <= p2;
        }
    }

    subIsShow5 |= price1 <= avePrice && avePrice <= price2;

    if (frontEndParams.isbook) {
        subIsShow5 = false;
        subIsShow5 |= priceObj.isBook;
    }

    if (frontEndParams.isHasBreakFast) {
        subIsShow7 = false;
        if (priceObj.rateTypeName == 'Drinking water' || priceObj.rateTypeName == 'Room only') {
            priceObj.isHasBreakFast = 0;
        }
        subIsShow7 |= priceObj.isHasBreakFast;
    }

    return subIsShow1 && subIsShow2 && subIsShow3 && subIsShow4 && subIsShow5 && subIsShow6 && subIsShow7;
},
    filterDataForEachType = function filterDataForEachType(list, frontEndParams) {
    if (!list) return;
    var rowSpan = 0;

    for (var i = 0; i < list.length; i++) {
        var o = list[i];

        for (var j = 0; j < o.roomTypePrices.length; j++) {
            var p = o.roomTypePrices[j];
            var isShow = getIsShowBoolean(p, frontEndParams);
            if (!isShow) {
                o.roomTypePrices.splice(j--, 1);
            }
        }

        rowSpan += o.roomTypePrices.length;

        if (o.roomTypePrices.length < 1) {
            list.splice(i--, 1);
        }
    }

    list.rowSpan = rowSpan;
},
    getFrontEndParams = function getFrontEndParams() {
    var params = {},
        immediateArr = $("input[data-attr='immediate']:checked"),
        canceltypeArr = $("input[data-attr='canceltype']:checked"),
        bedbreakfastArr = $("input[data-attr='bedbreakfast']:checked"),
        priceRangeArr = $("input[data-attr='priceRange']:checked"),
        immediateStr = [],
        canceltypeStr = [],
        bedbreakfastStr = [],
        priceRangeStr = [],
        isHasBreakFastStr = $("input[data-attr='isHasBreakFast']:checked").attr('data-value'),
        isbookStr = $("input[data-attr='isbook']:checked").attr('data-value');

    for (var i = 0; i < immediateArr.length; i++) {
        immediateStr.push($(immediateArr[i]).attr('data-value'));
    }for (var i = 0; i < canceltypeArr.length; i++) {
        canceltypeStr.push($(canceltypeArr[i]).attr('data-value'));
    }for (var i = 0; i < bedbreakfastArr.length; i++) {
        bedbreakfastStr.push($(bedbreakfastArr[i]).attr('data-value'));
    }for (var i = 0; i < priceRangeArr.length; i++) {
        priceRangeStr.push($(priceRangeArr[i]).attr('data-value'));
    }if (immediateStr.length) params.immediate = immediateStr.join(',');
    if (canceltypeStr.length) params.canceltype = canceltypeStr.join(',');
    if (bedbreakfastStr.length) params.bedbreakfast = bedbreakfastStr.join(',');
    if (priceRangeStr.length) params.priceRange = priceRangeStr.join(',');
    if (isHasBreakFastStr) params.isHasBreakFast = isHasBreakFastStr;
    if (isbookStr) params.isbook = isbookStr;

    return params;
},
    goToOrderConfirmPage = function goToOrderConfirmPage(_this) {
    var nightlyPriceList = JSON.parse(_this.find('.nightlyPriceList').html());
    var ifInvoice = nightlyPriceList && nightlyPriceList[0] && nightlyPriceList[0].ifInvoice;
    var priceStrs = _this.find('.hotelPriceStrs'),
        priceStrs_key = "hotelPriceStrs_" + +new Date(),
        params = ['staticInfoId=' + _this.attr('data-hotelid'), 'hotelId=' + _this.attr('data-hotelid'), 'supplierId=' + _this.attr('data-supplierid'), 'roomId=' + _this.attr('data-roomId'), 'breakFastId=' + _this.attr('data-breakFastId'), 'paymentType=' + _this.attr('data-paymentType'), 'rateType=' + _this.attr('data-rateType'), 'arriveStartTime=' + _this.attr('data-arriveStartTime'), 'arriveEndTime=' + _this.attr('data-arriveEndTime'), 'checkOutTime=' + _this.attr('data-checkOutTime'), 'isQueryPrice=true', _this.attr('data-marketingStr'), 'startDate=' + $.queryingHotelParams.startDate, 'endDate=' + $.queryingHotelParams.endDate, 'citytype=' + $.queryingHotelParams.type || '0', 'adultNum=' + $.queryingHotelParams.adultNum, 'childrenNum=' + $.queryingHotelParams.childrenNum, 'childrenAgeStr=' + $.queryingHotelParams.childrenAgesStr, 'roomNum=' + $.queryingHotelParams.selRoomNum, 'ch=' + $.queryingHotelParams.type || '0', 'hotelPriceStrsKey=' + priceStrs_key, 'isTicket=' + (!ifInvoice || ifInvoice === 1 || ifInvoice === 3 ? 0 : 1)];

    sessionStorage.setItem(priceStrs_key, priceStrs.html());

    var $hotelPolicies = $(".hotelPolicies");
    if ($hotelPolicies && $hotelPolicies.html()) {
        sessionStorage.setItem(priceStrs_key + '_policies', window.JSON.stringify($hotelPolicies.html()));
    }

    var $fees_mandatory = $(".fees_mandatory");
    if ($fees_mandatory && $fees_mandatory.html()) {
        sessionStorage.setItem(priceStrs_key + '_mandatory', window.JSON.stringify($fees_mandatory.html()));
    }
    var $fees_optional = $(".fees_optional");
    if ($fees_optional && $fees_optional.html()) {
        sessionStorage.setItem(priceStrs_key + '_optional', window.JSON.stringify($fees_optional.html()));
    }

    var url = "/order/orderConfirm.do?" + params.join('&');


    return url;
},
    initTdMouseEnter = function initTdMouseEnter(_table) {
    _table.find('td').not('.first-td').on('mouseenter', function () {
        $(this).closest('tr').find('td').not('.first-td').addClass('td-hover');
    }).on('mouseleave', function () {
        $(this).closest('tr').find('td').not('.first-td').removeClass('td-hover');
    });
};

initOrderClick = function initOrderClick(_table) {
    _table.find('.hp-order-btn').not('.disabled').on('click', function () {
        console.log('=====');
        var _this = $(this);

        _this.attr("href", goToOrderConfirmPage(_this));
    });

    $(document).delegate('.hli-package-input', 'input paste keyup', function () {
        var _this = $(this);
        var value = _this.val().replace(/^\s+|\s+$/g, '');
        var nextClickBtn = _this.closest('.hli-package-confirm-wrap').find('.hli-package-btn');
        var rule = /.*[^\s]/;

        rule.test(value) ? nextClickBtn.removeClass('disabled') : nextClickBtn.addClass('disabled');
    });

    $(document).delegate('.hli-package-btn', 'click', function () {
        if ($(this).hasClass('disabled')) {
            var warningInfo = $(this).closest('.hli-package-confirm-wrap').find('.warning-info');
            warningInfo.removeClass('hidden');

            setTimeout(function () {
                warningInfo.addClass('hidden');
            }, 2000);

            return false;
        }

        layer.closeAll();
    });
};

var initRoomTypeNameClick = function initRoomTypeNameClick(_table) {
    var url = $.pageFrom;
    if (url && url == 'hotelDetail') {
        _table.find(".show-more-td2").on("click", function () {

            var _this = $(this);
            var typeText = _this.attr('data-type');
            var typeTd = _this.closest('table').find('.first-td[data-type=' + typeText + ']');
            var spanRow = +typeTd.attr('rowspan');
            var thisTd = _this.closest('td');
            var dragIcon = _this.find('.room-type-icon');
            var childIcon = _this.closest('tr').find('.room-type-icon');
            var dataIndex = _this.attr('data-index');
            var sameRoomTypeTr;
            var sameRoomTypeTrs = [];

            if (dragIcon.length) {

                if (dragIcon.hasClass('room-type-down')) {
                    $(".borderTr" + dataIndex).removeClass('click-btn-css');
                    $(this).find('span').html('收起');
                    dragIcon.removeClass('room-type-down').addClass('room-type-up');
                } else {
                    $(".borderTr" + dataIndex + ":gt(2)").addClass('click-btn-css');
                    $(this).find('span').html('更多价格');
                    dragIcon.removeClass('room-type-up').addClass('room-type-down');

                    $('html,body').animate({
                        scrollTop: $(".firstBorderTr" + dataIndex).offset().top - 90
                    }, 200);
                }
            }
        });
    } else {
        _table.find(".hp-roomName").on('click', function () {
            var _this = $(this),
                typeText = _this.attr('data-type'),
                typeTd = _this.closest('table').find('.first-td[data-type=' + typeText + ']'),
                spanRow = +typeTd.attr('rowspan'),
                thisTd = _this.closest('td'),
                dragIcon = _this.find('.room-type-icon'),
                sameRoomTypeTr,
                sameRoomTypeTrs = [];

            if (dragIcon.length) {
                sameRoomTypeTr = _this.closest('tr').next('.auto-hide-tr');

                while (sameRoomTypeTr.length) {
                    sameRoomTypeTrs.push(sameRoomTypeTr);
                    sameRoomTypeTr = sameRoomTypeTr.next('.auto-hide-tr');
                }

                if (dragIcon.hasClass('room-type-down')) {
                    $.each(sameRoomTypeTrs, function (i, o) {
                        setTimeout(function () {
                            $(o).find('td').removeClass('hidden');
                        }, 50);

                        $(o).slideDown('fast');
                    });

                    setTimeout(function () {
                        dragIcon.removeClass('room-type-down').addClass('room-type-up');
                    }, 50);

                    if (typeText === 'recommend') {
                        typeTd.attr('rowspan', spanRow + sameRoomTypeTrs.length);
                    }

                    thisTd.removeClass('force-border');
                } else {
                    $.each(sameRoomTypeTrs, function (i, o) {
                        setTimeout(function () {
                            $(o).find('td').addClass('hidden');
                        }, 80);

                        $(o).slideUp('fast');
                    });

                    setTimeout(function () {
                        dragIcon.removeClass('room-type-up').addClass('room-type-down');

                        if (typeText === 'recommend') {
                            typeTd.attr('rowspan', spanRow - sameRoomTypeTrs.length);
                        }
                    }, 80);

                    thisTd.addClass('force-border');
                }
            }
        });
    }
},
    filterPriceAndFillIntoTable = function filterPriceAndFillIntoTable(priceTableTmpl, _table, firstQuery) {
    var tableList = _table || $(".hli-expand-inner");
    for (var i = 0; i < tableList.length; i++) {
        var item = tableList[i];

        var priceList = $.extend(true, {}, item.priceList),
            wraper = $(item).closest('.hl-item').find('.hli-price-list-wrap'),
            frontEndParams = getFrontEndParams(),
            noPriceMsg = '<div class="hli-error-msg">无相关价格！</div>',
            _table;

        if (item.priceList) {
            filterDataForEachType(priceList.roomTypeBasesRecommend, frontEndParams);
            filterDataForEachType(priceList.roomTypeBases, frontEndParams);

            if ((!priceList.roomTypeBasesRecommend || !priceList.roomTypeBasesRecommend.length) && (!priceList.roomTypeBases || !priceList.roomTypeBases.length) && !firstQuery) {
                wraper.html(noPriceMsg);
            } else {
                if (!priceList.roomTypeBasesRecommend) priceList.roomTypeBasesRecommend = [];
                if (!priceList.roomTypeBases) priceList.roomTypeBases = [];

                try {
                    var urlParams = new URLSearchParams(window.location.search);
                    var paramValue = urlParams.get("ch");
                    priceList.ch = paramValue;
                } catch (error) {
                    console.log("error", error);
                    priceList.ch = 1;
                }

                _table = $(priceTableTmpl(priceList));
                wraper.html(_table);

                initTips(_table);
                initTdMouseEnter(_table);
                initOrderClick(_table);
                initRoomTypeNameClick(_table);
            }
        } else {
            if (!firstQuery) {
                wraper.html(noPriceMsg);
            }
        }
    }
};

module.exports = filterPriceAndFillIntoTable;

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {


function getDaysForeachMonth(year) {
	return new Array(31, _leap(year), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
}

function _leap(year) {
	return 28 + (year % 4 == 0 && year % 100 != 0 || year % 400 == 0 ? 1 : 0);
}

function getOneMonthHTML(y, m, dayCount) {

	var week = new Date(y + '/' + m + '/1').getDay(),
	    rows = Math.ceil((dayCount + week) / 7),
	    total = 7 * rows,
	    arr = [],
	    monthStr = y + '/' + m,
	    headStr = y + '年' + m + '月',
	    bodyStr = '',
	    oneMonthTemplate = __webpack_require__(160);

	for (var i = 0; i < week; i++) {
		arr.push('null');
	}
	for (var i = 1; i <= dayCount; i++) {
		arr.push(new Date(y + '/' + m + '/' + i).Format('yyyy/MM/dd'));
	}
	for (var i = 0; i < total - dayCount - week; i++) {
		arr.push('null');
	}for (var i = 0; i < rows; i++) {
		bodyStr += '<tr class="calendar-p-row">';
		for (var j = 0; j < 7; j++) {
			bodyStr += getTDStr(arr[i * 7 + j]);
		}
		bodyStr += '</tr>';
	}

	return oneMonthTemplate({
		month: monthStr,
		head: headStr,
		body: bodyStr
	});
}

function getTDStr(d) {

	var tdStr = '';

	if (d === 'null') {
		tdStr = '<td><div class="cp-td-inner disabled"></div></td>';
	} else {
		var todayZeroTimeStamp = new Date(new Date().Format('yyyy/MM/dd') + ' 00:00:00'),
		    clazz = new Date(d) < todayZeroTimeStamp ? ' disabled' : '';

		tdStr = '<td>' + '<div class="cp-td-inner disabled' + clazz + '"  data-day="' + d + '">' + '<p class="calendar-p-day-num">' + _getDay(d) + '</p>' + '</div>' + '</td>';
	}

	return tdStr;
}

function _getDay(d) {

	var dStr = '';

	try {
		dStr = d.split('/')[2];
	} catch (e) {}

	return dStr;
}

function buildMonths(y, m) {

	var today = new Date(),
	    thisYear = today.getFullYear(),
	    thisMonth = today.getMonth(),
	    dayArr = getDaysForeachMonth(y || thisYear);

	if (y && m) {
		return getOneMonthHTML(y, m, dayArr[m - 1]);
	} else {
		var monthStr1 = getOneMonthHTML(thisYear, thisMonth + 1, dayArr[thisMonth]),
		    monthStr2 = thisMonth == 11 ? getOneMonthHTML(thisYear + 1, 1, 31) : getOneMonthHTML(thisYear, thisMonth + 2, dayArr[thisMonth + 1]);

		return monthStr1 + monthStr2;
	}
}

module.exports = function (y, m) {
	return buildMonths(y, m);
};

/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(45);

var Util = __webpack_require__(0),
    filterPriceAndFillIntoTable = __webpack_require__(119),
    testData = __webpack_require__(157),
    progressBar = __webpack_require__(113),
    hotelPolicyTmpl = __webpack_require__(158),
    hotelIntroductionTmpl = __webpack_require__(159),
    setMarketing = function setMarketing(o, p, j) {
	var copy = $.extend(true, {}, p);

	p.isHasMarketing = 0;
	p.marketing = null;
	p.marketingStr = 'isHasMarketing=0';

	if (copy.marketing) {
		var giftStartTime = copy.marketing.startTime.slice(0, 11) + '00:00:00',
		    giftEndTime = copy.marketing.endTime.slice(0, 11) + '23:59:59',
		    marketingPrice = copy.marketing.marketingPrice || 0,
		    totalPrice = 0;

		if (copy.marketing.isPack) {
			if (copy.marketing.pricingMethod) {
				for (var k = 0; k < copy.nightlyPriceList.length; k++) {
					totalPrice += copy.nightlyPriceList[k].salePrice;
				}

				copy.totalPriceRMB = totalPrice * parseInt($.queryingHotelParams.selRoomNum) + marketingPrice;
			} else {
				for (var k = 0; k < copy.nightlyPriceList.length; k++) {
					var q = copy.nightlyPriceList[k];

					if (new Date(giftStartTime) < new Date(q.date) && new Date(q.date) < new Date(giftEndTime)) {
						q.salePrice += marketingPrice;
					}

					totalPrice += q.salePrice;
				}

				copy.totalPriceRMB = totalPrice * parseInt($.queryingHotelParams.selRoomNum);
			}
		}

		copy.marketingStr = 'isHasMarketing=1&marketingPrice=' + marketingPrice + '&startTime=' + copy.marketing.startTime + '&endTime=' + copy.marketing.endTime;

		copy.marketing.isPack ? o.roomTypePrices.splice(j++ + 1, 0, copy) : o.roomTypePrices.splice(j, 1, copy);
	}

	return j;
},
    setNewAttrForPriceData = function setNewAttrForPriceData(res, type) {

	if (res.data[type]) {
		var rowSpan = 0;
		var roomNum = $('.s-i-room-num').attr('data-value');

		for (var i = 0; i < res.data[type].length; i++) {
			var o = res.data[type][i];

			rowSpan += o.roomTypePrices.length;

			for (var j = 0; j < o.roomTypePrices.length; j++) {
				var p = o.roomTypePrices[j];

				p.cancellationText = p.isCanCancle ? '可取消' : '不可取消';
				if (p.roomStatus === 3) {
					p.roomStatusText = '<span class="red">满房</span>';
				} else if (p.roomStatus === 2 || p.roomStatus === 6) {
					if (window.temporaryDemand1470) {
						p.roomStatusText = !!~$.inArray(parseInt(p.supplierId), window.temporaryDemand1470) ? '<span class="green">剩余[' + roomNum + ']</span>' : '<span class="purple">待查</span>';
					} else {
						p.roomStatusText = '<span class="purple">待查</span>';
					}
				} else if (p.roomStatus === 0 || p.roomStatus === 5) {
					p.roomStatusText = p.isTimeLimitConfirSupplier === 1 ? '<span class="blue">60秒确认</span>' : '剩余库存';
				} else if (p.roomStatus === 1) {
					p.roomStatusText = p.isTimeLimitConfirSupplier === 1 ? '<span class="blue">60秒确认</span>' : '<span class="green">畅订</span>';
				}

				if (p.roomStatusText === '剩余库存') {
					var stockArr = [];
					for (var k = 0; k < p.nightlyPriceList.length; k++) {
						var q = p.nightlyPriceList[k];
						if (q.status === 1) {
							q.stock = 999;
						}
						stockArr.push(q.stock - q.sellStock);
					}

					var minStock = Math.min.apply(this, stockArr);
					p.roomStatusText = minStock < 1 ? '<span class="red">满房</span>' : '<span class="green">剩余[' + Math.min.apply(this, stockArr) + ']</span>';
				}

				if (!p.isHasMarketing) p.isHasMarketing = 0;
				j = setMarketing(o, p, j);
			}
		}

		res.data[type].rowSpan = rowSpan;
	}
},
    initPriceData = function initPriceData(res) {
	if (res.data) {
		setNewAttrForPriceData(res, 'roomTypeBasesRecommend');
		setNewAttrForPriceData(res, 'roomTypeBases');
	}
},
    queryPriceFunc = function queryPriceFunc(that, priceTableTmpl, hotelItem, res, firstQuery, progress) {
	if (progress && !firstQuery) {
		progress.end();

		setTimeout(function (param) {
			$('.search-line-btn').removeClass('disabled');
			$('.s-i-dates-input').removeClass('disabled');
			$('.s-i-dates-input').prop('disabled', false);
		}, 200);
	}

	that.priceList = res.data || [];

	if (res.returnCode === 1) {
		var lowestPriceWrap = hotelItem.find('.hli-lowest-price-wrap');

		if (lowestPriceWrap.length && lowestPriceWrap.html().indexOf('起') === -1 && !firstQuery) {
			var lowestPriceStr = res.data.priceMin ? '￥<span class="hli-lowest-price">' + res.data.priceMin + '</span>起' : '满房&nbsp;&nbsp;&nbsp;&nbsp;';

			hotelItem.find('.hli-lowest-price-wrap').html(lowestPriceStr).removeClass('hidden');
		}

		initPriceData(res);
		that.priceList = res.data;
		filterPriceAndFillIntoTable(priceTableTmpl, $(that), firstQuery);
	} else if (res.returnCode === -400001) {
		hotelItem.find('.hli-price-list-wrap').html('');
	} else {
		var parent = $(that).closest('.hl-item').find('.hli-price-list-wrap');
		var tmpStr = '<div class="hli-error-msg">' + res.errinfo + '</div>';

		hotelItem.find('.hli-lowest-price-wrap').html(res.errinfo);

		parent.html(tmpStr);
	}
},
    queryPrices = function queryPrices(that, getParams, priceTableTmpl) {
	that.queryingPrice = true;

	var p = typeof getParams === 'function' ? getParams() : getParams,
	    hotelItem = $(that).closest('.hl-item'),
	    params = {
		hotelId: $(that).attr('data-hotelid') || p.infoIds,
		checkInDate: p.startDate,
		checkOutDate: p.endDate,
		roomNum: p.selRoomNum,
		adultNum: p.adultNum,
		childrenNum: p.childrenNum,
		childrenAgesStr: p.childrenAgesStr,

		isSearchSurcharge: $(".d-s-item[data-attr='bedbreakfast']:checked").length ? 1 : 0
	};

	if (!params.hotelId) {
		alert("酒店查价没有带 hotelId 参数！");
		return false;
	}

	$('.search-line-btn').addClass('disabled');
	$('.s-i-dates-input').addClass('disabled');
	$('.s-i-dates-input').prop('disabled', true);

	var loadingStr = '<div class="fzg-loading-wrap">' + '<img src="https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1514022140288.gif"/>' + '</div>';

	hotelItem.find('.hli-price-list-wrap').html(loadingStr);

	var progress = progressBar({
		elem: hotelItem.find('.progress-outer')[0]
	});

	$.post('/hotel/getHotelPriceListInStock.do', params, function (res) {

		queryPriceFunc(that, priceTableTmpl, hotelItem, res, true, progress);

		if (res.returnCode === 1) {

			$.post('/hotel/getHotelPriceRealTime.do', params, function (result) {

				if (result.returnCode === 1) {
					var _res$data = res.data,
					    bases = _res$data.roomTypeBases,
					    recommend = _res$data.roomTypeBasesRecommend;


					if (result && result.data) {
						var _result$data = result.data,
						    roomTypeBases = _result$data.roomTypeBases,
						    roomTypeBasesRecommend = _result$data.roomTypeBasesRecommend;

						if (roomTypeBasesRecommend && roomTypeBasesRecommend.length && roomTypeBasesRecommend[0].roomTypePrices && roomTypeBasesRecommend[0].roomTypePrices.length) {
							var roomTypePricesOne = roomTypeBasesRecommend[0].roomTypePrices[0];
							checkinPolicy(roomTypePricesOne);
						}

						var mergedArray = void 0;
						var mergedArrayRecommend = void 0;
						if (roomTypeBases) {
							if (bases) {
								mergedArrayRecommend = res.data.roomTypeBasesRecommend.concat(roomTypeBasesRecommend);
								mergedArrayRecommend.sort(function (a, b) {
									return a.roomTypePrices[0].totalPriceRMB - b.roomTypePrices[0].totalPriceRMB;
								});
								if (mergedArrayRecommend.length == 2) {
									mergedArrayRecommend = mergedArrayRecommend.slice(0, 1);
								} else if (mergedArrayRecommend.length == 4) {
									mergedArrayRecommend = mergedArrayRecommend.slice(0, 2);
								} else if (mergedArrayRecommend.length == 3) {
									if (mergedArrayRecommend[0].roomTypePrices.length == 2) {
										mergedArrayRecommend = mergedArrayRecommend.slice(0, 1);
									} else {
										mergedArrayRecommend = mergedArrayRecommend.slice(0, 2);
									}
								} else if (mergedArrayRecommend.length == 1) {
									mergedArrayRecommend = mergedArrayRecommend.slice(0, 1);
								} else {
									mergedArrayRecommend = mergedArrayRecommend.slice(0, 2);
								}
								res.data.roomTypeBasesRecommend = mergedArrayRecommend;

								mergedArray = res.data.roomTypeBases.concat(roomTypeBases);

								var newArr = [];
								for (var i = mergedArray.length - 1; i >= 0; i--) {
									if (mergedArray[i].roomName == '其他 Other') {
										newArr.push(mergedArray[i]);
										mergedArray.splice(i, 1);
									}
								}
								if (newArr.length > 1) {
									newArr[0].roomTypePrices = newArr[0].roomTypePrices.concat(newArr[1].roomTypePrices);
									newArr.splice(1, 1);
									newArr[0].roomTypePrices.sort(function (a, b) {
										return a.totalPriceRMB - b.totalPriceRMB;
									});
								}

								mergedArray = mergedArray.concat(newArr);

								mergedArray.sort(function (a, b) {
									return a.roomTypePrices[0].totalPriceRMB - b.roomTypePrices[0].totalPriceRMB;
								});
								res.data.roomTypeBases = mergedArray;

								queryPriceFunc(that, priceTableTmpl, hotelItem, res, null, progress);
							} else {
								queryPriceFunc(that, priceTableTmpl, hotelItem, result, null, progress);
							}
						} else {
							queryPriceFunc(that, priceTableTmpl, hotelItem, res, null, progress);
						}
					} else {
						queryPriceFunc(that, priceTableTmpl, hotelItem, res, null, progress);
					}
				} else {
					queryPriceFunc(that, priceTableTmpl, hotelItem, res, null, progress);
				}

				progress.end();
			}, 'noAnimation');
		} else {
			progress.end();
			if (res.returnCode === -400001) {
				$('.no-login-box').show();
			}
		}
	}, 'noAnimation');
};

var checkinPolicy = function checkinPolicy(roomTypePrices) {
	console.log("roomTypePrices", roomTypePrices);

	var o = roomTypePrices;
	if ($('#checkin-policy-content .hotel-detail-item').length === 0) {
		if (o.policies || o.checkInInstructions || o.specialCheckInInstructions) {
			var tip = $(".hotel-detail-content-tip").html();
			if (tip && tip !== "无" && o.specialCheckInInstructions) {
				if (o.specialCheckInInstructions.indexOf(tip) !== -1) {
					$(".hotel-detail-item-tip").hide();
				}
			}

			var introduction = $(".hotel-detail-content-introduction").html();
			if (introduction && o.checkInInstructions) {
				if (o.checkInInstructions.indexOf(introduction) !== -1) {
					$(".hotel-detail-item-introduction").hide();
				}
			}

			$('#checkin-policy-content').html(hotelPolicyTmpl({ o: o }));

			if (o.addAttrMap && (o.addAttrMap.descriptions_amenities || o.addAttrMap.descriptions_dining || o.addAttrMap.descriptions_renovations || o.addAttrMap.descriptions_businessAmenities || o.addAttrMap.descriptions_rooms || o.addAttrMap.descriptions_location || o.addAttrMap.descriptions_headline)) {
				var info = '';

				if (o.addAttrMap.descriptions_amenities) {
					info += o.addAttrMap.descriptions_amenities;
				}
				if (o.addAttrMap.descriptions_dining) {
					info += '<br /><br />' + o.addAttrMap.descriptions_dining;
				}
				if (o.addAttrMap.descriptions_renovations) {
					info += '<br /><br />' + o.addAttrMap.descriptions_renovations;
				}
				if (o.addAttrMap.descriptions_businessAmenities) {
					info += '<br /><br />' + o.addAttrMap.descriptions_businessAmenities;
				}
				if (o.addAttrMap.descriptions_rooms) {
					info += '<br /><br />' + o.addAttrMap.descriptions_rooms;
				}
				if (o.addAttrMap.descriptions_location) {
					info += '<br /><br />' + o.addAttrMap.descriptions_location;
				}
				if (o.addAttrMap.descriptions_headline) {
					info += '<br /><br />' + o.addAttrMap.descriptions_headline;
				}

				$('#hotel-introduction').html(hotelIntroductionTmpl({ o: info }));
			}
		}
	}
};

module.exports = queryPrices;

/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports) {


module.exports = { "dataList": null, "returnCode": 1, "returnMsg": "请求成功！", "data": {
        "hotelId": 37976,
        "type": 1,
        "roomTypeBasesRecommend": [{ "hotelId": "37976", "countryId": 70009, "roomName": "豪华皇室套房", "roomTypePrices": [{ "supplierId": "164321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "608167", "roomId": "1047544", "roomName": "豪华皇室套房", "roomTypeParentId": 24261, "roomTypeParentName": "豪华皇室大床套房", "roomStatus": 5, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "1", "occupancyStock": 1, "price": 2097.90, "salePrice": 1700.80400, "salePricePriceStrategy": 1748.0, "skuId": -1, "stock": 1, "sellStock": 0, "status": 5, "clauses": [{ "itemId": 608167, "staticInfoId": 37976, "skuId": -1, "clauseType": 1, "clauseNumber": 2, "clauseDate": 3, "clauseTime": 10, "cancelFineType": 1, "cancelFine": 0.0, "default": false }], "discount": -47.195999999999997953636921010911464691162109375, "reserveShow": "该天配额类型没有预订条款！" }, { "date": "2018-01-26", "formulaType": "1", "occupancyStock": 1, "price": 2412.90, "salePrice": 1955.73000, "salePricePriceStrategy": 2010.0, "skuId": -1, "stock": 1, "sellStock": 0, "status": 5, "clauses": [{ "itemId": 608167, "staticInfoId": 37976, "skuId": -1, "clauseType": 1, "clauseNumber": 2, "clauseDate": 3, "clauseTime": 10, "cancelFineType": 1, "cancelFine": 0.0, "default": false }], "discount": -54.27000000000000312638803734444081783294677734375, "reserveShow": "该天配额类型没有预订条款！" }], "totalPrice": 4510.80, "averagePrice": 2255.4, "taxesAndFees": 0, "extraPersonFees": 0, "totalPriceRMB": 3656.53000000000020008883439004421234130859375, "averagePriceRMB": 1828.2670, "taxesAndFeesRMB": 0, "extraPersonFeesRMB": 0, "cancellationType": 1, "clause": "2_3_10_1_0.0", "cancellationDesc": "入住前3天10点不可修改或取消，罚金为全段", "currentAlloment": -1, "maxPersonNum": 2, "breakFastName": "无早", "breakFastId": "7", "isAddBreakfast": false, "breakfastPriceRMB": 0, "breakfastPriceBase": 0, "bedTypeList": [{ "bedTypeId": "34", "bedTypeName": "大床[无早]" }], "paymentType": 0, "rateType": "1476977", "rateTypeName": "净房-弹性房价", "isBook": true, "showSalePrice": 1700.8, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"1\",\"occupancyStock\":1,\"price\":2097.90,\"salePrice\":1700.80400,\"salePricePriceStrategy\":1748.0,\"skuId\":-1,\"stock\":1,\"sellStock\":0,\"status\":5,\"clauses\":[{\"itemId\":608167,\"staticInfoId\":37976,\"skuId\":-1,\"clauseType\":1,\"clauseNumber\":2,\"clauseDate\":3,\"clauseTime\":10,\"cancelFineType\":1,\"cancelFine\":0.0,\"default\":false}],\"discount\":-47.195999999999997953636921010911464691162109375,\"reserveShow\":\"该天配额类型没有预订条款！\"},{\"date\":\"2018-01-26\",\"formulaType\":\"1\",\"occupancyStock\":1,\"price\":2412.90,\"salePrice\":1955.73000,\"salePricePriceStrategy\":2010.0,\"skuId\":-1,\"stock\":1,\"sellStock\":0,\"status\":5,\"clauses\":[{\"itemId\":608167,\"staticInfoId\":37976,\"skuId\":-1,\"clauseType\":1,\"clauseNumber\":2,\"clauseDate\":3,\"clauseTime\":10,\"cancelFineType\":1,\"cancelFine\":0.0,\"default\":false}],\"discount\":-54.27000000000000312638803734444081783294677734375,\"reserveShow\":\"该天配额类型没有预订条款！\"}]", "bedTypeStrs": "{\"bedTypeId\":\"34\",\"bedTypeName\":\"大床[无早]\"}", "bedTypeName": "大床[无早]", "canBookDays": 2, "chanageRoomNum": true, "book": true, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1047544", "roomName": "豪华皇室套房", "roomTypeParentId": 24261, "roomTypeParentName": "豪华皇室大床套房", "roomStatus": 1, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "1", "occupancyStock": 1, "price": 2098, "salePrice": 1712, "nowPrice": 0, "skuId": 1081249, "stock": 0, "sellStock": 0, "status": 1, "clauses": [{ "clauseId": 4631412, "itemId": 41593, "staticInfoId": 37976, "skuId": 167396, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }, { "date": "2018-01-26", "formulaType": "1", "occupancyStock": 1, "price": 1750, "salePrice": 1429, "nowPrice": 0, "skuId": 1081250, "stock": 0, "sellStock": 0, "status": 1, "clauses": [{ "clauseId": 4631413, "itemId": 41593, "staticInfoId": 37976, "skuId": 167397, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }], "totalPrice": 3848.00, "averagePrice": 1924.00, "totalPriceRMB": 3141, "totalPriceRMBBeforePriceStrategy": 3141, "totalNowPriceRMB": 0, "averagePriceRMB": 1570.50, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "无餐", "breakFastId": "7", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "34", "bedTypeName": "大床[无餐]" }], "paymentType": 0, "rateType": "1", "rateTypeName": "无早", "isBook": true, "showSalePrice": 1712.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"1\",\"occupancyStock\":1,\"price\":2098,\"salePrice\":1712,\"nowPrice\":0,\"skuId\":1081249,\"stock\":0,\"sellStock\":0,\"status\":1,\"clauses\":[{\"clauseId\":4631412,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":167396,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"},{\"date\":\"2018-01-26\",\"formulaType\":\"1\",\"occupancyStock\":1,\"price\":1750,\"salePrice\":1429,\"nowPrice\":0,\"skuId\":1081250,\"stock\":0,\"sellStock\":0,\"status\":1,\"clauses\":[{\"clauseId\":4631413,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":167397,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"}]", "bedTypeStrs": "{\"bedTypeId\":\"34\",\"bedTypeName\":\"大床[无餐]\"}", "bedTypeName": "大床[无餐]", "canBookDays": 2, "chanageRoomNum": true, "book": true, "confirm": true }] }],
        "roomTypeBases": [{ "hotelId": "37976", "countryId": 70009, "roomName": "豪华路凼景观皇室套房", "roomTypePrices": [{ "supplierId": "164321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "608167", "roomId": "1465959", "roomName": "豪华路凼景观皇室套房", "roomStatus": 5, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "1", "occupancyStock": 1, "price": 2255.40, "salePrice": 1828.26700, "salePricePriceStrategy": 1879.0, "skuId": -1, "stock": 1, "sellStock": 0, "status": 5, "clauses": [{ "itemId": 608167, "staticInfoId": 37976, "skuId": -1, "clauseType": 1, "clauseNumber": 2, "clauseDate": 3, "clauseTime": 10, "cancelFineType": 1, "cancelFine": 0.0, "default": false }], "discount": -50.73299999999999698729880037717521190643310546875, "reserveShow": "该天配额类型没有预订条款！" }, { "date": "2018-01-26", "formulaType": "1", "occupancyStock": 1, "price": 2675.40, "salePrice": 2167.84400, "salePricePriceStrategy": 2228.0, "skuId": -1, "stock": 1, "sellStock": 0, "status": 5, "clauses": [{ "itemId": 608167, "staticInfoId": 37976, "skuId": -1, "clauseType": 1, "clauseNumber": 2, "clauseDate": 3, "clauseTime": 10, "cancelFineType": 1, "cancelFine": 0.0, "default": false }], "discount": -60.15599999999999880628820392303168773651123046875, "reserveShow": "该天配额类型没有预订条款！" }], "totalPrice": 4930.80, "averagePrice": 2465.4, "taxesAndFees": 0, "extraPersonFees": 0, "totalPriceRMB": 3996.11000000000012732925824820995330810546875, "averagePriceRMB": 1998.0555, "taxesAndFeesRMB": 0, "extraPersonFeesRMB": 0, "cancellationType": 1, "clause": "2_3_10_1_0.0", "cancellationDesc": "入住前3天10点不可修改或取消，罚金为全段", "currentAlloment": -1, "maxPersonNum": 2, "breakFastName": "无早", "breakFastId": "7", "isAddBreakfast": false, "breakfastPriceRMB": 0, "breakfastPriceBase": 0, "bedTypeList": [{ "bedTypeId": "34", "bedTypeName": "大床[无早]" }], "paymentType": 0, "rateType": "1476977", "rateTypeName": "净房-弹性房价", "isBook": true, "showSalePrice": 1828.27, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"1\",\"occupancyStock\":1,\"price\":2255.40,\"salePrice\":1828.26700,\"salePricePriceStrategy\":1879.0,\"skuId\":-1,\"stock\":1,\"sellStock\":0,\"status\":5,\"clauses\":[{\"itemId\":608167,\"staticInfoId\":37976,\"skuId\":-1,\"clauseType\":1,\"clauseNumber\":2,\"clauseDate\":3,\"clauseTime\":10,\"cancelFineType\":1,\"cancelFine\":0.0,\"default\":false}],\"discount\":-50.73299999999999698729880037717521190643310546875,\"reserveShow\":\"该天配额类型没有预订条款！\"},{\"date\":\"2018-01-26\",\"formulaType\":\"1\",\"occupancyStock\":1,\"price\":2675.40,\"salePrice\":2167.84400,\"salePricePriceStrategy\":2228.0,\"skuId\":-1,\"stock\":1,\"sellStock\":0,\"status\":5,\"clauses\":[{\"itemId\":608167,\"staticInfoId\":37976,\"skuId\":-1,\"clauseType\":1,\"clauseNumber\":2,\"clauseDate\":3,\"clauseTime\":10,\"cancelFineType\":1,\"cancelFine\":0.0,\"default\":false}],\"discount\":-60.15599999999999880628820392303168773651123046875,\"reserveShow\":\"该天配额类型没有预订条款！\"}]", "bedTypeStrs": "{\"bedTypeId\":\"34\",\"bedTypeName\":\"大床[无早]\"}", "bedTypeName": "大床[无早]", "canBookDays": 2, "chanageRoomNum": true, "book": true, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1465959", "roomName": "豪华路凼景观皇室套房", "roomStatus": 0, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "1", "occupancyStock": 1, "price": 2255, "salePrice": 1839, "nowPrice": 0, "skuId": 1081633, "stock": 3, "sellStock": 0, "status": 0, "clauses": [{ "clauseId": 4631748, "itemId": 41593, "staticInfoId": 37976, "skuId": 167603, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }, { "date": "2018-01-26", "formulaType": "1", "occupancyStock": 1, "price": 2000, "salePrice": 1634, "nowPrice": 0, "skuId": 1081634, "stock": 0, "sellStock": 0, "status": 1, "clauses": [{ "clauseId": 4631749, "itemId": 41593, "staticInfoId": 37976, "skuId": 167604, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }], "totalPrice": 4255.00, "averagePrice": 2127.50, "totalPriceRMB": 3473, "totalPriceRMBBeforePriceStrategy": 3473, "totalNowPriceRMB": 0, "averagePriceRMB": 1736.50, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "无餐", "breakFastId": "7", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "34", "bedTypeName": "大床[无餐]" }], "paymentType": 0, "rateType": "1", "rateTypeName": "无早", "isBook": true, "showSalePrice": 1839.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"1\",\"occupancyStock\":1,\"price\":2255,\"salePrice\":1839,\"nowPrice\":0,\"skuId\":1081633,\"stock\":3,\"sellStock\":0,\"status\":0,\"clauses\":[{\"clauseId\":4631748,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":167603,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"},{\"date\":\"2018-01-26\",\"formulaType\":\"1\",\"occupancyStock\":1,\"price\":2000,\"salePrice\":1634,\"nowPrice\":0,\"skuId\":1081634,\"stock\":0,\"sellStock\":0,\"status\":1,\"clauses\":[{\"clauseId\":4631749,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":167604,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"}]", "bedTypeStrs": "{\"bedTypeId\":\"34\",\"bedTypeName\":\"大床[无餐]\"}", "bedTypeName": "大床[无餐]", "canBookDays": 2, "chanageRoomNum": true, "book": true, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1465959", "roomName": "豪华路凼景观皇室套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "2", "occupancyStock": 1, "price": 0, "salePrice": 0, "nowPrice": 0, "skuId": 1122946, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4734566, "itemId": 41593, "staticInfoId": 37976, "skuId": 176211, "clauseType": 0, "clauseNumber": 0, "clauseDate": 14, "clauseTime": 18, "cancelFineType": 0, "default": false }, { "clauseId": 4734567, "itemId": 41593, "staticInfoId": 37976, "skuId": 176211, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前14天18点前预订;" }, { "date": "2018-01-26", "formulaType": "2", "occupancyStock": 1, "price": 1692, "salePrice": 1382, "nowPrice": 0, "skuId": 1124238, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4735075, "itemId": 41593, "staticInfoId": 37976, "skuId": 176435, "clauseType": 0, "clauseNumber": 0, "clauseDate": 14, "clauseTime": 18, "cancelFineType": 0, "attr": "undefined", "default": false }, { "clauseId": 4735076, "itemId": 41593, "staticInfoId": 37976, "skuId": 176435, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前14天18点前预订;" }], "totalPrice": 1692.00, "averagePrice": 846.00, "totalPriceRMB": 1382, "totalPriceRMBBeforePriceStrategy": 1382, "totalNowPriceRMB": 0, "averagePriceRMB": 691.00, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "无早", "breakFastId": "7", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "34", "bedTypeName": "大床[无早]" }], "paymentType": 0, "rateType": "4490", "rateTypeName": "提前14天", "isBook": false, "showSalePrice": 0.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":0,\"salePrice\":0,\"nowPrice\":0,\"skuId\":1122946,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4734566,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176211,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":14,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"\",\"default\":false},{\"clauseId\":4734567,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176211,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前14天18点前预订;\"},{\"date\":\"2018-01-26\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":1692,\"salePrice\":1382,\"nowPrice\":0,\"skuId\":1124238,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4735075,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176435,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":14,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false},{\"clauseId\":4735076,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176435,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前14天18点前预订;\"}]", "bedTypeStrs": "{\"bedTypeId\":\"34\",\"bedTypeName\":\"大床[无早]\"}", "bedTypeName": "大床[无早]", "canBookDays": 0, "chanageRoomNum": true, "book": false, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1465959", "roomName": "豪华路凼景观皇室套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "2", "occupancyStock": 1, "price": 0, "salePrice": 0, "nowPrice": 0, "skuId": 1122581, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4734562, "itemId": 41593, "staticInfoId": 37976, "skuId": 176210, "clauseType": 0, "clauseNumber": 0, "clauseDate": 7, "clauseTime": 18, "cancelFineType": 0, "default": false }, { "clauseId": 4734563, "itemId": 41593, "staticInfoId": 37976, "skuId": 176210, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前7天18点前预订;" }, { "date": "2018-01-26", "formulaType": "2", "occupancyStock": 1, "price": 1918, "salePrice": 1567, "nowPrice": 0, "skuId": 1124210, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4735005, "itemId": 41593, "staticInfoId": 37976, "skuId": 176407, "clauseType": 0, "clauseNumber": 0, "clauseDate": 7, "clauseTime": 18, "cancelFineType": 0, "attr": "undefined", "default": false }, { "clauseId": 4735006, "itemId": 41593, "staticInfoId": 37976, "skuId": 176407, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前7天18点前预订;" }], "totalPrice": 1918.00, "averagePrice": 959.00, "totalPriceRMB": 1567, "totalPriceRMBBeforePriceStrategy": 1567, "totalNowPriceRMB": 0, "averagePriceRMB": 783.50, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "无早", "breakFastId": "7", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "34", "bedTypeName": "大床[无早]" }], "paymentType": 0, "rateType": "4491", "rateTypeName": "提前7天", "isBook": false, "showSalePrice": 0.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":0,\"salePrice\":0,\"nowPrice\":0,\"skuId\":1122581,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4734562,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176210,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":7,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"\",\"default\":false},{\"clauseId\":4734563,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176210,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前7天18点前预订;\"},{\"date\":\"2018-01-26\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":1918,\"salePrice\":1567,\"nowPrice\":0,\"skuId\":1124210,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4735005,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176407,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":7,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false},{\"clauseId\":4735006,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176407,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前7天18点前预订;\"}]", "bedTypeStrs": "{\"bedTypeId\":\"34\",\"bedTypeName\":\"大床[无早]\"}", "bedTypeName": "大床[无早]", "canBookDays": 0, "chanageRoomNum": true, "book": false, "confirm": true }] }, { "hotelId": "37976", "countryId": 70009, "roomName": "天伦乐套房", "roomTypePrices": [{ "supplierId": "164321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "608167", "roomId": "4454", "roomName": "天伦乐套房", "roomStatus": 5, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "1", "occupancyStock": 1, "price": 2517.90, "salePrice": 2040.38100, "salePricePriceStrategy": 2097.0, "skuId": -1, "stock": 1, "sellStock": 0, "status": 5, "clauses": [{ "itemId": 608167, "staticInfoId": 37976, "skuId": -1, "clauseType": 1, "clauseNumber": 2, "clauseDate": 3, "clauseTime": 10, "cancelFineType": 1, "cancelFine": 0.0, "default": false }], "discount": -56.618999999999999772626324556767940521240234375, "reserveShow": "该天配额类型没有预订条款！" }, { "date": "2018-01-26", "formulaType": "1", "occupancyStock": 1, "price": 2832.90, "salePrice": 2295.30700, "salePricePriceStrategy": 2359.0, "skuId": -1, "stock": 1, "sellStock": 0, "status": 5, "clauses": [{ "itemId": 608167, "staticInfoId": 37976, "skuId": -1, "clauseType": 1, "clauseNumber": 2, "clauseDate": 3, "clauseTime": 10, "cancelFineType": 1, "cancelFine": 0.0, "default": false }], "discount": -63.6929999999999978399500832892954349517822265625, "reserveShow": "该天配额类型没有预订条款！" }], "totalPrice": 5350.80, "averagePrice": 2675.4, "taxesAndFees": 0, "extraPersonFees": 0, "totalPriceRMB": 4335.6899999999995998223312199115753173828125, "averagePriceRMB": 2167.8440, "taxesAndFeesRMB": 0, "extraPersonFeesRMB": 0, "cancellationType": 1, "clause": "2_3_10_1_0.0", "cancellationDesc": "入住前3天10点不可修改或取消，罚金为全段", "currentAlloment": -1, "maxPersonNum": 2, "breakFastName": "无早", "breakFastId": "7", "isAddBreakfast": false, "breakfastPriceRMB": 0, "breakfastPriceBase": 0, "bedTypeList": [{ "bedTypeId": "2071", "bedTypeName": "大床[无早]" }], "paymentType": 0, "rateType": "1476977", "rateTypeName": "净房-弹性房价", "isBook": true, "showSalePrice": 2040.38, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"1\",\"occupancyStock\":1,\"price\":2517.90,\"salePrice\":2040.38100,\"salePricePriceStrategy\":2097.0,\"skuId\":-1,\"stock\":1,\"sellStock\":0,\"status\":5,\"clauses\":[{\"itemId\":608167,\"staticInfoId\":37976,\"skuId\":-1,\"clauseType\":1,\"clauseNumber\":2,\"clauseDate\":3,\"clauseTime\":10,\"cancelFineType\":1,\"cancelFine\":0.0,\"default\":false}],\"discount\":-56.618999999999999772626324556767940521240234375,\"reserveShow\":\"该天配额类型没有预订条款！\"},{\"date\":\"2018-01-26\",\"formulaType\":\"1\",\"occupancyStock\":1,\"price\":2832.90,\"salePrice\":2295.30700,\"salePricePriceStrategy\":2359.0,\"skuId\":-1,\"stock\":1,\"sellStock\":0,\"status\":5,\"clauses\":[{\"itemId\":608167,\"staticInfoId\":37976,\"skuId\":-1,\"clauseType\":1,\"clauseNumber\":2,\"clauseDate\":3,\"clauseTime\":10,\"cancelFineType\":1,\"cancelFine\":0.0,\"default\":false}],\"discount\":-63.6929999999999978399500832892954349517822265625,\"reserveShow\":\"该天配额类型没有预订条款！\"}]", "bedTypeStrs": "{\"bedTypeId\":\"2071\",\"bedTypeName\":\"大床[无早]\"}", "bedTypeName": "大床[无早]", "canBookDays": 2, "chanageRoomNum": true, "book": true, "confirm": true }] }, { "hotelId": "37976", "countryId": 70009, "roomName": "豪华皇室套房", "roomTypePrices": [{ "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1047544", "roomName": "豪华皇室套房", "roomTypeParentId": 24261, "roomTypeParentName": "豪华皇室大床套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "2", "occupancyStock": 1, "price": 1580, "salePrice": 1291, "nowPrice": 0, "skuId": 1020541, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4445985, "itemId": 41593, "staticInfoId": 37976, "skuId": 160069, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }, { "date": "2018-01-26", "formulaType": "2", "occupancyStock": 1, "price": 1850, "salePrice": 1511, "nowPrice": 0, "skuId": 1020542, "stock": 0, "sellStock": 0, "status": 1, "clauses": [{ "clauseId": 4445986, "itemId": 41593, "staticInfoId": 37976, "skuId": 160070, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }], "totalPrice": 3430.00, "averagePrice": 1715.00, "totalPriceRMB": 2802, "totalPriceRMBBeforePriceStrategy": 2802, "totalNowPriceRMB": 0, "averagePriceRMB": 1401.00, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "两份早餐", "breakFastId": "9", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "34", "bedTypeName": "大床[两份早餐]" }], "paymentType": 0, "rateType": "3", "rateTypeName": "双早", "isBook": false, "showSalePrice": 1291.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":1580,\"salePrice\":1291,\"nowPrice\":0,\"skuId\":1020541,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4445985,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":160069,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"},{\"date\":\"2018-01-26\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":1850,\"salePrice\":1511,\"nowPrice\":0,\"skuId\":1020542,\"stock\":0,\"sellStock\":0,\"status\":1,\"clauses\":[{\"clauseId\":4445986,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":160070,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"}]", "bedTypeStrs": "{\"bedTypeId\":\"34\",\"bedTypeName\":\"大床[两份早餐]\"}", "bedTypeName": "大床[两份早餐]", "canBookDays": 1, "isHasMarketing": 1, "marketingInfo": "        Bed & Breakfast package 双早特惠", "marketingPrice": 0.0, "marketing": { "marketingId": 6239, "hotelId": 37976, "suppId": 3321, "roomId": "1047544,1047545", "roomName": "豪华皇室套房,豪华贝丽套房", "priceType": "3", "priceTypeName": "双早", "paymentType": 0, "marketingInfo": "        Bed & Breakfast package 双早特惠", "startTime": "2017-10-23 00:00:00", "endTime": "2018-02-15 00:00:00", "marketingPrice": 0.0, "isPack": 0, "isDel": 0 }, "chanageRoomNum": true, "book": false, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1047544", "roomName": "豪华皇室套房", "roomTypeParentId": 24261, "roomTypeParentName": "豪华皇室大床套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "2", "occupancyStock": 1, "price": 1888, "salePrice": 1543, "nowPrice": 0, "skuId": 942848, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4226390, "itemId": 41593, "staticInfoId": 37976, "skuId": 147355, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }, { "date": "2018-01-26", "formulaType": "2", "occupancyStock": 1, "price": 2100, "salePrice": 1715, "nowPrice": 0, "skuId": 942849, "stock": 0, "sellStock": 0, "status": 1, "clauses": [{ "clauseId": 4226391, "itemId": 41593, "staticInfoId": 37976, "skuId": 147356, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }], "totalPrice": 3988.00, "averagePrice": 1994.00, "totalPriceRMB": 3258, "totalPriceRMBBeforePriceStrategy": 3258, "totalNowPriceRMB": 0, "averagePriceRMB": 1629.00, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "两份早餐", "breakFastId": "9", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "34", "bedTypeName": "大床[两份早餐]" }], "paymentType": 0, "rateType": "1470787", "rateTypeName": "冬季套票", "isBook": false, "showSalePrice": 1543.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":1888,\"salePrice\":1543,\"nowPrice\":0,\"skuId\":942848,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4226390,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":147355,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"},{\"date\":\"2018-01-26\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":2100,\"salePrice\":1715,\"nowPrice\":0,\"skuId\":942849,\"stock\":0,\"sellStock\":0,\"status\":1,\"clauses\":[{\"clauseId\":4226391,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":147356,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"}]", "bedTypeStrs": "{\"bedTypeId\":\"34\",\"bedTypeName\":\"大床[两份早餐]\"}", "bedTypeName": "大床[两份早餐]", "canBookDays": 1, "isHasMarketing": 1, "marketingInfo": "         Macao Winter Package 冬季套票\n 1. 一晚住宿\t\n2.于精选餐厅享用早餐或者午餐\n3. 两张单程澳门至香港金光飞航经济舱船票，或巴黎铁塔入场券，或贡多拉之旅，或历险Q立方/ Q立方王国儿童地带入场券，或水世界或Planet J冒险王国入场券（六选一）\n4.「贵宾尊享优惠」小册子\n连住只能享受一次套票项目\n第二晚额外尊享: 第二晚双早/双人午餐                            三选一：双人澳门发现之旅/澳门币400餐饮购物券/西游记门票两张（西游记表演每周四不适用，场次以酒店确认为准）\n**第三人费用RMB350元（含第三人早）\n***巴黎人铁塔2017年12月27至2018年1月11关闭登塔，六选一项目请选其他***", "marketingPrice": 0.0, "marketing": { "marketingId": 6247, "hotelId": 37976, "suppId": 3321, "roomId": "1047544,1047545", "roomName": "豪华皇室套房,豪华贝丽套房", "priceType": "1470787", "priceTypeName": "冬季套票", "paymentType": 0, "marketingInfo": "         Macao Winter Package 冬季套票\n 1. 一晚住宿\t\n2.于精选餐厅享用早餐或者午餐\n3. 两张单程澳门至香港金光飞航经济舱船票，或巴黎铁塔入场券，或贡多拉之旅，或历险Q立方/ Q立方王国儿童地带入场券，或水世界或Planet J冒险王国入场券（六选一）\n4.「贵宾尊享优惠」小册子\n连住只能享受一次套票项目\n第二晚额外尊享: 第二晚双早/双人午餐                            三选一：双人澳门发现之旅/澳门币400餐饮购物券/西游记门票两张（西游记表演每周四不适用，场次以酒店确认为准）\n**第三人费用RMB350元（含第三人早）\n***巴黎人铁塔2017年12月27至2018年1月11关闭登塔，六选一项目请选其他***", "startTime": "2017-10-23 00:00:00", "endTime": "2018-02-15 00:00:00", "marketingPrice": 0.0, "isPack": 0, "isDel": 0 }, "chanageRoomNum": true, "book": false, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1047544", "roomName": "豪华皇室套房", "roomTypeParentId": 24261, "roomTypeParentName": "豪华皇室大床套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "2", "occupancyStock": 1, "price": 0, "salePrice": 0, "nowPrice": 0, "skuId": 1121486, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4734548, "itemId": 41593, "staticInfoId": 37976, "skuId": 176207, "clauseType": 0, "clauseNumber": 0, "clauseDate": 7, "clauseTime": 18, "cancelFineType": 0, "default": false }, { "clauseId": 4734549, "itemId": 41593, "staticInfoId": 37976, "skuId": 176207, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前7天18点前预订;" }, { "date": "2018-01-26", "formulaType": "2", "occupancyStock": 1, "price": 1784, "salePrice": 1457, "nowPrice": 0, "skuId": 1124102, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4734698, "itemId": 41593, "staticInfoId": 37976, "skuId": 176299, "clauseType": 0, "clauseNumber": 0, "clauseDate": 7, "clauseTime": 18, "cancelFineType": 0, "attr": "undefined", "default": false }, { "clauseId": 4734699, "itemId": 41593, "staticInfoId": 37976, "skuId": 176299, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前7天18点前预订;" }], "totalPrice": 1784.00, "averagePrice": 892.00, "totalPriceRMB": 1457, "totalPriceRMBBeforePriceStrategy": 1457, "totalNowPriceRMB": 0, "averagePriceRMB": 728.50, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "无早", "breakFastId": "7", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "34", "bedTypeName": "大床[无早]" }], "paymentType": 0, "rateType": "4491", "rateTypeName": "提前7天", "isBook": false, "showSalePrice": 0.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":0,\"salePrice\":0,\"nowPrice\":0,\"skuId\":1121486,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4734548,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176207,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":7,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"\",\"default\":false},{\"clauseId\":4734549,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176207,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前7天18点前预订;\"},{\"date\":\"2018-01-26\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":1784,\"salePrice\":1457,\"nowPrice\":0,\"skuId\":1124102,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4734698,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176299,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":7,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false},{\"clauseId\":4734699,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176299,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前7天18点前预订;\"}]", "bedTypeStrs": "{\"bedTypeId\":\"34\",\"bedTypeName\":\"大床[无早]\"}", "bedTypeName": "大床[无早]", "canBookDays": 0, "chanageRoomNum": true, "book": false, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1047544", "roomName": "豪华皇室套房", "roomTypeParentId": 24261, "roomTypeParentName": "豪华皇室大床套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "2", "occupancyStock": 1, "price": 0, "salePrice": 0, "nowPrice": 0, "skuId": 1121121, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4734546, "itemId": 41593, "staticInfoId": 37976, "skuId": 176206, "clauseType": 0, "clauseNumber": 0, "clauseDate": 14, "clauseTime": 18, "cancelFineType": 0, "default": false }, { "clauseId": 4734547, "itemId": 41593, "staticInfoId": 37976, "skuId": 176206, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前14天18点前预订;" }, { "date": "2018-01-26", "formulaType": "2", "occupancyStock": 1, "price": 1574, "salePrice": 1287, "nowPrice": 0, "skuId": 1124129, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4734783, "itemId": 41593, "staticInfoId": 37976, "skuId": 176326, "clauseType": 0, "clauseNumber": 0, "clauseDate": 14, "clauseTime": 18, "cancelFineType": 0, "attr": "undefined", "default": false }, { "clauseId": 4734784, "itemId": 41593, "staticInfoId": 37976, "skuId": 176326, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前14天18点前预订;" }], "totalPrice": 1574.00, "averagePrice": 787.00, "totalPriceRMB": 1287, "totalPriceRMBBeforePriceStrategy": 1287, "totalNowPriceRMB": 0, "averagePriceRMB": 643.50, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "无早", "breakFastId": "7", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "34", "bedTypeName": "大床[无早]" }], "paymentType": 0, "rateType": "4490", "rateTypeName": "提前14天", "isBook": false, "showSalePrice": 0.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":0,\"salePrice\":0,\"nowPrice\":0,\"skuId\":1121121,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4734546,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176206,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":14,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"\",\"default\":false},{\"clauseId\":4734547,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176206,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前14天18点前预订;\"},{\"date\":\"2018-01-26\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":1574,\"salePrice\":1287,\"nowPrice\":0,\"skuId\":1124129,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4734783,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176326,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":14,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false},{\"clauseId\":4734784,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176326,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前14天18点前预订;\"}]", "bedTypeStrs": "{\"bedTypeId\":\"34\",\"bedTypeName\":\"大床[无早]\"}", "bedTypeName": "大床[无早]", "canBookDays": 0, "chanageRoomNum": true, "book": false, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1047544", "roomName": "豪华皇室套房", "roomTypeParentId": 24261, "roomTypeParentName": "豪华皇室大床套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "2", "occupancyStock": 1, "price": 1480, "salePrice": 1210, "nowPrice": 0, "skuId": 1019831, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4444570, "itemId": 41593, "staticInfoId": 37976, "skuId": 159794, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "default": false }], "reserveShow": "该天配额类型没有预订条款！" }, { "date": "2018-01-26", "formulaType": "2", "occupancyStock": 1, "price": 1750, "salePrice": 1430, "nowPrice": 0, "skuId": 1019832, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4444570, "itemId": 41593, "staticInfoId": 37976, "skuId": 159794, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "default": false }], "reserveShow": "该天配额类型没有预订条款！" }], "totalPrice": 3230.00, "averagePrice": 1615.00, "totalPriceRMB": 2640, "totalPriceRMBBeforePriceStrategy": 2640, "totalNowPriceRMB": 0, "averagePriceRMB": 1320.00, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "无早", "breakFastId": "7", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "34", "bedTypeName": "大床[无早]" }], "paymentType": 0, "rateType": "1434034", "rateTypeName": "净房", "isBook": false, "showSalePrice": 1210.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":1480,\"salePrice\":1210,\"nowPrice\":0,\"skuId\":1019831,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4444570,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":159794,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"},{\"date\":\"2018-01-26\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":1750,\"salePrice\":1430,\"nowPrice\":0,\"skuId\":1019832,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4444570,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":159794,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"}]", "bedTypeStrs": "{\"bedTypeId\":\"34\",\"bedTypeName\":\"大床[无早]\"}", "bedTypeName": "大床[无早]", "canBookDays": 0, "chanageRoomNum": true, "book": false, "confirm": true }] }, { "hotelId": "37976", "countryId": 70009, "roomName": "豪华贝丽套房", "roomTypePrices": [{ "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1047545", "roomName": "豪华贝丽套房", "roomTypeParentId": 24262, "roomTypeParentName": "豪华贝丽套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "2", "occupancyStock": 1, "price": 1830, "salePrice": 1494, "nowPrice": 0, "skuId": 1020594, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4446122, "itemId": 41593, "staticInfoId": 37976, "skuId": 160122, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }, { "date": "2018-01-26", "formulaType": "2", "occupancyStock": 1, "price": 2100, "salePrice": 1715, "nowPrice": 0, "skuId": 1020595, "stock": 0, "sellStock": 0, "status": 1, "clauses": [{ "clauseId": 4446123, "itemId": 41593, "staticInfoId": 37976, "skuId": 160123, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }], "totalPrice": 3930.00, "averagePrice": 1965.00, "totalPriceRMB": 3209, "totalPriceRMBBeforePriceStrategy": 3209, "totalNowPriceRMB": 0, "averagePriceRMB": 1604.50, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "两份早餐", "breakFastId": "9", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "35", "bedTypeName": "双床[两份早餐]" }], "paymentType": 0, "rateType": "3", "rateTypeName": "双早", "isBook": false, "showSalePrice": 1494.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":1830,\"salePrice\":1494,\"nowPrice\":0,\"skuId\":1020594,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4446122,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":160122,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"},{\"date\":\"2018-01-26\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":2100,\"salePrice\":1715,\"nowPrice\":0,\"skuId\":1020595,\"stock\":0,\"sellStock\":0,\"status\":1,\"clauses\":[{\"clauseId\":4446123,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":160123,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"}]", "bedTypeStrs": "{\"bedTypeId\":\"35\",\"bedTypeName\":\"双床[两份早餐]\"}", "bedTypeName": "双床[两份早餐]", "canBookDays": 1, "isHasMarketing": 1, "marketingInfo": "        Bed & Breakfast package 双早特惠", "marketingPrice": 0.0, "marketing": { "marketingId": 6239, "hotelId": 37976, "suppId": 3321, "roomId": "1047544,1047545", "roomName": "豪华皇室套房,豪华贝丽套房", "priceType": "3", "priceTypeName": "双早", "paymentType": 0, "marketingInfo": "        Bed & Breakfast package 双早特惠", "startTime": "2017-10-23 00:00:00", "endTime": "2018-02-15 00:00:00", "marketingPrice": 0.0, "isPack": 0, "isDel": 0 }, "chanageRoomNum": true, "book": false, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1047545", "roomName": "豪华贝丽套房", "roomTypeParentId": 24262, "roomTypeParentName": "豪华贝丽套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "2", "occupancyStock": 1, "price": 2080, "salePrice": 1698, "nowPrice": 0, "skuId": 943071, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4226548, "itemId": 41593, "staticInfoId": 37976, "skuId": 147451, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }, { "date": "2018-01-26", "formulaType": "2", "occupancyStock": 1, "price": 2350, "salePrice": 1915, "nowPrice": 0, "skuId": 943072, "stock": 0, "sellStock": 0, "status": 1, "clauses": [{ "clauseId": 4226549, "itemId": 41593, "staticInfoId": 37976, "skuId": 147452, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }], "totalPrice": 4430.00, "averagePrice": 2215.00, "totalPriceRMB": 3613, "totalPriceRMBBeforePriceStrategy": 3613, "totalNowPriceRMB": 0, "averagePriceRMB": 1806.50, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "两份早餐", "breakFastId": "9", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "35", "bedTypeName": "双床[两份早餐]" }], "paymentType": 0, "rateType": "1470787", "rateTypeName": "冬季套票", "isBook": false, "showSalePrice": 1698.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":2080,\"salePrice\":1698,\"nowPrice\":0,\"skuId\":943071,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4226548,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":147451,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"},{\"date\":\"2018-01-26\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":2350,\"salePrice\":1915,\"nowPrice\":0,\"skuId\":943072,\"stock\":0,\"sellStock\":0,\"status\":1,\"clauses\":[{\"clauseId\":4226549,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":147452,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"}]", "bedTypeStrs": "{\"bedTypeId\":\"35\",\"bedTypeName\":\"双床[两份早餐]\"}", "bedTypeName": "双床[两份早餐]", "canBookDays": 1, "isHasMarketing": 1, "marketingInfo": "         Macao Winter Package 冬季套票\n 1. 一晚住宿\t\n2.于精选餐厅享用早餐或者午餐\n3. 两张单程澳门至香港金光飞航经济舱船票，或巴黎铁塔入场券，或贡多拉之旅，或历险Q立方/ Q立方王国儿童地带入场券，或水世界或Planet J冒险王国入场券（六选一）\n4.「贵宾尊享优惠」小册子\n连住只能享受一次套票项目\n第二晚额外尊享: 第二晚双早/双人午餐                            三选一：双人澳门发现之旅/澳门币400餐饮购物券/西游记门票两张（西游记表演每周四不适用，场次以酒店确认为准）\n**第三人费用RMB350元（含第三人早）\n***巴黎人铁塔2017年12月27至2018年1月11关闭登塔，六选一项目请选其他***", "marketingPrice": 0.0, "marketing": { "marketingId": 6247, "hotelId": 37976, "suppId": 3321, "roomId": "1047544,1047545", "roomName": "豪华皇室套房,豪华贝丽套房", "priceType": "1470787", "priceTypeName": "冬季套票", "paymentType": 0, "marketingInfo": "         Macao Winter Package 冬季套票\n 1. 一晚住宿\t\n2.于精选餐厅享用早餐或者午餐\n3. 两张单程澳门至香港金光飞航经济舱船票，或巴黎铁塔入场券，或贡多拉之旅，或历险Q立方/ Q立方王国儿童地带入场券，或水世界或Planet J冒险王国入场券（六选一）\n4.「贵宾尊享优惠」小册子\n连住只能享受一次套票项目\n第二晚额外尊享: 第二晚双早/双人午餐                            三选一：双人澳门发现之旅/澳门币400餐饮购物券/西游记门票两张（西游记表演每周四不适用，场次以酒店确认为准）\n**第三人费用RMB350元（含第三人早）\n***巴黎人铁塔2017年12月27至2018年1月11关闭登塔，六选一项目请选其他***", "startTime": "2017-10-23 00:00:00", "endTime": "2018-02-15 00:00:00", "marketingPrice": 0.0, "isPack": 0, "isDel": 0 }, "chanageRoomNum": true, "book": false, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1047545", "roomName": "豪华贝丽套房", "roomTypeParentId": 24262, "roomTypeParentName": "豪华贝丽套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "1", "occupancyStock": 1, "price": 2348, "salePrice": 1915, "nowPrice": 0, "skuId": 1081522, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4631589, "itemId": 41593, "staticInfoId": 37976, "skuId": 167492, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }, { "date": "2018-01-26", "formulaType": "1", "occupancyStock": 1, "price": 2000, "salePrice": 1633, "nowPrice": 0, "skuId": 1081523, "stock": 0, "sellStock": 0, "status": 1, "clauses": [{ "clauseId": 4631590, "itemId": 41593, "staticInfoId": 37976, "skuId": 167493, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }], "totalPrice": 4348.00, "averagePrice": 2174.00, "totalPriceRMB": 3548, "totalPriceRMBBeforePriceStrategy": 3548, "totalNowPriceRMB": 0, "averagePriceRMB": 1774.00, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "无餐", "breakFastId": "7", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "35", "bedTypeName": "双床[无餐]" }], "paymentType": 0, "rateType": "1", "rateTypeName": "无早", "isBook": false, "showSalePrice": 1915.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"1\",\"occupancyStock\":1,\"price\":2348,\"salePrice\":1915,\"nowPrice\":0,\"skuId\":1081522,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4631589,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":167492,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"},{\"date\":\"2018-01-26\",\"formulaType\":\"1\",\"occupancyStock\":1,\"price\":2000,\"salePrice\":1633,\"nowPrice\":0,\"skuId\":1081523,\"stock\":0,\"sellStock\":0,\"status\":1,\"clauses\":[{\"clauseId\":4631590,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":167493,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"}]", "bedTypeStrs": "{\"bedTypeId\":\"35\",\"bedTypeName\":\"双床[无餐]\"}", "bedTypeName": "双床[无餐]", "canBookDays": 1, "chanageRoomNum": true, "book": false, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1047545", "roomName": "豪华贝丽套房", "roomTypeParentId": 24262, "roomTypeParentName": "豪华贝丽套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "2", "occupancyStock": 1, "price": 0, "salePrice": 0, "nowPrice": 0, "skuId": 1122216, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4734552, "itemId": 41593, "staticInfoId": 37976, "skuId": 176209, "clauseType": 0, "clauseNumber": 0, "clauseDate": 7, "clauseTime": 18, "cancelFineType": 0, "default": false }, { "clauseId": 4734553, "itemId": 41593, "staticInfoId": 37976, "skuId": 176209, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前7天18点前预订;" }, { "date": "2018-01-26", "formulaType": "2", "occupancyStock": 1, "price": 2007, "salePrice": 1639, "nowPrice": 0, "skuId": 1124156, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4734856, "itemId": 41593, "staticInfoId": 37976, "skuId": 176353, "clauseType": 0, "clauseNumber": 0, "clauseDate": 7, "clauseTime": 18, "cancelFineType": 0, "attr": "undefined", "default": false }, { "clauseId": 4734857, "itemId": 41593, "staticInfoId": 37976, "skuId": 176353, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前7天18点前预订;" }], "totalPrice": 2007.00, "averagePrice": 1003.50, "totalPriceRMB": 1639, "totalPriceRMBBeforePriceStrategy": 1639, "totalNowPriceRMB": 0, "averagePriceRMB": 819.50, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "无早", "breakFastId": "7", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "35", "bedTypeName": "双床[无早]" }], "paymentType": 0, "rateType": "4491", "rateTypeName": "提前7天", "isBook": false, "showSalePrice": 0.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":0,\"salePrice\":0,\"nowPrice\":0,\"skuId\":1122216,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4734552,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176209,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":7,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"\",\"default\":false},{\"clauseId\":4734553,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176209,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前7天18点前预订;\"},{\"date\":\"2018-01-26\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":2007,\"salePrice\":1639,\"nowPrice\":0,\"skuId\":1124156,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4734856,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176353,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":7,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false},{\"clauseId\":4734857,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176353,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前7天18点前预订;\"}]", "bedTypeStrs": "{\"bedTypeId\":\"35\",\"bedTypeName\":\"双床[无早]\"}", "bedTypeName": "双床[无早]", "canBookDays": 0, "chanageRoomNum": true, "book": false, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1047545", "roomName": "豪华贝丽套房", "roomTypeParentId": 24262, "roomTypeParentName": "豪华贝丽套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "2", "occupancyStock": 1, "price": 0, "salePrice": 0, "nowPrice": 0, "skuId": 1121851, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4734550, "itemId": 41593, "staticInfoId": 37976, "skuId": 176208, "clauseType": 0, "clauseNumber": 0, "clauseDate": 14, "clauseTime": 18, "cancelFineType": 0, "default": false }, { "clauseId": 4734551, "itemId": 41593, "staticInfoId": 37976, "skuId": 176208, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前14天18点前预订;" }, { "date": "2018-01-26", "formulaType": "2", "occupancyStock": 1, "price": 1771, "salePrice": 1447, "nowPrice": 0, "skuId": 1124183, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4734925, "itemId": 41593, "staticInfoId": 37976, "skuId": 176380, "clauseType": 0, "clauseNumber": 0, "clauseDate": 14, "clauseTime": 18, "cancelFineType": 0, "attr": "undefined", "default": false }, { "clauseId": 4734926, "itemId": 41593, "staticInfoId": 37976, "skuId": 176380, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前14天18点前预订;" }], "totalPrice": 1771.00, "averagePrice": 885.50, "totalPriceRMB": 1447, "totalPriceRMBBeforePriceStrategy": 1447, "totalNowPriceRMB": 0, "averagePriceRMB": 723.50, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "无早", "breakFastId": "7", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "35", "bedTypeName": "双床[无早]" }], "paymentType": 0, "rateType": "4490", "rateTypeName": "提前14天", "isBook": false, "showSalePrice": 0.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":0,\"salePrice\":0,\"nowPrice\":0,\"skuId\":1121851,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4734550,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176208,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":14,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"\",\"default\":false},{\"clauseId\":4734551,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176208,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前14天18点前预订;\"},{\"date\":\"2018-01-26\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":1771,\"salePrice\":1447,\"nowPrice\":0,\"skuId\":1124183,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4734925,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176380,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":14,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false},{\"clauseId\":4734926,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176380,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前14天18点前预订;\"}]", "bedTypeStrs": "{\"bedTypeId\":\"35\",\"bedTypeName\":\"双床[无早]\"}", "bedTypeName": "双床[无早]", "canBookDays": 0, "chanageRoomNum": true, "book": false, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1047545", "roomName": "豪华贝丽套房", "roomTypeParentId": 24262, "roomTypeParentName": "豪华贝丽套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "2", "occupancyStock": 1, "price": 1730, "salePrice": 1414, "nowPrice": 0, "skuId": 1020077, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4444604, "itemId": 41593, "staticInfoId": 37976, "skuId": 159795, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "default": false }], "reserveShow": "该天配额类型没有预订条款！" }, { "date": "2018-01-26", "formulaType": "2", "occupancyStock": 1, "price": 2000, "salePrice": 1634, "nowPrice": 0, "skuId": 1020078, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4444604, "itemId": 41593, "staticInfoId": 37976, "skuId": 159795, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "default": false }], "reserveShow": "该天配额类型没有预订条款！" }], "totalPrice": 3730.00, "averagePrice": 1865.00, "totalPriceRMB": 3048, "totalPriceRMBBeforePriceStrategy": 3048, "totalNowPriceRMB": 0, "averagePriceRMB": 1524.00, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "无早", "breakFastId": "7", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "35", "bedTypeName": "双床[无早]" }], "paymentType": 0, "rateType": "1434034", "rateTypeName": "净房", "isBook": false, "showSalePrice": 1414.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":1730,\"salePrice\":1414,\"nowPrice\":0,\"skuId\":1020077,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4444604,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":159795,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"},{\"date\":\"2018-01-26\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":2000,\"salePrice\":1634,\"nowPrice\":0,\"skuId\":1020078,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4444604,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":159795,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"}]", "bedTypeStrs": "{\"bedTypeId\":\"35\",\"bedTypeName\":\"双床[无早]\"}", "bedTypeName": "双床[无早]", "canBookDays": 0, "chanageRoomNum": true, "book": false, "confirm": true }] }, { "hotelId": "37976", "countryId": 70009, "roomName": "豪华路凼景观贝丽套房", "roomTypePrices": [{ "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1465960", "roomName": "豪华路凼景观贝丽套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "1", "occupancyStock": 1, "price": 2097, "salePrice": 1711, "nowPrice": 0, "skuId": 1081748, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4631935, "itemId": 41593, "staticInfoId": 37976, "skuId": 167718, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }, { "date": "2018-01-26", "formulaType": "1", "occupancyStock": 1, "price": 2250, "salePrice": 1834, "nowPrice": 0, "skuId": 1081749, "stock": 0, "sellStock": 0, "status": 1, "clauses": [{ "clauseId": 4631936, "itemId": 41593, "staticInfoId": 37976, "skuId": 167719, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "该天配额类型没有预订条款！" }], "totalPrice": 4347.00, "averagePrice": 2173.50, "totalPriceRMB": 3545, "totalPriceRMBBeforePriceStrategy": 3545, "totalNowPriceRMB": 0, "averagePriceRMB": 1772.50, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "无餐", "breakFastId": "7", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "35", "bedTypeName": "双床[无餐]" }], "paymentType": 0, "rateType": "1", "rateTypeName": "无早", "isBook": false, "showSalePrice": 1711.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"1\",\"occupancyStock\":1,\"price\":2097,\"salePrice\":1711,\"nowPrice\":0,\"skuId\":1081748,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4631935,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":167718,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"},{\"date\":\"2018-01-26\",\"formulaType\":\"1\",\"occupancyStock\":1,\"price\":2250,\"salePrice\":1834,\"nowPrice\":0,\"skuId\":1081749,\"stock\":0,\"sellStock\":0,\"status\":1,\"clauses\":[{\"clauseId\":4631936,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":167719,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"该天配额类型没有预订条款！\"}]", "bedTypeStrs": "{\"bedTypeId\":\"35\",\"bedTypeName\":\"双床[无餐]\"}", "bedTypeName": "双床[无餐]", "canBookDays": 1, "chanageRoomNum": true, "book": false, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1465960", "roomName": "豪华路凼景观贝丽套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "2", "occupancyStock": 1, "price": 0, "salePrice": 0, "nowPrice": 0, "skuId": 1123676, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4734571, "itemId": 41593, "staticInfoId": 37976, "skuId": 176213, "clauseType": 0, "clauseNumber": 0, "clauseDate": 7, "clauseTime": 18, "cancelFineType": 0, "default": false }, { "clauseId": 4734572, "itemId": 41593, "staticInfoId": 37976, "skuId": 176213, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前7天18点前预订;" }, { "date": "2018-01-26", "formulaType": "2", "occupancyStock": 1, "price": 2141, "salePrice": 1747, "nowPrice": 0, "skuId": 1124265, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4735304, "itemId": 41593, "staticInfoId": 37976, "skuId": 176462, "clauseType": 0, "clauseNumber": 0, "clauseDate": 7, "clauseTime": 18, "cancelFineType": 0, "attr": "undefined", "default": false }, { "clauseId": 4735305, "itemId": 41593, "staticInfoId": 37976, "skuId": 176462, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前7天18点前预订;" }], "totalPrice": 2141.00, "averagePrice": 1070.50, "totalPriceRMB": 1747, "totalPriceRMBBeforePriceStrategy": 1747, "totalNowPriceRMB": 0, "averagePriceRMB": 873.50, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "无早", "breakFastId": "7", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "35", "bedTypeName": "双床[无早]" }], "paymentType": 0, "rateType": "4491", "rateTypeName": "提前7天", "isBook": false, "showSalePrice": 0.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":0,\"salePrice\":0,\"nowPrice\":0,\"skuId\":1123676,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4734571,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176213,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":7,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"\",\"default\":false},{\"clauseId\":4734572,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176213,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前7天18点前预订;\"},{\"date\":\"2018-01-26\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":2141,\"salePrice\":1747,\"nowPrice\":0,\"skuId\":1124265,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4735304,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176462,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":7,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false},{\"clauseId\":4735305,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176462,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前7天18点前预订;\"}]", "bedTypeStrs": "{\"bedTypeId\":\"35\",\"bedTypeName\":\"双床[无早]\"}", "bedTypeName": "双床[无早]", "canBookDays": 0, "chanageRoomNum": true, "book": false, "confirm": true }, { "supplierId": "3321", "isTimeLimitConfirSupplier": 0, "hotelId": "37976", "itemId": "41593", "roomId": "1465960", "roomName": "豪华路凼景观贝丽套房", "roomStatus": 3, "nightlyPriceList": [{ "date": "2018-01-25", "formulaType": "2", "occupancyStock": 1, "price": 0, "salePrice": 0, "nowPrice": 0, "skuId": 1123311, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4734568, "itemId": 41593, "staticInfoId": 37976, "skuId": 176212, "clauseType": 0, "clauseNumber": 0, "clauseDate": 14, "clauseTime": 18, "cancelFineType": 0, "default": false }, { "clauseId": 4734569, "itemId": 41593, "staticInfoId": 37976, "skuId": 176212, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前14天18点前预订;" }, { "date": "2018-01-26", "formulaType": "2", "occupancyStock": 1, "price": 1889, "salePrice": 1544, "nowPrice": 0, "skuId": 1124292, "stock": 0, "sellStock": 0, "status": 3, "clauses": [{ "clauseId": 4735361, "itemId": 41593, "staticInfoId": 37976, "skuId": 176489, "clauseType": 0, "clauseNumber": 0, "clauseDate": 14, "clauseTime": 18, "cancelFineType": 0, "attr": "undefined", "default": false }, { "clauseId": 4735362, "itemId": 41593, "staticInfoId": 37976, "skuId": 176489, "clauseType": 1, "clauseNumber": 3, "clauseDate": 0, "clauseTime": 0, "cancelFineType": 0, "attr": "undefined", "default": false }], "reserveShow": "/images/clause/ti.png|订此房间，需要提前14天18点前预订;" }], "totalPrice": 1889.00, "averagePrice": 944.50, "totalPriceRMB": 1544, "totalPriceRMBBeforePriceStrategy": 1544, "totalNowPriceRMB": 0, "averagePriceRMB": 772.00, "clause": "3_0_0_0_0", "cancellationDesc": "此房即订即保，一但预订。不可修改或取消", "maxPersonNum": 2, "breakFastName": "无早", "breakFastId": "7", "isAddBreakfast": false, "bedTypeList": [{ "bedTypeId": "35", "bedTypeName": "双床[无早]" }], "paymentType": 0, "rateType": "4490", "rateTypeName": "提前14天", "isBook": false, "showSalePrice": 0.0, "hotelPriceStrs": "[{\"date\":\"2018-01-25\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":0,\"salePrice\":0,\"nowPrice\":0,\"skuId\":1123311,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4734568,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176212,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":14,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"\",\"default\":false},{\"clauseId\":4734569,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176212,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前14天18点前预订;\"},{\"date\":\"2018-01-26\",\"formulaType\":\"2\",\"occupancyStock\":1,\"price\":1889,\"salePrice\":1544,\"nowPrice\":0,\"skuId\":1124292,\"stock\":0,\"sellStock\":0,\"status\":3,\"clauses\":[{\"clauseId\":4735361,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176489,\"clauseType\":0,\"clauseNumber\":0,\"clauseDate\":14,\"clauseTime\":18,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false},{\"clauseId\":4735362,\"itemId\":41593,\"staticInfoId\":37976,\"skuId\":176489,\"clauseType\":1,\"clauseNumber\":3,\"clauseDate\":0,\"clauseTime\":0,\"cancelFineType\":0,\"attr\":\"undefined\",\"default\":false}],\"reserveShow\":\"/images/clause/ti.png|订此房间，需要提前14天18点前预订;\"}]", "bedTypeStrs": "{\"bedTypeId\":\"35\",\"bedTypeName\":\"双床[无早]\"}", "bedTypeName": "双床[无早]", "canBookDays": 0, "chanageRoomNum": true, "book": false, "confirm": true }] }] } };

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<li class="hotel-detail-item">\r\n    <label class="hotel-detail-label">\r\n        <img src="https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1749462714946.png" alt="" style="float: left;margin-right: 10px;" />\r\n        入住政策\r\n    </label>\r\n\r\n    <div style="margin-left: 140px;padding-bottom: 5px;border-bottom: dashed 1px #e3e3e3;">\r\n        <div style="margin-bottom: 10px;">\r\n            <span style="font-weight: 600;">入住离店时间:</span>\r\n            <div >\r\n                ';
 if (o.arriveStartTime && o.arriveEndTime){ ;
__p += '\r\n                <p >\r\n                    酒店入住开始时间' +
((__t = ( o.arriveStartTime )) == null ? '' : __t) +
'，结束时间' +
((__t = ( o.arriveEndTime )) == null ? '' : __t) +
'\r\n                </p>\r\n                ';
 } ;
__p += '\r\n\r\n                ';
 if (o.addAttrMap && o.addAttrMap.checkOutTime){ ;
__p += '\r\n                <p >\r\n                    酒店退房时间' +
((__t = ( o.addAttrMap.checkOutTime )) == null ? '' : __t) +
'\r\n                </p>\r\n                ';
 } ;
__p += '\r\n            </div>\r\n        </div>\r\n\r\n        ';
 if (o.policies){ ;
__p += '\r\n        <div style="margin-bottom: 10px;">\r\n            <span style="font-weight: 600;">入住政策：</span>\r\n            <div>' +
((__t = ( o.policies )) == null ? '' : __t) +
'</div>\r\n        </div>\r\n        ';
 } ;
__p += '\r\n\r\n        ';
 if (o.checkInInstructions){ ;
__p += '\r\n        <div style="margin-bottom: 10px;">\r\n            <span style="font-weight: 600;">入住提示：</span>\r\n            <div>' +
((__t = ( o.checkInInstructions )) == null ? '' : __t) +
'</div>\r\n        </div>\r\n        ';
 } ;
__p += '\r\n\r\n        ';
 if (o.specialCheckInInstructions){ ;
__p += '\r\n        <div style="margin-bottom: 10px;">\r\n            <span style="font-weight: 600;">特殊入住提示：</span>\r\n            <div>' +
((__t = ( o.specialCheckInInstructions )) == null ? '' : __t) +
'</div>\r\n        </div>\r\n        ';
 } ;
__p += '\r\n\r\n        ';
 if (o.addAttrMap && o.addAttrMap.fees_mandatory){ ;
__p += '\r\n        <div style="margin-bottom: 10px;">\r\n            <span style="font-weight: 600;">强制性费用：</span>\r\n            <div>' +
((__t = ( o.addAttrMap.fees_mandatory )) == null ? '' : __t) +
'</div>\r\n        </div>\r\n        ';
 } ;
__p += '\r\n\r\n        ';
 if (o.addAttrMap && o.addAttrMap.fees_optional){ ;
__p += '\r\n        <div style="margin-bottom: 10px;">\r\n            <span style="font-weight: 600;">可选项费用：</span>\r\n            <div>' +
((__t = ( o.addAttrMap.fees_optional )) == null ? '' : __t) +
'</div>\r\n        </div>\r\n        ';
 } ;
__p += '\r\n        \r\n    </div>\r\n</li>';

}
return __p
}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="hotel-introduction" class="hdi-brief-item-content" data-content="' +
((__t = ( o )) == null ? '' : __t) +
'" style="margin-bottom: 10px;">\r\n    ';
 if(o && o.length > 45){ ;
__p += '\r\n        <span>' +
((__t = ( o.substring(0,45) )) == null ? '' : __t) +
'......</span>\r\n        <a href="javascipt:void(0);" class="hdi-brief-view-detail">[查看详情]</a>\r\n    ';
 } else { ;
__p += '\r\n        <span>' +
((__t = ( o || '' )) == null ? '' : __t) +
'</span>\r\n    ';
 } ;
__p += '\r\n</div>';

}
return __p
}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!-- 一个月的字符串模板 -->\n<div class="cp-one-month-wrap current" data-month="' +
((__t = ( month )) == null ? '' : __t) +
'">\n    <h1 class="cp-month-head">' +
((__t = ( head )) == null ? '' : __t) +
'</h1>\n    <table>\n        <thead class="cp-month-thead">\n            <tr>\n                <td>日</td>\n                <td>一</td>\n                <td>二</td>\n                <td>三</td>\n                <td>四</td>\n                <td>五</td>\n                <td>六</td>\n            </tr>\n        </thead>\n        <tbody>' +
((__t = ( body )) == null ? '' : __t) +
'</tbody>\n    </table>\n</div>';

}
return __p
}

/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 var totalTrNum = 0; $.each([roomTypeBasesRecommend, roomTypeBases], function(index, roomTypeBases){ var typeText = index === 0 ? 'recommend' : 'others' ;
__p += '\n<table class="hotel-price-table hotel-detail-price-table' +
((__t = ( index === 0 ? ' recommend-table' : '' )) == null ? '' : __t) +
'' +
((__t = ( roomTypeBases.length > 0 ? '' : ' hidden')) == null ? '' : __t) +
'">\n	<thead class="hotel-price-thead hotel-detail-price-thead' +
((__t = ( index === 0 ? ' recommend-thead' : '')) == null ? '' : __t) +
'">\n	<tr>\n        ';
 if (index === 0){ ;
__p += '\n		<th width="260"><span class="hot-room-span">超值房型<i class="hot-room"></i></span></th>\n        ';
 }else{ ;
__p += '\n		<th width="260">特色房型</th>\n        ';
 } ;
__p += '\n		<th  width="190">价格类型</th>\n		<th width="150" class="align-center"><span>床型/早餐</span></th>\n		<th>预订规则</th>\n		<th>取消规则</th>\n		<th>剩余数量</th>\n		<th width="160">均价/总价</th>\n		<th width="115">预订</th>\n	</tr>\n	</thead>\n\n	<tbody class="hotel-price-tbody' +
((__t = ( index === 0 ? ' recommend-tbody' : '')) == null ? '' : __t) +
' ' +
((__t = ( index===1 ? 'myBody' : '' )) == null ? '' : __t) +
'" data-infoid="' +
((__t = ( hotelId )) == null ? '' : __t) +
'">\n	';
 for(var i = 0; i < roomTypeBases.length; i++){ var n = roomTypeBases[i]; ;
__p += '\n\n		';
 for(var j = 0; j < n.roomTypePrices.length; j++){ var o = n.roomTypePrices[j]; totalTrNum++; ;
__p += '\n        <!-- index === 1 && j === 0 ? \' mytr\' : index === 0 && j === 1 ? \' mytr\' : \'\' -->\n		<tr class="hotel-price-tr\n            ' +
((__t = ( j === 0 ? '' : ' auto-hide-tr' )) == null ? '' : __t) +
'\n            ' +
((__t = ( totalTrNum > 3 ? ' auto-hide' : '' )) == null ? '' : __t) +
' \n            ' +
((__t = ( index === 1 && j === 0 ? ' newmytr' : index === 0 && j === 1 ? ' newmytr' : '' )) == null ? '' : __t) +
'\n            ' +
((__t = ( index === 1 && j === 0 ? ' mytr' : '' )) == null ? '' : __t) +
'\n            ' +
((__t = ( index === 1 && j > 2 ? ' click-btn-css' : '' )) == null ? '' : __t) +
'\n            ' +
((__t = ( index === 1 ? ' borderTr' + i : '' )) == null ? '' : __t) +
'\n            ' +
((__t = ( index === 1 && j === 0 ? ' firstBorderTr' + i : '' )) == null ? '' : __t) +
'\n            ' +
((__t = ( index === 1 && i > 0 ? ' gt-one-tr' : '' )) == null ? '' : __t) +
'"  \n\n			data-show="' +
((__t = ( index===1 && (n.roomTypePrices.length - 1) == j ? 'true' : index===0? 'true' : 'false' )) == null ? '' : __t) +
'"\n        >\n\n            <!-- 第一个td -->\n			<td class="first-td' +
((__t = (
				(j === 0 && n.roomTypePrices.length > 1) ? ' no-border-bottom-td' :
				(j > 0 && j == n.roomTypePrices.length - 1) ? ' no-border-top-td' :
				(j > 0 && j < n.roomTypePrices.length - 1) ? ' no-border-td' : ''
			)) == null ? '' : __t) +
'" data-type="' +
((__t = ( typeText )) == null ? '' : __t) +
'">\n				<span class="hp-roomName' +
((__t = ( j === 0 || (ch == 3 && n.roomName == '其他 Other') ? '' : ' hidden' )) == null ? '' : __t) +
'"\n					roomid="' +
((__t = ( o.roomId )) == null ? '' : __t) +
'"\n					hotelid="' +
((__t = ( o.hotelId )) == null ? '' : __t) +
'"\n					supplierid="' +
((__t = ( o.supplierId )) == null ? '' : __t) +
'"\n					data-type="' +
((__t = ( typeText )) == null ? '' : __t) +
'"\n					data-track="详情页_酒店项_展开房型" >\n\n                    ';
 if(ch == 3 && n.roomName && n.roomName == "其他 Other"){ ;
__p += '\n						' +
((__t = ( o.roomName )) == null ? '' : __t) +
'\n                    ';
 }else{ ;
__p += '\n					    ' +
((__t = ( n.roomName )) == null ? '' : __t) +
'\n                    ';
 } ;
__p += '\n\n                    ';
 if(n.roomTypePrices.length > 1 && index ===1){ ;
__p += '\n						<!-- <i class="room-type-icon room-type-down"></i> -->\n                    ';
 } ;
__p += '\n					';
 if(n.roomTypePrices.length > 1 && index ===0){ ;
__p += '\n						<!-- <i class="room-type-icon room-type-up"></i>	 -->\n					';
 } ;
__p += '	\n				</span>\n			</td>\n\n            <!-- 第二个td -->\n			<td class="has-border-td yu-ding">\n                ';
 if(n.roomName && n.roomName == "其他 Other" && ch != 3){ ;
__p += '\n                <p \n                    style="\n                    max-width: 100%;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    font-weight: bold;\n                    display: -webkit-box;\n                    -webkit-box-orient: vertical;\n                    -webkit-line-clamp: 2;"\n                    title="' +
((__t = ( o.roomName )) == null ? '' : __t) +
'"\n                >\n                    ' +
((__t = ( o.roomName )) == null ? '' : __t) +
'\n                </p>\n                ';
 } ;
__p += '\n                \n                <span class="span-title" title="' +
((__t = ( o.rateTypeName || '' )) == null ? '' : __t) +
'" >' +
((__t = ( o.rateTypeName || '' )) == null ? '' : __t) +
'</span>\n                \n                <!-- 是否直采,isOwn等于1 -->\n                ';
 if(o.isOwn && o.isOwn == 1){ ;
__p += '\n                <div class="zhicai-div">\n                    <img src="https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1721721843566.gif" alt="">\n                    <div class="zhicai-all">\n                        <div class="zhicai-dialog">\n                            <span class="zhicai-dialog_text">准确率更高，库存更稳定，响应更及时</span>\n                            <div class="zhicai-dialog_ico"></div>\n                        </div>\n                    </div>\n                </div>\n                ';
 } ;
__p += '\n                \n				';
 if(o.isHasMarketing){ ;
__p += '\n				<!-- <i class="marketing-icon" data-tip="' +
((__t = ( encodeURIComponent(o.marketingInfo) )) == null ? '' : __t) +
'"></i> -->\n                <div class="tooltip-base">\n                    <i class="marketing-icon-base"></i>\n                    <span class="tooltiptext">' +
((__t = ( o.marketingInfo )) == null ? '' : __t) +
'</span>\n                </div>\n				';
 } ;
__p += '\n\n				';
 if(o.productDesc){ ;
__p += '\n				<!-- <i class="marketing-icon" data-tip="' +
((__t = ( encodeURIComponent(o.productDesc) )) == null ? '' : __t) +
'"></i> -->\n                <div class="tooltip-base">\n                    <i class="marketing-icon-base"></i>\n                    <span class="tooltiptext">' +
((__t = ( o.productDesc )) == null ? '' : __t) +
'</span>\n                </div>\n\n				';
 } ;
__p += '\n\n				';
 if(o.packageRequest){ ;
__p += '\n				<i class="pagekage-icon"></i>\n				';
 } ;
__p += '\n\n				\n				<!-- 新增按钮 -->\n				';
 if(n.roomTypePrices.length > 1 && index ===1){ ;
__p += '\n				<!-- <span class="new-btn hp-roomName' +
((__t = ( j === 0 ? '' : ' hidden' )) == null ? '' : __t) +
'"\n					roomid="' +
((__t = ( o.roomId )) == null ? '' : __t) +
'"\n					hotelid="' +
((__t = ( o.hotelId )) == null ? '' : __t) +
'"\n					supplierid="' +
((__t = ( o.supplierId )) == null ? '' : __t) +
'"\n					data-type="' +
((__t = ( typeText )) == null ? '' : __t) +
'"\n					data-track="详情页_酒店项_展开房型"   >\n						<span>更多</span>\n						<i class="room-type-icon room-type-down"></i>\n				</span> -->\n				';
 } ;
__p += '\n				<!-- 新增按钮  超值房型表格!!!!##### -->\n				';
 if(n.roomTypePrices.length > 1 && index ===0){ ;
__p += '\n				<!-- <span class="new-btn hp-roomName' +
((__t = ( j !== 0 ? '' : ' hidden' )) == null ? '' : __t) +
'"\n					roomid="' +
((__t = ( o.roomId )) == null ? '' : __t) +
'"\n					hotelid="' +
((__t = ( o.hotelId )) == null ? '' : __t) +
'"\n					supplierid="' +
((__t = ( o.supplierId )) == null ? '' : __t) +
'"\n					data-type="' +
((__t = ( typeText )) == null ? '' : __t) +
'"\n					data-track="详情页_酒店项_展开房型" >\n						<span>收起</span>\n						<i class="room-type-icon room-type-up"></i>	\n				</span> -->\n				';
 } ;
__p += '	\n			</td>\n\n            <!-- 第三个td -->\n			<td class="align-center">\n				';
 if(o.bedTypeName){ ;
__p += '\n				<p><span>' +
((__t = ( o.bedTypeName.split('[')[0] )) == null ? '' : __t) +
'</span></p>\n				';
 } ;
__p += '\n				<p><span class="' +
((__t = ( o.breakFastId == -2 ? 'multi-breakfast' : '' )) == null ? '' : __t) +
'">' +
((__t = ( o.breakFastName || '' )) == null ? '' : __t) +
'</span></p>\n			</td>\n\n            <!-- 第四个td -->\n            <td>\n                <span class="hp-order-clause">预定条款</span>\n                ';
 if(o.suppOtaChannel){ ;
__p += '\n                <span class="supp-ota" data-tip="禁售渠道：' +
((__t = ( o.suppOtaChannel )) == null ? '' : __t) +
'">OTA</span>\n                ';
 } ;
__p += '\n            </td>\n\n            <!-- 第五个td -->\n			<td>\n                <span class="hp-cancel-clause' +
((__t = ( o.cancellationText === '可取消' ? ' green' : '')) == null ? '' : __t) +
'" data-tip="' +
((__t = ( o.cancellationDesc )) == null ? '' : __t) +
'">' +
((__t = ( o.cancellationText )) == null ? '' : __t) +
'</span>\n            </td>\n\n            <!-- 第六个td -->\n			<td>\n                <span class="hp-store-status">' +
((__t = ( o.roomStatusText )) == null ? '' : __t) +
'</span>\n            </td>\n\n            <!-- 第七个td -->\n			<td>\n				<span class="hp-currency">均 ￥<span class="hp-average-price-num">' +
((__t = ( o.averagePriceRMB.toFixed(2).replace(/(\.0+|0+)$/, '') )) == null ? '' : __t) +
'</span></span>\n				<br>\n				<span class="hp-total-price">总 ￥<span class="hp-total-price-num">' +
((__t = ( o.totalPriceRMB )) == null ? '' : __t) +
'</span></span>\n			</td>\n\n            <!-- 第八个td 预订按钮 -->\n			<td class="last-td">\n				';
 if(o.isBook){ ;
__p += '\n					<a href="javascript:;" class="hp-order-btn' +
((__t = ( index === 0 ? ' orange' : ' blue')) == null ? '' : __t) +
'"\n						data-supplierId="' +
((__t = ( o.supplierId )) == null ? '' : __t) +
'"\n						data-hotelId="' +
((__t = ( o.hotelId )) == null ? '' : __t) +
'"\n						data-roomId="' +
((__t = ( o.roomId )) == null ? '' : __t) +
'"\n						data-breakFastId="' +
((__t = ( o.breakFastId )) == null ? '' : __t) +
'"\n						data-paymentType="' +
((__t = ( o.paymentType )) == null ? '' : __t) +
'"\n						data-rateType="' +
((__t = ( o.rateType )) == null ? '' : __t) +
'"\n						data-marketingStr="' +
((__t = ( o.marketingStr )) == null ? '' : __t) +
'" \n                        data-arriveStartTime="' +
((__t = ( (o.policies || o.checkInInstructions || o.specialCheckInInstructions) && o.arriveStartTime ? o.arriveStartTime : '' )) == null ? '' : __t) +
'"\n                        data-arriveEndTime="' +
((__t = ( (o.policies || o.checkInInstructions || o.specialCheckInInstructions) && o.arriveEndTime ? o.arriveEndTime : '' )) == null ? '' : __t) +
'"\n                        data-checkOutTime="' +
((__t = ( (o.policies || o.checkInInstructions || o.specialCheckInInstructions) && o.addAttrMap && o.addAttrMap.checkOutTime ? o.addAttrMap.checkOutTime : '' )) == null ? '' : __t) +
'" \n                        >\n\n						<span class="hidden nightlyPriceList">' +
((__t = ( window.JSON.stringify(o.nightlyPriceList) )) == null ? '' : __t) +
'</span>\n						<span class="hidden hotelPriceStrs">' +
((__t = ( encodeURIComponent( window.JSON.stringify(o) ) )) == null ? '' : __t) +
'</span>\n\n                        ';
 if(o.policies){ ;
__p += '\n                            <div class="hidden hotelPolicies">' +
((__t = ( o.policies )) == null ? '' : __t) +
'</div>\n                        ';
 } ;
__p += '\n\n                        ';
 if(o.addAttrMap && o.addAttrMap.fees_mandatory){ ;
__p += '\n                            <div class="hidden fees_mandatory">' +
((__t = ( o.addAttrMap.fees_mandatory )) == null ? '' : __t) +
'</div>\n                        ';
 } ;
__p += '\n                        ';
 if(o.addAttrMap && o.addAttrMap.fees_optional){ ;
__p += '\n                            <div class="hidden fees_optional">' +
((__t = ( o.addAttrMap.fees_optional )) == null ? '' : __t) +
'</div>\n                        ';
 } ;
__p += '\n					</a>\n\n                    <!-- 实时数据不显示日历价skuid = -1为实时 -->\n                    ';
 if(o.nightlyPriceList[0].skuId && o.nightlyPriceList[0].skuId != -1){ ;
__p += '\n                    <div \n                        class="calendar-price-div jump-order-btn"\n                        id="beforeJumpSearchPrice"\n                        data-hotelId="' +
((__t = ( o.hotelId )) == null ? '' : __t) +
'"\n                        data-roomId="' +
((__t = ( o.roomId )) == null ? '' : __t) +
'"\n                        data-supplierId="' +
((__t = ( o.supplierId )) == null ? '' : __t) +
'"\n                        data-rateType="' +
((__t = ( o.rateType )) == null ? '' : __t) +
'"\n                        data-marketingStr="' +
((__t = ( o.marketingStr )) == null ? '' : __t) +
'"\n                        data-currency="' +
((__t = ( o.currency )) == null ? '' : __t) +
'"\n                    >\n                        <img src="https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1720000432387.png" alt="" class="calendar-price-img jump-order-btn">\n                        <span class="calendar-price-span jump-order-btn">日历价</span>\n                    </div>\n                    ';
 } ;
__p += '\n\n\n				';
 }else{ ;
__p += '\n					<a href="javascript:;" class="hp-order-btn disabled"><span class="hidden nightlyPriceList">' +
((__t = ( window.JSON.stringify(o.nightlyPriceList) )) == null ? '' : __t) +
'</span><span class="hidden hotelPriceStrs">' +
((__t = ( o.hotelPriceStrs )) == null ? '' : __t) +
'</span></a>\n                    \n                    <!-- 实时数据不显示日历价skuid = -1为实时 -->\n                    ';
 if(o.nightlyPriceList[0].skuId && o.nightlyPriceList[0].skuId != -1){ ;
__p += '\n                    <div \n                        class="calendar-price-div jump-order-btn"\n                        id="beforeJumpSearchPrice"\n                        data-hotelId="' +
((__t = ( o.hotelId )) == null ? '' : __t) +
'"\n                        data-roomId="' +
((__t = ( o.roomId )) == null ? '' : __t) +
'"\n                        data-supplierId="' +
((__t = ( o.supplierId )) == null ? '' : __t) +
'"\n                        data-rateType="' +
((__t = ( o.rateType )) == null ? '' : __t) +
'"\n                        data-marketingStr="' +
((__t = ( o.marketingStr )) == null ? '' : __t) +
'"\n                        data-currency="' +
((__t = ( o.currency )) == null ? '' : __t) +
'"\n                    >\n                        <img src="https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1720000432387.png" alt="" class="calendar-price-img jump-order-btn">\n                        <span class="calendar-price-span jump-order-btn">日历价</span>\n                    </div>\n                    ';
 } ;
__p += '\n\n				';
 } ;
__p += '\n			</td>\n\n		</tr>\n		';
 } ;
__p += '\n\n        <!-- 新的展开更多价格 -->\n        ';
 if(index == 1 && n.roomTypePrices.length > 3 && (ch != 3 || n.roomName !== "其他 Other")){ ;
__p += '\n            <tr class="show-more-tr' +
((__t = ( i > 0 ? ' gt-one-tr' : '' )) == null ? '' : __t) +
'">\n                <td class="show-more-td1"></td>\n\n                <td colspan="8" class="show-more-td2"\n                    data-index="' +
((__t = ( i )) == null ? '' : __t) +
'"\n                    data-type="' +
((__t = ( typeText )) == null ? '' : __t) +
'"\n                    data-track="详情页_酒店项_展开房型"   \n                >\n                    <span>更多价格</span>\n                    <i class="room-type-icon room-type-down"></i>\n                </td>\n\n            </tr>\n        ';
 } ;
__p += '\n\n	';
 } ;
__p += '\n	</tbody>\n\n\n\n    <!-- 底部展开全部 -->\n	';
 if(index == 1 && roomTypeBases.length > 1){ ;
__p += '\n	<tfoot>\n		<tr>\n			<td colspan="9">\n				<div class="hli-expand-inner" data-hotelid="35429" data-track="详情页_酒店项_展开全部房型">\n					<span>收起全部房型</span>\n					<i class="hli-icon icon-up"></i>\n				</div>\n			</td>\n		</tr>\n	</tfoot>\n	';
 } ;
__p += '\n</table>\n';
 }) ;
__p += '\n\n\n\n<script>\n    //let pageFrom = \'hotelDetail\';  //定义一个变量,区分展开收起来自详情页面;\n    $.pageFrom = \'hotelDetail\';\n	//根据文字长度改变height\n	// function changeHeight() {\n	// 	let btn = $(\'.newmytr\').find($(\'.span-title\')) \n	// 	$.each(btn,function(index,item){\n	// 		// console.log(\'我在这\',$(this).html().length);\n    //         let lengthNum = $(this).html().length\n	// 		if(lengthNum>13 && lengthNum<=26 ){\n    //             // console.log(111);\n	// 			$(this).css({\n	// 				height:\'92px\'\n	// 			})\n	// 		} else if(lengthNum>26 && lengthNum<=39) {\n    //             // console.log(222);\n	// 			$(this).css({\n	// 				height:\'95px\',\n    //                 alignItems: \'start\',\n    //                 paddingTop:\'7px\'\n	// 			})\n	// 		}  else {\n                \n    //         }\n	// 	})\n	// }\n	// changeHeight()\n\n\n	\n	// function changeType(){\n	// 	var _table =  $("table") || \'\';\n	// 	var _this = $(_table).find(\'.hp-roomName\')\n	// 			typeText = _this.attr(\'data-type\'),\n	// 			typeTd = _this.closest(\'table\').find(\'.first-td[data-type=\' + typeText + \']\'),\n	// 			spanRow = +typeTd.attr(\'rowspan\'),\n	// 			thisTd = _this.closest(\'td\'),\n	// 			dragIcon = _this.find(\'.room-type-icon\');\n		\n	// 	let sameRoomTypeTrs = $(\'.myBody\').find(\'.auto-hide-tr\')			\n	// 	$.each(sameRoomTypeTrs, function(i, o) {\n			\n	// 		setTimeout(function(){\n	// 			$(o).find(\'td\').addClass(\'hidden\');\n	// 		}, 80);\n\n	// 		$(o).slideUp(\'fast\');\n	// 	});\n	// }\n	// changeType()\n\n	\n\n</script>\n';

}
return __p
}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {



var hotelQueryParams = {};

var Util = __webpack_require__(0),
    addDays = Util.addDays,
    queryString = Util.queryString,
    monthStr = __webpack_require__(125),
    calendarEvents = __webpack_require__(342),
    queryPriceForCalendar = __webpack_require__(214);

function initOrderBtnClick(y, m, option) {
    __webpack_require__(343);

    $(document).delegate('#ticketCalenderPrice', 'click', function () {
        console.log("ticketCalenderPrice");
        var _this = $(this),
            external = _this.attr('data-citytype') === '3',
            checkin = external ? addDays(new Date(), 1, '-') : addDays(new Date(), 0, '-'),
            checkout = external ? addDays(new Date(), 30, '-') : addDays(new Date(), 29, '-'),
            ticketRangeId = queryString('ticketRangeId'),
            ticketType = queryString('ticketType'),
            priceType = queryString('priceType'),
            paymentType = queryString('paymentType'),
            itemId = queryString('itemId'),
            formulaType = queryString('formulaType');

        if (_this.hasClass('disabled')) return;

        var orderParam = {
            monthStr: monthStr(y, m),
            ticketRangeId: ticketRangeId,
            ticketType: ticketType,
            priceType: priceType,
            paymentType: paymentType,
            itemId: itemId,
            formulaType: formulaType,
            startDateStr: checkin,
            endDateStr: checkout
        };

        var orderParamPanel = __webpack_require__(215)(orderParam);

        $('.calendarPrice').html(orderParamPanel);

        $('.hiddenOrderPrice').attr({
            'data-ticketrangeid': ticketRangeId,
            'data-ticketType': ticketType,
            'data-priceType': priceType,
            'data-paymentType': paymentType,
            'data-itemId': itemId,
            'data-formulaType': formulaType
        });

        queryPriceForCalendar(orderParam, null, option);
    });

    $(document).delegate('#beforeJumpSearchPrice', 'click', function () {
        var searchParams = new URLSearchParams(window.location.search);


        var _this = $(this),
            external = searchParams.get('ch') === '3',
            checkin = external ? addDays(new Date(), 1, '-') : addDays(new Date(), 0, '-'),
            checkout = external ? addDays(new Date(), 30, '-') : addDays(new Date(), 29, '-'),
            hotelId = _this.attr('data-hotelId'),
            roomId = _this.attr('data-roomId'),
            supplierId = _this.attr('data-supplierId'),
            rateType = _this.attr('data-rateType'),
            marketingStr = _this.attr('data-marketingStr');
        currency = _this.attr('data-currency');

        hotelQueryParams.hotelId = hotelId;
        hotelQueryParams.roomId = roomId;
        hotelQueryParams.supplierId = supplierId;
        hotelQueryParams.rateType = rateType;
        hotelQueryParams.marketingStr = marketingStr;

        if (_this.hasClass('disabled')) return;

        var orderParam = {
            monthStr: monthStr(y, m),
            startDateStr: checkin,
            endDateStr: checkout,
            hotelId: hotelId,
            roomType: roomId,
            suppId: supplierId,
            priceType: rateType,
            currency: currency
        };

        var orderParamPanel = __webpack_require__(215)(orderParam);

        var offsetNum = _this.offset();

        $('.calendarPrice').html(orderParamPanel);
        $('.calendar-price-wrap').css({
            'left': '54%',
            'top': offsetNum.top + 45
        });

        $('.hiddenOrderPrice').attr({
            'data-hotelId': hotelId,
            'data-suppId': supplierId,
            'data-roomType': roomId,
            'data-priceType': rateType,
            'data-currency': currency
        });

        queryPriceForCalendar(orderParam, null, option);
    });

    $(document).on('click', function (e) {
        e.stopPropagation();
        if ($('.jump-order-btn').length !== 0) {
            if (!$('.calendar-price-wrap').is(e.target) && $('.calendar-price-wrap').has(e.target).length == 0 && !$(e.target).hasClass('jump-order-btn')) {
                setTimeout(function () {
                    $('.calendar-price-wrap').hide();
                }, 200);
            }
        } else {
            if (!$('#ticketCalenderPrice').is(e.target) && !$('.calendar-price-wrap').is(e.target) && $('.calendar-price-wrap').has(e.target).length == 0 && !$(e.target).hasClass('month-switch-bar')) {
                setTimeout(function () {
                    $('.calendar-price-wrap').hide();
                }, 200);
            }
        }
    });
}

module.exports = {

    run: function run(y, m, option) {
        initOrderBtnClick(y, m, option);

        calendarEvents(option);
    },
    hotelQueryParams: hotelQueryParams
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {



var addDays = __webpack_require__(0).addDays;

function queryPrice(layero, month, option) {

    var params = {
        hotelId: layero.hotelId,
        suppId: layero.suppId,
        roomType: layero.roomType,
        priceType: layero.priceType,
        startDateStr: layero.startDateStr,
        endDateStr: layero.endDateStr,
        currency: layero.currency
    };

    $.post('/hotel/hotelCalendarPrice.do', params, function (data) {
        fillCalendarWithPrices(layero, data, option);
    });
}

function fillCalendarWithPrices(layero, res, option) {
    if (res.data && res.returnCode === 1) {

        var dayArr = $('.calendar-price-wrap').find('.cp-td-inner');

        $.each(res.data, function (date, o) {
            dayArr.each(function (i, e) {
                var p = dayArr[i],
                    pDayStr = $(p).attr('data-day');

                if (pDayStr === date.replace(/-/g, '/')) {

                    console.log("date", date);

                    if (o.salePrice) {
                        var price = o.salePrice;
                        var tmpStr = '\n                        <p class="calendar-p-price">\uFFE5 ' + price + ' </p>\n                        <span class="check-in-span hidden">\u5165\u4F4F</span>\n                        <span class="check-out-span hidden">\u79BB\u5E97</span>\n                        ';
                        $(p).append(tmpStr);
                        $(p).removeClass('disabled');
                    }
                }
            });
        });

        var hasCheckinDate = $('.calendar-price-wrap').find('.checkin').attr('data-day');
        if (hasCheckinDate) {
            var arrDom = $('.calendar-price-wrap').find('.cp-td-inner');
            setTmpGray(arrDom, hasCheckinDate);
        }

        if (option) {
            option;
        }
    } else if (res.returnCode === -400001) {
        alert('请先登录', { closeBtn: 0 }, function () {
            location.href = '/user/bookHotel.do?';
        });
    } else {
        alert(res.errinfo);
    }
}

function setTmpGray(dayArr, checkin) {
    if (dayArr && checkin) {

        var lastValidDay = new Date(addDays(checkin, 15, '/') + ' 23:59:59');
        var checkinDate = new Date(checkin);

        var hasNoPrice;

        for (var i = 0; i < dayArr.length; i++) {
            var _date = new Date($(dayArr[i]).attr('data-day'));

            if (hasNoPrice) {
                $(dayArr[i]).addClass('disabled-checkout');

                $(dayArr[i]).find(".calendar-p-price").addClass('calendar-d-price');
                continue;
            }

            if (_date > checkinDate && _date < lastValidDay && $(dayArr[i]).hasClass('disabled')) {
                $(dayArr[i]).removeClass('disabled');

                $(dayArr[i]).addClass('temporary-cancel-disabled');
                hasNoPrice = new Date($(dayArr[i]).attr('data-day'));
            }

            if (lastValidDay < _date) {
                $(dayArr[i]).addClass('disabled-checkout');

                $(dayArr[i]).find(".calendar-p-price").addClass('calendar-d-price');
            }
        }
    }
}

module.exports = function (layero, month, option) {
    queryPrice(layero, month, option);
};

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!-- 点击 "预定" 按钮时弹出的面板 -->\n<section>\n\n\n    <!-- 价格日历 -->\n    <section class="calendar-price-wrap">\n        <div class="month-switch-bar-wrap">\n            <div class="month-switch-bar month-left hidden"></div>\n            <div class="month-switch-bar month-right"></div>\n            <input type="hidden" class="hiddenOrderPrice">\n        </div>\n\n        <!-- 各月份的字符串 -->\n        ' +
((__t = ( monthStr )) == null ? '' : __t) +
'\n    </section>\n\n\n</section>\n';

}
return __p
}

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */
/***/ (function(module, exports, __webpack_require__) {


window.Promise = __webpack_require__(23);

__webpack_require__(4);
__webpack_require__(332);

__webpack_require__(333);

__webpack_require__(12).run('noLogin');
__webpack_require__(5).run();
__webpack_require__(18).run();

__webpack_require__(334).run();
__webpack_require__(339).run();
__webpack_require__(340).run();
__webpack_require__(341).run();

__webpack_require__(17);

var y = new Date().getFullYear(),
    m = new Date().getMonth();
__webpack_require__(213).run(y, m + 1);

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {



var count = 0;
var map2 = void 0;
var hotelNameG = void 0;
var hotelData = null;

var testList = [];

initMyOverlay = function initMyOverlay() {
    var MyOverlay = function MyOverlay(center, number) {
        this._center = center;
        this._number = number;
        this._length = 20;
    };

    MyOverlay.prototype = new AMap.Overlay();

    MyOverlay.prototype.initialize = function (map) {
        this._map = map;

        var div = document.createElement("div");
        div.classList = 'my-overlay-wrap';

        var icon = document.createElement("i");
        icon.classList = 'iconfont icon-location';
        div.appendChild(icon);

        var span = document.createElement("span");
        span.classList = 'my-overlay-index';
        span.textContent = this._number;
        div.appendChild(span);

        map.getPanes().markerPane.appendChild(div);

        this._div = div;

        return div;
    };

    MyOverlay.prototype.draw = function () {
        var position = this._map.pointToOverlayPixel(this._center);
        this._div.style.left = position.x - 15 + "px";
        this._div.style.top = position.y - 35 + "px";
    };

    MyOverlay.prototype.show = function () {
        if (this._div) {
            this._div.style.display = "";
        }
    };

    MyOverlay.prototype.hide = function () {
        if (this._div) {
            this._div.style.display = "none";
        }
    };
};

var Util = __webpack_require__(0),
    queryString = Util.queryString,
    addDays = Util.addDays,
    priceTableTmpl = __webpack_require__(212),
    hotelInfoTmpl = __webpack_require__(335),
    hotelInfoDetailsTmpl = __webpack_require__(336),
    poiTypeTmpl = __webpack_require__(337),
    hotelLicensesTmpl = __webpack_require__(338),
    queryPrices = __webpack_require__(137),
    mapKeyArr = ['景点', '餐馆', '便利店', '商场', '游乐园', '公园', '地铁站', '租车店', '火车站', '机场'],
    initOpenMap = function initOpenMap() {
    $(".hdi-open-map").on('click', function () {
        var _this = $(this),
            _link = _this.attr('data-link'),
            hotelName = _this.attr('data-hotelname'),
            iWidth = 650,
            iHeight = 500,
            iTop = (window.screen.availHeight - 30 - iHeight) / 2,
            iLeft = (window.screen.availWidth - 10 - iWidth) / 2;

        window.open(_link, hotelName, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no');
    });
},
    setInitParams = function setInitParams(params) {

    var datesInput = document.querySelector(".s-i-dates-input");
    var roomNum = document.querySelector(".s-i-room-num");
    var adultChildren = document.querySelector(".s-i-adult-children");

    var lastQueryParams = sessionStorage.getItem('queryParamsToHotelDetail');
    if (lastQueryParams) {
        lastQueryParams = window.JSON.parse(lastQueryParams);
        params.selRoomNum = lastQueryParams.selRoomNum;
        params.adultNum = lastQueryParams.adultNum;
        params.childrenNum = lastQueryParams.childrenNum;
        params.childrenAgesStr = lastQueryParams.childrenAgesStr;

        if (lastQueryParams.priceRange) {
            var priceArr = lastQueryParams.priceRange.split('-');
            $('#slp_1').val(priceArr[0]);
            $('#slp_2').val(priceArr[1]);
        }

        if (lastQueryParams.cancelType && ~lastQueryParams.cancelType.indexOf('canceltype-0')) {
            $('.d-s-item[data-value="canceltype-0"]').click();
        }

        if (lastQueryParams.confirmType && ~lastQueryParams.confirmType.indexOf('XS-1')) {
            $('.d-s-item[data-value="XS-1"]').click();
        }

        if (lastQueryParams.confirmType && ~lastQueryParams.confirmType.indexOf('XS-2')) {
            $('.d-s-item[data-value="XS-2"]').click();
        }
    }

    datesInput.checkin = params.startDate;
    datesInput.checkout = params.endDate;
    $(datesInput).val(params.startDate.replace(/-/g, '/') + ' - ' + params.endDate.replace(/-/g, '/'));

    $(roomNum).html(params.selRoomNum + '间').attr('data-value', params.selRoomNum);

    adultChildren.adultNum = params.adultNum;
    adultChildren.childrenNum = params.childrenNum;
    adultChildren.childrenAgesStr = params.childrenAgesStr;
    $(adultChildren).val(params.adultNum + '成人，' + params.childrenNum + '小孩');
},
    setHotelInfo = function setHotelInfo(data) {
    data.picList = data.picList || [];
    var picArr = data.picSrc.split('|');
    if (!data.picList.length) data.picList = picArr;
    data.picSrc = picArr[0];

    $("#hotel-name").html(data.infoName);

    $(".hotel-detail-info-outer").html(hotelInfoTmpl({ o: data }));
    $(".hotel-detail-outer").html(hotelInfoDetailsTmpl({ o: data }));
    $("#acWrap").html(hotelLicensesTmpl({ o: data }));

    hotelData = data;

    if (data.countryType == 3) {
        loadBinMap();
    } else {
        loadJScript();
    }
},
    loadJScript = function loadJScript() {
    window._AMapSecurityConfig = {
        securityJsCode: "29c997b3acbee02306d298f32a52affe"
    };

    window.onLoad = function () {
        var map = new AMap.Map("mapCon1");
    };
    var url = "https://webapi.amap.com/maps?v=2.0&key=10ea136f173c976c698b72830aa582b2&callback=initMap";
    var jsapi = document.createElement("script");

    jsapi.src = url;
    document.body.appendChild(jsapi);
};

loadBinMap = function loadBinMap() {
    var url = "https://www.bing.com/api/maps/mapcontrol?callback=GetBinMap&key=AkWVMxrbKvEVAZW8S9fwiOL9Q70uKer-kgpKwExVOVz3WbtDq0IsDEYJhRKo6_av&setLang=zh-CN";
    var jsapi = document.createElement("script");

    jsapi.src = url;
    document.body.appendChild(jsapi);
};

GetBinMap = function GetBinMap() {
    setBinMap(hotelData);
};

setBinMap = function setBinMap(data) {
    var result = gcoord.transform([+data.longitude, +data.latitude], gcoord.BD09, gcoord.GCJ02);

    $('.poi-hotel-name-outer .name').html(data.infoName);
    $('.poi-hotel-name-outer .address').html(data.address);
    var map = new Microsoft.Maps.Map('#mapCon1', {
        zoom: 12,
        center: new Microsoft.Maps.Location(result[1], result[0]) });

    var center = map.getCenter();

    var pin = new Microsoft.Maps.Pushpin(center, {
        icon: "https://api.map.baidu.com/images/marker_red_sprite.png"
    });

    map.entities.push(pin);

    var infobox = new Microsoft.Maps.Infobox(center, {
        htmlContent: "\n                <div class=\"customInfobox\">\n                    " + hotelData.infoName + "\n                </div>\n            "
    });

    infobox.setMap(map);

    setBinMaker(data);

    var div = document.createElement('a');
    div.href = '#hotelMap';
    div.classList = 'check-map-detail';
    div.appendChild(document.createTextNode("查看地图"));

    $("#mapCon1").append(div);
};

initMap = function initMap() {
    setMap(hotelData);
};

setMap = function setMap(data) {
    $('.poi-hotel-name-outer .name').html(data.infoName);
    $('.poi-hotel-name-outer .address').html(data.address);
    hotelNameG = data.infoName;

    var point = new AMap.LngLat(+data.longitude, +data.latitude);

    pointAfterConvert(point);
    return;

    if (data.countryType == 3) {
        AMap.convertFrom([point], "gps", function (status, result) {
            if (status === "complete" && result.info === "ok") {
                var lnglats = result.locations;
                console.log(lnglats);
            }
        });
    } else {
        pointAfterConvert(point);
    }
}, translateCallback = function translateCallback(data) {
    if (data.status === 0) {
        pointAfterConvert(data.points[0]);
    }
}, pointAfterConvert = function pointAfterConvert(point) {

    var result = gcoord.transform([+point.lng, +point.lat], gcoord.BD09, gcoord.GCJ02);

    var map = new AMap.Map("mapCon1");
    $(".amap-logo").remove();
    $(".amap-copyright").remove();

    map.setZoomAndCenter(15, new AMap.LngLat(result[0], result[1]));
    map.setFeatures(['bg', 'road', 'building', 'point']);

    var marker = new AMap.Marker({
        position: new AMap.LngLat(result[0], result[1]),
        offset: new AMap.Pixel(0, 0),
        icon: "https://api.map.baidu.com/images/marker_red_sprite.png"
    });
    map.add(marker);

    var customTitle = document.createElement('div');
    customTitle.style.padding = '5px';
    customTitle.style.background = 'white';
    customTitle.style.border = '1px solid #ccc';
    customTitle.style.width = '145px';
    customTitle.style.position = 'absolute';
    customTitle.style.top = '-130%';
    customTitle.style.left = '-180%';
    customTitle.style.textAlign = 'center';
    customTitle.style.backgroundColor = '#ff4500';
    customTitle.style.color = '#fff';
    customTitle.style.fontSize = '12px';
    customTitle.style.whiteSpace = 'nowrap';
    customTitle.style.overflow = 'hidden';
    customTitle.style.textOverflow = 'ellipsis';
    customTitle.innerHTML = hotelData.infoName;
    $("#mapCon1").find(".amap-marker").append(customTitle);

    var div = document.createElement('a');
    div.href = '#hotelMap';
    div.classList = 'check-map-detail';
    div.appendChild(document.createTextNode("查看地图"));
    map.getContainer().appendChild(div);

    window.setTimeout(function () {
        var marker1 = new AMap.Marker({
            position: new AMap.LngLat(result[0], result[1]),
            offset: new AMap.Pixel(0, 0),
            zIndex: 999,
            icon: "https://api.map.baidu.com/images/marker_red_sprite.png",
            extData: {
                className: 'my-marker-class' }
        });
        var map2 = new AMap.Map("MapContainer");
        $(".amap-logo").remove();
        $(".amap-copyright").remove();
        map2.setZoomAndCenter(15, new AMap.LngLat(result[0], result[1]));
        map2.setFeatures(['bg', 'road', 'building', 'point']);
        map2.add(marker1);
        setLessMapMaker(map2);
    }, 1000);

    return;

    map.centerAndZoom(point, 15);
    map.enableScrollWheelZoom(true);

    var marker = new BMap.Marker(point);
    map.addOverlay(marker);
    marker.setAnimation(BMAP_ANIMATION_BOUNCE);

    map2 = new BMap.Map("MapContainer");
    map2.centerAndZoom(point, 15);
    map2.enableScrollWheelZoom(true);
    map2.addControl(new BMap.NavigationControl());
    map2.addControl(new BMap.MapTypeControl({ mapTypes: [BMAP_NORMAL_MAP, BMAP_SATELLITE_MAP] }));

    setMapMaker(point);
    setLessMapMaker();
    var div = document.createElement('a');
    div.href = '#hotelMap';
    div.classList = 'check-map-detail';
    div.appendChild(document.createTextNode("查看地图"));
    map.getContainer().appendChild(div);

    var local = new BMap.LocalSearch(map2);
    local.setSearchCompleteCallback(searchCompleteCallBack);
    for (var i = 0; i < mapKeyArr.length; i++) {
        local.searchNearby(mapKeyArr[i], point, 1000);
    }
}, setBinMaker = function setBinMaker(data) {
    var result = gcoord.transform([+data.longitude, +data.latitude], gcoord.BD09, gcoord.GCJ02);

    var map = new Microsoft.Maps.Map('#MapContainer', {
        zoom: 12,
        center: new Microsoft.Maps.Location(result[1], result[0]) });
    window.setTimeout(function () {
        $(".NavBar_Container").remove();
        $(".bm_bottomLeftOverlay").remove();
    }, 300);

    var center = map.getCenter();

    var pin = new Microsoft.Maps.Pushpin(center, {
        icon: "https://api.map.baidu.com/images/marker_red_sprite.png"
    });

    map.entities.push(pin);

    var infobox = new Microsoft.Maps.Infobox(center, {
        htmlContent: "\n                <div class=\"customInfobox curShow\">\n                    " + data.infoName + "\n                </div>\n            "
    });

    infobox.setMap(map);

    Microsoft.Maps.Events.addHandler(pin, 'mouseover', function (e) {
        $(".curShow").css({
            display: "block"
        });
    });

    Microsoft.Maps.Events.addHandler(pin, 'mouseout', function (e) {
        $(".curShow").css({
            display: "none"
        });
    });

    $(".poi-hotel-name-outer").on('mouseover', function () {
        $("#MapContainer").find(".curShow").css({
            display: 'block'
        });
    });

    $(".poi-hotel-name-outer").on('mouseout', function () {
        $("#MapContainer").find(".curShow").css({
            display: 'none'
        });
    });

    $(".poi-hotel-name-outer").on('click', function () {
        map.setView({ center: center });
    });

    $('.nearby-hotel-info').empty();
    if (testList.length === 0) {
        return;
    }

    testList.forEach(function (item, index) {
        var newHistory = "\n                <div class=\"info-item\">\n                    <div>" + item.infoName + "</div>\n                    <div class=\"item-div\">\n                        <div>" + item.address + "</div>\n                    </div>\n                </div>\n            ";
        $(newHistory).appendTo('.nearby-hotel-info');

        var result1 = gcoord.transform([+item.longitude, +item.latitude], gcoord.BD09, gcoord.GCJ02);

        var infobox = new Microsoft.Maps.Infobox(new Microsoft.Maps.Location(result1[1], result1[0]), {
            htmlContent: "\n                    <div class=\"lable-price-css lable-all" + index + "\">\n                        <div class=\"label-tixing" + index + " childLable\" style=\"background-color: #fff;text-align: center;position:absolute;top:-65px;left:-85px;padding:5px;border:1px solid #333;border-radius:5px;display:none;\">\n                                <h1 style=\"color:#333;font-size:14px;width:210px;margin-bottom:5px;white-space: nowrap;overflow: hidden;text-overflow:ellipsis;\">" + item.infoName + "</h1>\n                                <span style=\"color:#0066ff;font-size:13px;\">" + (item.hasOwnProperty('minPrice') && item.minPrice ? '￥' + item.minPrice : '未查询到报价') + "</span>\n                                <span style=\"color:#333;margin-top:5px;font-size:13px;\">\u8D77</span>\n                        </div>\n                        <span class=\"nearyBy-label" + index + " nearyByItem \">\n                            " + (item.hasOwnProperty('minPrice') && item.minPrice ? '￥' + item.minPrice : "未查询到报价") + "  \n                        </span>\n                    </div>\n                "
        });

        infobox.setMap(map);

        var hotelNameOuter = $(".info-item")[index];

        $(hotelNameOuter).on('mouseover', function () {
            $(".label-tixing" + index).css({
                display: 'block'
            });
        });
        $(hotelNameOuter).on('mouseout', function () {
            $(".label-tixing" + index).css({
                display: 'none'
            });
        });
        $(hotelNameOuter).on('click', function () {
            map.setView({ center: new Microsoft.Maps.Location(result1[1], result1[0]) });
        });
    });
}, setLessMapMaker = function setLessMapMaker(map2) {
    var customTitle = document.createElement('div');
    customTitle.classList.add('new-class');
    customTitle.style.padding = '5px';
    customTitle.style.background = 'white';
    customTitle.style.border = '1px solid #ccc';
    customTitle.style.width = '170px';
    customTitle.style.position = 'absolute';
    customTitle.style.top = '-130%';
    customTitle.style.left = '-210%';
    customTitle.style.textAlign = 'center';
    customTitle.style.backgroundColor = '#ff4500';
    customTitle.style.color = '#fff';
    customTitle.style.fontSize = '13px';
    customTitle.style.whiteSpace = 'nowrap';
    customTitle.style.overflow = 'hidden';
    customTitle.style.textOverflow = 'ellipsis';
    customTitle.style.display = 'none';
    customTitle.innerHTML = hotelData.infoName;
    $("#MapContainer").find(".amap-marker").append(customTitle);

    var result1 = gcoord.transform([+hotelData.longitude, +hotelData.latitude], gcoord.BD09, gcoord.GCJ02);

    $(".poi-hotel-name-outer").on('mouseover', function () {
        $("#MapContainer").find(".amap-marker .new-class").parent(".amap-marker").css({
            'z-index': '999'
        });
        $("#MapContainer").find(".amap-marker .new-class").css({
            display: 'block'
        });
    });

    $(".poi-hotel-name-outer").on('mouseout', function () {
        $("#MapContainer").find(".amap-marker .new-class").parent(".amap-marker").css({
            'z-index': '998'
        });
        $("#MapContainer").find(".amap-marker .new-class").css({
            display: 'none'
        });
    });

    $(".poi-hotel-name-outer").on('click', function () {
        map2.setCenter([result1[0], result1[1]]);
    });

    $("#MapContainer .amap-marker .new-class").parent(".amap-marker").on('mouseover', function () {
        $(this).css({
            'z-index': '999'
        });
        $(this).find(".new-class").css({
            display: 'block'
        });
    });

    $("#MapContainer .amap-marker .new-class").parent(".amap-marker").on('mouseout', function () {
        $(this).css({
            'z-index': '12'
        });
        $(this).find(".new-class").css({
            display: 'none'
        });
    });

    $('.nearby-hotel-info').empty();
    if (testList.length === 0) {
        return;
    }


    testList.forEach(function (item, index) {
        var newHistory = "\n\t\t\t\t<div class=\"info-item\">\n\t\t\t\t\t<div>" + item.infoName + "</div>\n\t\t\t\t\t<div class=\"item-div\">\n\t\t\t\t\t\t<div>" + item.address + "</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t";
        $(newHistory).appendTo('.nearby-hotel-info');

        var content = "\n                <div class=\"lable-price-css lable-all" + index + "\">\n                    <div class=\"label-tixing" + index + " childLable\" style=\"background-color: #fff;text-align: center;position:absolute;top:-65px;left:-85px;padding:5px;border:1px solid #333;border-radius:5px;display:none;\">\n                            <h1 style=\"color:#333;font-size:14px;width:210px;margin-bottom:5px;white-space: nowrap;overflow: hidden;text-overflow:ellipsis;\">" + item.infoName + "</h1>\n                            <span style=\"color:#0066ff;font-size:13px;\">" + (item.hasOwnProperty('minPrice') && item.minPrice ? '￥' + item.minPrice : '未查询到报价') + "</span>\n                            <span style=\"color:#333;margin-top:5px;font-size:13px;\">\u8D77</span>\n                    </div>\n                    <span class=\"nearyBy-label" + index + " nearyByItem \">\n                        " + (item.hasOwnProperty('minPrice') && item.minPrice ? '￥' + item.minPrice : "未查询到报价") + "  \n                    </span>\n                </div>\n            ";

        var result2 = gcoord.transform([+item.longitude, +item.latitude], gcoord.BD09, gcoord.GCJ02);

        var marker = new AMap.Marker({
            position: new AMap.LngLat(result2[0], result2[1]),
            offset: new AMap.Pixel(0, 0),

            content: content
        });
        map2.add(marker);

        var hotelNameOuter = $(".info-item")[index];

        $(hotelNameOuter).on('mouseover', function () {
            $(".lable-all" + index).parent(".amap-marker").css({
                'z-index': '999'
            });
            $(".label-tixing" + index).css({
                display: 'block'
            });
        });
        $(hotelNameOuter).on('mouseout', function () {
            $(".lable-all" + index).parent(".amap-marker").css({
                'z-index': '12'
            });
            $(".label-tixing" + index).css({
                display: 'none'
            });
        });

        $(hotelNameOuter).on('click', function () {
            map2.setCenter([result2[0], result2[1]]);
        });

        return;
        var point = { lat: item.latitude, lng: item.longitude };
        var icon = new BMap.Icon('https://s3.bmp.ovh/imgs/2022/04/11/4d650aa0123df092.png', new BMap.Size(0, 0));
        var marker = new BMap.Marker(point, { icon: icon });
        map2.addOverlay(marker);

        var opts = {
            position: point,
            offset: new BMap.Size(0, -1) };

        var label = new BMap.Label("\n\t\t\t<div class=\"label-tixing\" style=\"background-color: #fff;text-align: center;position:absolute;top:-65px;left:-85px;padding:5px;border:1px solid #333;border-radius:5px;display:none;\">\n\t\t\t\t\t<h1 style=\"color:#333;font-size:14px;width:210px;margin-bottom:5px;white-space: nowrap;overflow: hidden;text-overflow:ellipsis;\">" + item.infoName + "</h1>\n\t\t\t\t\t<span style=\"color:#0066ff;font-size:13px;\">" + (item.hasOwnProperty('minPrice') && item.minPrice ? '￥' + item.minPrice : '未查询到报价') + "</span>\n\t\t\t\t\t<span style=\"color:#333;margin-top:5px;font-size:13px;\">\u8D77</span>\n            </div>\n\t\t\t<span class=\"nearyBy-label" + index + "\">" + (item.hasOwnProperty('minPrice') && item.minPrice ? '￥' + item.minPrice : '未查询到报价') + '</span>', opts);
        label.setStyle({
            transform: "translate(-50%, 0)",
            border: "none",
            color: "white",
            background: "#0066ff",
            padding: "5px 10px",
            lineHeight: "20px",
            boxShadow: "0 0px 5px #0066ff"
        });

        var hotelNameOuter = $('.info-item')[index];

        hotelNameOuter.marker = marker;
        hotelNameOuter.label = label;
        map2.addOverlay(hotelNameOuter.label);

        hotelNameOuter.point = point;

        $(hotelNameOuter).on('mouseover', function () {
            var domData = $(this)[0].label.V.children[0];
            $(domData).parent().css({
                'z-index': '129398569'
            });
            $(domData).css({
                display: 'block'
            });
        });
        $(hotelNameOuter).on('mouseout', function () {
            var domData = $(this)[0].label.V.children[0];
            $(domData).parent().css({
                'z-index': '12939856'
            });
            $(domData).css({
                display: 'none'
            });
        });

        $(hotelNameOuter).on('click', function () {
            map2.panTo(new BMap.Point(point.lng, point.lat));
        });

        $(document).on('mouseover', ".nearyBy-label" + index, function () {
            $(this).parent().css({
                'z-index': '129398569'
            });
            $(this).prev('.label-tixing').css({
                display: 'block'
            });
        });

        $(document).on('mouseout', ".nearyBy-label" + index, function () {
            $(this).parent().css({
                'z-index': '12939856'
            });
            $(this).prev('.label-tixing').css({
                display: 'none'
            });
        });
    });
}, setMapMaker = function setMapMaker(point) {
    var marker = new BMap.Marker(point);
    map2.addOverlay(marker);
    marker.setAnimation(BMAP_ANIMATION_BOUNCE);

    var opts = {
        position: point,
        offset: new BMap.Size(0, -80) };
    var label = new BMap.Label('<span class="poi-item-lable-content">' + hotelNameG + '</span>', opts);
    label.setStyle({
        transform: "translate(-50%, 0)",
        border: "none",
        color: "white",
        background: "orangered",
        padding: "5px 10px",
        lineHeight: "20px",
        boxShadow: "0 0px 5px #ec7764"
    });

    var hotelNameOuter = document.querySelector('.poi-hotel-name-outer');
    hotelNameOuter.marker = marker;
    hotelNameOuter.label = label;
    map2.addOverlay(hotelNameOuter.label);
    hotelNameOuter.label.hide();
    hotelNameOuter.point = point;

    setTimeout(function () {
        hotelNameOuter.marker.V.label = hotelNameOuter.label;
        $(hotelNameOuter.marker.V).on('mouseover', function () {
            this.label.show();
        });
        $(hotelNameOuter.marker.V).on('mouseout', function () {
            this.label.hide();
        });
    }, 300);

    $('.poi-hotel-name-outer').on('mouseover', function () {
        var marker = this.marker;
        $('.my-overlay-wrap').removeClass('active');

        var allArr = $('.poi-item-li');
        for (var i = 0; i < allArr.length; i++) {
            allArr[i].label.hide();
            allArr[i].MyOverlay.hide();
        }

        this.label.show();
    });

    $('.poi-hotel-name-outer').on('mouseout', function () {
        this.marker.V.label.hide();
    });

    $('.poi-hotel-name-outer').on('click', function () {
        var point = this.point;
        map2.panTo(new BMap.Point(point.lng, point.lat));
    });
}, searchCompleteCallBack = function searchCompleteCallBack(res) {
    var poiWrap = $('#mapNavInner li').filter(function (i, n) {
        return $(n).attr('data-key') === res.keyword;
    });

    if (res.bR > 0) {
        for (var i = 0; i < res.Ar.length; i++) {
            var o = res.Ar[i];
            o.url = o.url.replace(/gsp0.baidu.com\/80MWsjip0QIZ8tyhnq/g, 'map.baidu.com');
        }

        res.len = Math.min(5, res.bR);
        poiWrap.find('.poi-type-num').html(res.len + '家');
        poiWrap.find('.poi-type-res-wrap').html(poiTypeTmpl(res));
    } else {
        poiWrap.remove();
    }

    count++;
    if (count >= res.len) {
        $($('.poi-type-res-wrap')[0]).removeClass('hidden');
        addAllOverlay();
    }
}, addAllOverlay = function addAllOverlay() {
    var arr = $('.poi-item-li');

    for (var i = 0; i < arr.length; i++) {
        var point = JSON.parse(decodeURIComponent($(arr[i]).attr('data-point')));
        var index = $(arr[i]).attr('data-index');

        arr[i].MyOverlay = new MyOverlay(point, index);
        map2.addOverlay(arr[i].MyOverlay);
        arr[i].MyOverlay.hide();

        var opts = {
            position: point,
            offset: new BMap.Size(0, -70) };
        var title = $(arr[i]).find('.title').attr('data-title');
        var label = new BMap.Label('<span class="poi-item-lable-content">' + title + '</span>', opts);
        label.setStyle({
            transform: "translate(-50%, 0)",
            border: "none",
            color: "white",
            background: "orangered",
            padding: "5px 10px",
            lineHeight: "20px",
            boxShadow: "0 0px 5px #ec7764"
        });
        arr[i].label = label;
        map2.addOverlay(arr[i].label);
        arr[i].label.hide();

        arr[i].MyOverlay._div.MyOverlay = arr[i].MyOverlay;
        arr[i].MyOverlay._div.label = arr[i].label;
    }

    initOverlayHover();
}, initOverlayHover = function initOverlayHover() {
    $('.my-overlay-wrap').on('mouseover', function () {
        this.label.show();
        $(this).addClass('active');
    });

    $('.my-overlay-wrap').on('mouseout', function () {
        this.label.hide();
        $(this).removeClass('active');
    });
}, initPOItitleEvents = function initPOItitleEvents(data) {
    $(document).delegate('#showLicenses', 'click', function () {
        var showLicensesDOM = null;
        var he = $();
        showLicensesDOM = layer.open({
            type: 1,
            title: false,

            area: ['60%', '68%'],
            shade: 0.5,
            content: hotelLicensesTmpl({
                o: data
            })
        });
    });

    $(document).delegate('.poi-type-title', 'click', function () {
        var arr = $(this).closest('ul').find('.poi-type-res-wrap');
        arr.slideUp('fast');
        var thisWrap = $(this).parent().find('.poi-type-res-wrap');
        if (thisWrap.css('display') === 'block') {
            thisWrap.slideUp('fast');
        } else {
            thisWrap.slideDown('fast');
        }
    });

    $(document).delegate('.poi-block-li', 'mouseover', function () {
        var allArr = $('.poi-item-li');
        var arr = $(this).find('.poi-item-li');

        for (var i = 0; i < allArr.length; i++) {
            allArr[i].MyOverlay.hide();
        }

        for (var _i = 0; _i < arr.length; _i++) {
            arr[_i].MyOverlay.show();
        }
    });

    $(document).delegate('.poi-block-li', 'mouseout', function () {
        var allArr = $('.poi-item-li');
        for (var i = 0; i < allArr.length; i++) {
            allArr[i].label.hide();
        }
    });

    $(document).delegate('.poi-item-li', 'mouseover', function () {
        var myOverlay = this.MyOverlay;
        $('.my-overlay-wrap').removeClass('active');
        $(myOverlay._div).addClass('active');

        var allArr = $('.poi-item-li');
        for (var i = 0; i < allArr.length; i++) {
            allArr[i].label.hide();
        }

        this.label.show();
    });

    $(document).delegate('.poi-item-li', 'mouseout', function () {
        var myOverlay = this.MyOverlay;
        $(myOverlay._div).removeClass('active');
        this.label.hide();
    });

    $(document).delegate('.poi-item-li', 'click', function () {
        var center = this.MyOverlay._center;
        map2.panTo(new BMap.Point(center.lng, center.lat));
    });
}, queryHotels = function queryHotels(params) {
    $.post('/hotel/getHotelInfoList.do', params, function (res) {
        if (res.returnCode === 1) {
            if (res.dataList && res.dataList.length) {
                setHotelInfo(res.dataList[0]);


                var neabyHotelList = res.dataList[0].staticInfoList && res.dataList[0].staticInfoList.length ? res.dataList[0].staticInfoList : [];
                var hotelId = res.dataList[0].infoId;
                if (neabyHotelList.length > 0) {
                    for (var i = 0; i < neabyHotelList.length; i++) {
                        if (neabyHotelList[i].staticInfoId == hotelId) {
                            neabyHotelList.splice(i, 1);
                            break;
                        }
                    }
                }
                if (neabyHotelList.length > 4) {
                    testList = neabyHotelList.slice(0, 4);
                } else {
                    testList = neabyHotelList;
                }

                if (!neabyHotelList || !neabyHotelList.length) {
                    $(".nearby-hotel").empty();
                }
            }
        }
    });
}, setNavText = function setNavText(citytype) {
    var navText = citytype == 2 ? '港澳台' : citytype == 3 ? '海外' : '国内';

    $("#cityTypeText").html(navText);
}, getInitParamsAndInitPage = function getInitParamsAndInitPage() {
    var hotelId = queryString('hotelId');
    var hotelIdObj = $("#hotelId");
    var checkin = queryString('checkin');
    var checkout = queryString('checkout');
    var citytype = queryString('ch');
    var selRoomNum = queryString('selRoomNum') || 1;
    var adultNum = queryString('adultNum') || 2;
    var childrenNum = queryString('childrenNum') || 0;
    var childrenAgesStr = queryString('childrenAgesStr') || '';

    if (citytype != 0 && citytype != 2 && citytype != 3) citytype = 0;

    if (citytype == 3) {
        if (+new Date() + 24 * 60 * 60 * 1000 > +new Date(checkin.replace(/-/g, '/') + ' 23:59:59')) {
            checkin = addDays(new Date(), 1);
            checkout = addDays(new Date(), 2);
        }
    } else {
        if (+new Date() > +new Date(checkin.replace(/-/g, '/') + ' 23:59:59')) {
            checkin = addDays(new Date(), 0);
            checkout = addDays(new Date(), 1);
        }
    }

    var params = {
        'infoIds': hotelId,
        "type": citytype,
        "startDate": checkin,
        "endDate": checkout,
        "selRoomNum": selRoomNum,
        "adultNum": adultNum,
        "childrenNum": childrenNum,
        "childrenAgesStr": childrenAgesStr,
        "pageNow": 1
    };

    hotelIdObj.attr('data-hotelid', hotelId);

    setNavText(citytype);

    setInitParams(params);

    $.queryingHotelParams = params;

    queryPrices(hotelIdObj[0], params, priceTableTmpl);

    queryHotels(params);
}, initPageScroll = function initPageScroll() {
    window.setTimeout(function () {

        window.onscroll = function () {
            var elem = $('.hli-expand-inner .icon-up')[0],
                clientHeight = document.documentElement.clientHeight;

            if (elem) {
                var o = $('.hli-expand-inner')[0],
                    p = $(o).closest('.hli-price-list-wrap')[0],
                    rect = p.getBoundingClientRect();

                if (rect.bottom >= clientHeight) {
                    $(o).addClass('fix-bottom');
                } else {
                    $(o).removeClass('fix-bottom');
                }

                if (rect.top >= clientHeight - 300) {
                    $(o).removeClass('fix-bottom');
                }

                if (rect.top <= 90) {
                    $('.search-line-outer').addClass('fix-top');
                } else {
                    $('.search-line-outer').removeClass('fix-top');
                }
            } else {
                $('.search-line-outer').removeClass('fix-top');
            }
        };
    }, 5000);
};

module.exports = {
    run: function run() {
        getInitParamsAndInitPage();

        initPageScroll();
    }
};

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!-- 酒店信息 -->\r\n<div class="hotel-detail-info-inner">\r\n    <div class="hdi-head">\r\n        <h1 class="hdi-hotel-name1">\r\n			<span class="hdi-hotel-name">' +
((__t = ( o.infoName )) == null ? '' : __t) +
'</span>\r\n			<span class="hdi-hotel-name2">' +
((__t = ( o.enName || '' )) == null ? '' : __t) +
'</span>\r\n			';
 if(o.displayFlag) { ;
__p += '\r\n				<i class="hli-icon' +
((__t = ( o.displayFlag === '1' ? ' icon-jinpai' : o.displayFlag === '2' ? ' icon-tuiguang' : '' )) == null ? '' : __t) +
' "></i>\r\n			';
 } ;
__p += '\r\n			<span class="hdi-level-name">\r\n			' +
((__t = ( 
				~('50,55'.indexOf( o.star )) ? '豪华型' :
				~('40,45'.indexOf( o.star )) ? '高档型' :
				~('30,35'.indexOf( o.star )) ? '舒适型' : '经济型'
			)) == null ? '' : __t) +
'\r\n			</span>\r\n			\r\n			<span class="hdi-icon-star"></span>\r\n			<span class="hdi-icon-star"></span>\r\n			';
 if(~('50,55'.indexOf( o.star ))) { ;
__p += '\r\n				<span class="hdi-icon-star"></span>\r\n				<span class="hdi-icon-star"></span>\r\n				<span class="hdi-icon-star"></span>\r\n			';
 } else if(~('40,45'.indexOf( o.star ))) { ;
__p += '\r\n				<span class="hdi-icon-star"></span>\r\n				<span class="hdi-icon-star"></span>\r\n			';
 } else if(~('30,35'.indexOf( o.star ))) { ;
__p += '\r\n				<span class="hdi-icon-star"></span>\r\n			';
 } ;
__p += '\r\n		</h1>\r\n		\r\n		<div class="hdi-location">\r\n			<i class="iconfont icon-location1"></i>\r\n			<label>地址：</label>\r\n			<a title="map" class="hdi-open-map" href="#hotelMap" data-link="';
 if (o.countryType==0) {;
__p += '/biz/hotel/foreignhotel/baiduMap.jsp';
 }else{ ;
__p += '/biz/hotel/foreignhotel/googleMap.jsp';
 } ;
__p += '?lon=' +
((__t = ( o.longitude || 0 )) == null ? '' : __t) +
'&amp;lat=' +
((__t = ( o.latitude || 0 )) == null ? '' : __t) +
'&amp;_location=' +
((__t = ( encodeURI(encodeURI(o.address.replace(/[： 。，！、:.!,]+$/g,''))) )) == null ? '' : __t) +
'&amp;_title=' +
((__t = ( encodeURI(encodeURI(o.infoName)) )) == null ? '' : __t) +
'">\r\n				<span class="hdi-location-text">' +
((__t = ( o.address.replace(/[： 。，！、:.!,]+$/g,'') || '' )) == null ? '' : __t) +
'</span>\r\n			</a>\r\n		</div>\r\n		\r\n		<div class="hdi-lowest-wrap">\r\n			<div class="hdi-gz-wrap">\r\n				<div class="hdi-gz-inner ' +
((__t = ( (o.hasOwnProperty('isMyFavorite') && o.isMyFavorite === 1) ? 'icon-gz-on' : 'icon-gz-off' )) == null ? '' : __t) +
'" data-hotelid="' +
((__t = ( o.infoId )) == null ? '' : __t) +
'">\r\n					';
 if (o.hasOwnProperty('isMyFavorite') && o.isMyFavorite === 1){ ;
__p += '\r\n						<i class="iconfont icon-favorite-fill"></i>\r\n						<span class="icon-gz-on-tips">已收藏</span>\r\n					';
 }else{ ;
__p += '\r\n						<i class="iconfont icon-favorite"></i>\r\n						<span class="icon-gz-on-tips">未收藏</span>\r\n					';
 } ;
__p += '\r\n				</div>\r\n			</div>\r\n		</div>\r\n    </div>\r\n\r\n    <div class="hdi-body">\r\n		<div class="hdi-img-outer">\r\n			<div class="hdi-img-wrap-big">\r\n				<div class="hdi-scroll-btn left disabled">\r\n					<i class="iconfont icon-left2"></i>\r\n				</div>\r\n\r\n				<img class="hdi-img-source" src="' +
((__t = ( o.picSrc.replace(/\/common\/images\/nopic.png/, 'https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1560999493874.png" style="width: 50%;margin: 70px 0 0 137px;') )) == null ? '' : __t) +
'" />\r\n				\r\n				<div class="hdi-scroll-btn right">\r\n					<i class="iconfont icon-right2"></i>\r\n				</div>\r\n			</div>\r\n			<div class="hdi-img-wrap-small">\r\n				<div class="hdi-img-scroll scroll-up disabled">\r\n					<i class="hli-icon"></i>\r\n				</div>\r\n				\r\n				<ul class="hdi-img-small-list">\r\n					';
 for(var i = 0; i < o.picList.length; i++){ var p = o.picList[i]; ;
__p += '\r\n					<li class="hdi-img-small-item ' +
((__t = ( i === 0 ? 'active' : '')) == null ? '' : __t) +
'" data-index="' +
((__t = ( i )) == null ? '' : __t) +
'">\r\n						<img class="hide-img-thumb" src="' +
((__t = ( p.replace(/\/common\/images\/nopic.png/, 'https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1560999493874.png" style="width: 50%;margin: 20px 0 0 32px;') )) == null ? '' : __t) +
'" />\r\n					</li>\r\n					';
 } ;
__p += '\r\n				</ul>\r\n\r\n				<div class="hdi-img-scroll scroll-down">\r\n					<i class="hli-icon"></i>\r\n				</div>\r\n			</div>\r\n		</div>\r\n		<div class="hdi-brief-wrap">\r\n			<ul class="hdi-brief-list">\r\n				<li class="hdi-brief-item">\r\n					<p class="hdi-brief-item-title">酒店简介</p>\r\n					<div id="hotel-introduction" class="hdi-brief-item-content" data-content="' +
((__t = ( o.infoDesc )) == null ? '' : __t) +
'">\r\n						';
 if(o.infoDesc && o.infoDesc.length > 45){ ;
__p += '\r\n							<span>' +
((__t = ( o.infoDesc.substring(0,45) )) == null ? '' : __t) +
'......</span>\r\n							<a href="javascipt:void(0);" class="hdi-brief-view-detail">[查看详情]</a>\r\n						';
 } else { ;
__p += '\r\n							<span>' +
((__t = ( o.infoDesc || '' )) == null ? '' : __t) +
'</span>\r\n						';
 } ;
__p += '\r\n					</div>\r\n					<p>联系方式：' +
((__t = ( o.bookingPhone || '' )) == null ? '' : __t) +
'</p>\r\n				</li>\r\n				<li class="hdi-brief-item">\r\n					<p class="hdi-brief-item-title">特别提示</p>\r\n					<div class="hdi-brief-item-content" data-content="' +
((__t = ( o.indicate )) == null ? '' : __t) +
'">\r\n						';
 if(o.indicate && o.indicate.length > 45){ ;
__p += '\r\n							<span>' +
((__t = ( o.indicate.substring(0,45) )) == null ? '' : __t) +
'......</span>\r\n							<a href="javascipt:void(0);" class="hdi-brief-view-detail">[查看详情]</a>\r\n						';
 } else { ;
__p += '\r\n							<span>' +
((__t = ( o.indicate || '无' )) == null ? '' : __t) +
'</span>\r\n						';
 } ;
__p += '\r\n					</div>\r\n				</li>\r\n			</ul>\r\n\r\n			<p id="mapCon1" style="height: 210px;margin-top: 8px;"></p>\r\n		</div>\r\n    </div>\r\n</div>\r\n';

}
return __p
}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\r\n<!--酒店信息详情-->\r\n<div class="hotel-detail-inner">\r\n	<h1 class="hotel-detail-title">酒店详情</h1>\r\n	<ul class="hotel-detail-list">\r\n        <!-- 入住政策 -->\r\n        <div id="checkin-policy-content"></div>\r\n\r\n		<li class="hotel-detail-item hotel-detail-item-tip">\r\n			<label class="hotel-detail-label">\r\n				<i class="hli-icon icon-tebietixing"></i>\r\n				特别提示\r\n			</label>\r\n			<p class="hotel-detail-content hotel-detail-content-tip">' +
((__t = ( o.indicate || '无' )) == null ? '' : __t) +
'</p>\r\n		</li>\r\n		<!--<li class="hotel-detail-item">\r\n			<label class="hotel-detail-label">\r\n				<i class="hli-icon icon-jiudianjianjie"></i>\r\n				温馨提示\r\n			</label>\r\n			<p class="hotel-detail-content">该酒店产品不可以放到美团网站上售卖，如有返现，订单给予取消并照常收款，第三人入住需要加收底三个人入住费用；wifi免费；酒店客房即公共区域一律禁止吸烟；住房需注意创作，价格使用 9间即一下，适用于中国市场</p>\r\n		</li>-->\r\n		<li class="hotel-detail-item">\r\n			<label class="hotel-detail-label">\r\n				<i class="hli-icon icon-lianxifangshi"></i>\r\n				联系方式\r\n			</label>\r\n			<p class="hotel-detail-content">' +
((__t = ( o.bookingPhone|| '' )) == null ? '' : __t) +
'</p>\r\n		</li>\r\n		<li class="hotel-detail-item">\r\n			<label class="hotel-detail-label">\r\n				<i class="hli-icon icon-jiudiansheshi"></i>\r\n				酒店设施\r\n			</label>\r\n			<p class="hotel-detail-content">' +
((__t = ( o.facilities ? o.facilities.split('|').join('、') : '' )) == null ? '' : __t) +
'</p>\r\n		</li>\r\n		<li class="hotel-detail-item hotel-detail-item-introduction">\r\n			<label class="hotel-detail-label">\r\n				<i class="hli-icon icon-jiudianjianjie"></i>\r\n				酒店简介\r\n			</label>\r\n			<div class="hotel-detail-content hotel-detail-content-introduction">' +
((__t = ( o.infoDesc || '' )) == null ? '' : __t) +
'</div>\r\n		</li>\r\n		';
 if (o.licenseLink) { ;
__p += '\r\n			<li class="hotel-detail-item">\r\n					<label class="hotel-detail-label">\r\n						<i class="hli-icon icon-jiudianfuwu"></i>\r\n						证照信息\r\n					</label>\r\n					<p id="showLicenses" class="hotel-detail-content">查看酒店证照信息 >></p>\r\n				</li>\r\n		  ';
 } ;
__p += '\r\n	</ul>\r\n</div>\r\n';

}
return __p
}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<ul>\r\n	';
 for(var i = 0; i < len; i++){ var n = Ar[i]; ;
__p += '\r\n	<li class="poi-item-li" data-point="' +
((__t = ( encodeURIComponent(JSON.stringify(n.point)) )) == null ? '' : __t) +
'" data-index="' +
((__t = ( i + 1 )) == null ? '' : __t) +
'">\r\n		<div class="poi-type-item-left-wrap">\r\n			<i class="iconfont icon-location"></i>\r\n			<span>' +
((__t = ( i + 1 )) == null ? '' : __t) +
'</span>\r\n		</div>\r\n		<div class="poi-type-item-right-wrap">\r\n			<p class="title" data-title="' +
((__t = ( n.title )) == null ? '' : __t) +
'">' +
((__t = ( n.title )) == null ? '' : __t) +
' <a href="' +
((__t = ( n.url )) == null ? '' : __t) +
'" target="_blank">详情</a> </p>\r\n			<p class="address">' +
((__t = ( n.address )) == null ? '' : __t) +
'</p>\r\n		</div>\r\n	</li>\r\n	';
 } ;
__p += '\r\n</ul>';

}
return __p
}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="acWrap">\r\n        <div id="acContent" class="cf clearfix">\r\n            <div class="content-img">\r\n                <img src="' +
((__t = ( o.licenseLink )) == null ? '' : __t) +
'" /> \r\n            </div>\r\n        </div>\r\n</div>\r\n';

}
return __p
}

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {


var Util = __webpack_require__(0);
var queryString = Util.queryString;

var sideThumbHeight = 98;
var itemHeight = sideThumbHeight + 2;
var onePageHeight = 4 * itemHeight;

var initSmallImgListScroll = function initSmallImgListScroll() {
	$(".hotel-detail-info-outer").delegate('.hdi-img-wrap-small', 'mouseover', function () {
		$(this).find('.hdi-img-scroll').show();
	}).delegate('.hdi-img-wrap-small', 'mouseout', function () {
		$(this).find('.hdi-img-scroll').hide();
	});

	$(".hotel-detail-info-outer").delegate('.hdi-img-scroll', 'click', function () {
		var _this = $(this),
		    parent = _this.closest('.hdi-img-wrap-small'),
		    upIcon = parent.find('.scroll-up'),
		    downIcon = parent.find('.scroll-down'),
		    target = parent.find('.hdi-img-small-list'),
		    liCount = target.find('li').length,
		    targetHeight = liCount * sideThumbHeight + (liCount - 1) * 2;

		var offsetY;
		var translateY = -parseInt(target.css('margin-top'));

		if (_this.hasClass('scroll-down')) {
			if (downIcon.hasClass('disabled')) return;

			upIcon.removeClass('disabled');

			var nextStep = translateY + onePageHeight;

			if (targetHeight - nextStep < onePageHeight) {
				offsetY = targetHeight - 412;
				downIcon.addClass('disabled');
			} else {
				offsetY = nextStep;
			}
		} else {
			if (upIcon.hasClass('disabled')) return;

			downIcon.removeClass('disabled');

			var nextStep = translateY - onePageHeight;

			if (nextStep <= 0) {
				offsetY = 0;
				upIcon.addClass('disabled');
			} else {
				offsetY = nextStep;
			}
		}

		var topNodesCount = Math.ceil(offsetY / itemHeight);
		var $sliderNodes = $(".hotel-detail-info-outer .hdi-img-small-list .hdi-img-small-item");
		var currentImageUrl = $($sliderNodes[topNodesCount]).find('.hide-img-thumb').attr('src');

		$sliderNodes.removeClass('active');
		$($sliderNodes[topNodesCount]).addClass('active');
		target.animate({ 'margin-top': -offsetY }, 200);
		showImageInAlbums(currentImageUrl);
		updateHorizontalBtn(topNodesCount, $sliderNodes.length);
	});
};

var initSmallImgClick = function initSmallImgClick() {
	$(".hotel-detail-info-outer").delegate('.hdi-img-small-item', 'click', function () {
		var _this = $(this),
		    $sliderNodes,
		    thisImgSrc;

		if (_this.hasClass('active')) return;

		thisImgSrc = _this.find('.hide-img-thumb').attr('src');
		showImageInAlbums(thisImgSrc);
		$sliderNodes = _this.closest('.hdi-img-small-list').find('.hdi-img-small-item');
		$sliderNodes.removeClass('active');
		_this.addClass('active');
		updateHorizontalBtn(_this.data('index'), $sliderNodes.length);
	});
};

var showImageInAlbums = function showImageInAlbums(url) {
	$(".hotel-detail-info-outer .hdi-img-wrap-big .hdi-img-source").attr('src', url);
};

var initHorizontalScroll = function initHorizontalScroll() {
	$(".hotel-detail-info-outer").delegate('.hdi-img-wrap-big', 'mouseover', function () {
		$(this).find('.hdi-scroll-btn').show();
	}).delegate('.hdi-img-wrap-big', 'mouseout', function () {
		$(this).find('.hdi-scroll-btn').hide();
	});

	$(".hotel-detail-info-outer").delegate('.hdi-scroll-btn', 'click', function () {
		var $this = $(this);

		if ($this.hasClass('disabled')) return;

		var $list = $(".hotel-detail-info-outer .hdi-img-small-list");
		var $sliderNodes = $list.children(".hdi-img-small-item");
		var total = $sliderNodes.length;
		var listHeight = total * sideThumbHeight + (total - 1) * 2;
		var translateY = -parseInt($list.css('margin-top'));
		var topNodesCount = Math.ceil(translateY / itemHeight);
		var next = void 0;

		$sliderNodes.each(function (index, item) {
			var $node = $(item);

			if ($node.hasClass('active')) {
				if ($this.hasClass('left')) {
					next = index - 1;
				} else {
					next = index + 1;
				}

				$node.removeClass('active');
			}
		});

		var $current = $($sliderNodes[next]);
		var offsetY = void 0;

		if (next < topNodesCount) {
			if (topNodesCount <= 4) {
				offsetY = 0;
			} else {
				offsetY = (topNodesCount - 4) * itemHeight;
			}
		} else if (next > topNodesCount + 3) {
			if (total - next <= 4) {
				offsetY = listHeight - 412;
			} else {
				offsetY = (topNodesCount + 4) * itemHeight;
			}
		}

		if (offsetY >= 0) {
			var $parent = $(".hotel-detail-info-outer .hdi-img-wrap-small");
			var $topBtn = $parent.children('.scroll-up');
			var $bottomBtn = $parent.children('.scroll-down');

			$list.animate({ 'margin-top': -offsetY }, 200);

			if (offsetY === 0) {
				$topBtn.addClass('disabled');

				if (listHeight > 412) {
					$bottomBtn.removeClass('disabled');
				}
			} else if (listHeight > 412) {
				if (offsetY === listHeight - 412) {
					$topBtn.removeClass('disabled');
					$bottomBtn.addClass('disabled');
				} else {
					$bottomBtn.removeClass('disabled');
				}
			}
		}

		$current.addClass('active');
		showImageInAlbums($current.find('.hide-img-thumb').attr('src'));
		updateHorizontalBtn(next, $sliderNodes.length);
	});
};

var updateHorizontalBtn = function updateHorizontalBtn(index, total) {
	var $parent = $(".hotel-detail-info-outer .hdi-img-wrap-big");
	var $leftBtn = $parent.children('.left');
	var $rightBtn = $parent.children('.right');

	if (index === 0) {
		$leftBtn.addClass('disabled');
		$rightBtn.removeClass('disabled');
	} else {
		$leftBtn.removeClass('disabled');

		if (index === total - 1) {
			$rightBtn.addClass('disabled');
		} else {
			$rightBtn.removeClass('disabled');
		}
	}
};

var initHotelInfoFolder = function initHotelInfoFolder() {
	$(".hotel-detail-info-outer").delegate('.hdi-brief-view-detail', 'click', function () {
		var $content = $(this).closest('.hdi-brief-item-content');
		var text = $content.data('content');

		$content.html(text);
	});
};

module.exports = {
	run: function run() {
		initSmallImgListScroll();

		initHorizontalScroll();

		initSmallImgClick();

		initHotelInfoFolder();
	}
};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {


var Util = __webpack_require__(0),
    myCalendar = __webpack_require__(28),
    mySelect = __webpack_require__(22),
    adultChildrenSelect = __webpack_require__(67),
    queryPrices = __webpack_require__(137),
    priceTableTmpl = __webpack_require__(212),
    filterPriceAndFillIntoTable = __webpack_require__(119),
    getPriceRange = function getPriceRange(priceMin, priceMax) {
	priceMin = priceMin || 0;
	priceMax = priceMax || 4000;

	var priceArr = [0, 200, 300, 500, 800, 1500, 3000, 30000];
	var falg_start = false;
	var falg_end = false;
	var priceRange_result_str = "";
	for (var p_i = 0; p_i < 7; p_i++) {
		var priceArr_min = priceArr[p_i];
		var priceArr_max = priceArr[p_i + 1] - 1;
		if (priceMin >= priceArr_min && priceMin <= priceArr_max) {
			falg_start = true;
		}
		if (falg_start && !falg_end) {
			if (priceRange_result_str == "") {
				priceRange_result_str = priceArr_min + "-" + priceArr_max;
			} else {
				priceRange_result_str += "," + priceArr_min + "-" + priceArr_max;
			}
		}
		if (priceMax >= priceArr_min && priceMax <= priceArr_max) {
			falg_end = true;
		}
	}
	if (priceRange_result_str.lastIndexOf(',') >= 48) priceRange_result_str = '';
	return priceRange_result_str;
},
    getParams = function getParams() {
	var datesInput = document.querySelector(".s-i-dates-input"),
	    roomNum = document.querySelector(".s-i-room-num"),
	    adultChildren = document.querySelector(".s-i-adult-children"),
	    params = {
		type: $.queryingHotelParams.type || "0",
		startDate: Util.formatOne(datesInput.checkin),
		endDate: datesInput.checkout ? Util.formatOne(datesInput.checkout) : Util.addDays(datesInput.checkin, 1),
		selRoomNum: $(roomNum).attr('data-value'),
		adultNum: adultChildren ? adultChildren.adultNum : 2,
		childrenNum: adultChildren ? adultChildren.childrenNum : 0,
		childrenAgesStr: adultChildren ? adultChildren.childrenAgesStr : ''
	},
	    priceRange = getPriceRange(+$("#slp_1").val(), +$("#slp_2").val());

	if (priceRange) params.priceRange = priceRange;

	$.extend($.queryingHotelParams, params);

	return params;
},
    searchLineScrollIntoView = function searchLineScrollIntoView() {
	if ($('.search-line-outer').hasClass('fix-top')) {
		setTimeout(function () {
			$('.search-line-outer')[0].scrollIntoView();
		}, 50);
	}
},
    searchHotelPrice = function searchHotelPrice() {
	var price1 = $("#slp_1").val(),
	    price2 = $("#slp_2").val();

	if (price1 && price2 && parseInt(price1) > parseInt(price2)) {
		layer.msg('请设置正确的价格区间！');
		return false;
	}

	var loadingStr = '<div class="fzg-loading-wrap">' + '<img src="https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1514022140288.gif"/>' + '</div>';

	$(".hli-price-list-wrap").html(loadingStr);
	queryPrices(document.querySelector('#hotelId'), getParams, priceTableTmpl);
	searchLineScrollIntoView();
},
    initSearchBtnClick = function initSearchBtnClick() {
	$(".search-line-btn").on('click', function () {
		if (!$(this).hasClass('disabled')) {
			searchHotelPrice();
		}
	});

	$(".s-i-room-num, .d-s-item.bedbreakfast").on('change', function () {
		searchHotelPrice();
	});
},
    initCalendar = function initCalendar() {
	$('.s-i-dates-input').on('mousedown', function () {
		myCalendar({
			left: -81,
			top: 1,
			validDays: 15,
			cityType: $.queryingHotelParams.type || 0
		});
	});

	$('.s-i-dates-input').on('datePicked', function () {
		searchHotelPrice();
	});
},
    initRoomNum = function initRoomNum() {
	$(".s-i-room-num").on('mousedown', function () {
		mySelect({
			options: [{ text: '1间', value: '1' }, { text: '2间', value: '2' }, { text: '3间', value: '3' }, { text: '4间', value: '4' }, { text: '5间', value: '5' }, { text: '6间', value: '6' }, { text: '7间', value: '7' }, { text: '8间', value: '8' }, { text: '9间', value: '9' }, { text: '10间', value: '10' }]
		});
	});
},
    initAdultChildrenSelect = function initAdultChildrenSelect() {
	$('.s-i-adult-children').on('mousedown', function () {
		adultChildrenSelect();
	});
},
    initFrontEndParamsChange = function initFrontEndParamsChange() {
	$(".d-s-item").on('click', function () {
		if (!$(this).hasClass('bedbreakfast')) {
			filterPriceAndFillIntoTable(priceTableTmpl);
		}

		searchLineScrollIntoView();
	});
},
    initPriceRangeInput = function initPriceRangeInput() {
	$(".search-line-price").on('keyup input paste', function () {
		this.value = this.value.replace(/[^\d]/g, '');
	});
},
    initLowestHighestEdit = function initLowestHighestEdit() {
	$(".search-line-price").on('change', function () {
		filterPriceAndFillIntoTable(priceTableTmpl);
	});
};

module.exports = {
	run: function run() {
		initPriceRangeInput();

		initCalendar();

		initRoomNum();

		initAdultChildrenSelect();

		initSearchBtnClick();

		initFrontEndParamsChange();

		initLowestHighestEdit();
	}
};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {



var Util = __webpack_require__(0),
    initExpandBtnClick = function initExpandBtnClick() {
	$(".hli-price-list-wrap").delegate('.hli-expand-inner', 'click', function () {

		var _this = $(this);
		var expandText = _this.find('span');
		var expandIcon = _this.find('.hli-icon');
		var autoHideTrs = _this.closest('.hl-item').find('.auto-hide');
		var myTrs = _this.closest('.hl-item').find('.mytr');

		if (expandIcon.hasClass('icon-down')) {

			$(".myBody").find(".gt-one-tr").removeClass("click-more-css");
			expandIcon.removeClass('icon-down').addClass('icon-up');
			expandText.html('收起全部房型');
		} else {

			$(".myBody").find(".gt-one-tr").addClass("click-more-css");
			expandIcon.removeClass('icon-up').addClass('icon-down');
			expandText.html('展开全部房型');

			setTimeout(function () {
				$('html,body').animate({
					scrollTop: $(".hotel-price-table").offset().top
				}, 200);
			}, 100);
		}

		_this.closest('.fix-bottom').removeClass('fix-bottom');
	});
},
    initAlertLogin = function initAlertLogin() {
	$('.login-btn').click(function () {
		__webpack_require__(1)();
	});
};

module.exports = {
	run: function run() {
		initExpandBtnClick();

		initAlertLogin();
	}
};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {



var Util = __webpack_require__(0),
    addDays = __webpack_require__(0).addDays,
    buildMonths = __webpack_require__(125),
    comfirmPrice = __webpack_require__(24).getInitData,
    queryPriceForCalendar = __webpack_require__(214);

var queryString = __webpack_require__(0).queryString;
var changeTotalMoney = __webpack_require__(31).ticketTotalMoney;
var changeToPage = __webpack_require__(30).changeToPage;

function getRoomPrice(checkin, checkout) {
    var hotelQueryParams = __webpack_require__(213).hotelQueryParams;

    var roomNum = document.querySelector(".s-i-room-num"),
        adultChildren = document.querySelector(".s-i-adult-children"),
        params = {
        checkInDate: Util.formatOne(checkin),
        checkOutDate: checkout ? Util.formatOne(checkout) : Util.addDays(checkin, 1),
        roomNum: $(roomNum).attr('data-value'),
        adultNum: adultChildren ? adultChildren.adultNum : 2,
        childrenNum: adultChildren ? adultChildren.childrenNum : 0,
        childrenAgesStr: adultChildren ? adultChildren.childrenAgesStr : '',
        hotelId: hotelQueryParams.hotelId,
        roomId: hotelQueryParams.roomId,
        supplierId: hotelQueryParams.supplierId,
        rateType: hotelQueryParams.rateType
    };

    if (!params.hotelId) {
        alert("酒店查价没有带 hotelId 参数！");
        return;
    }

    hotelQueryParams.checkInDate = params.checkInDate;
    hotelQueryParams.checkOutDate = params.checkOutDate;

    $.post('/hotel/getHotelPriceListInStock.do', params, function (res) {
        if (res.returnCode === 1) {
            if (res.data.roomTypeBases) {
                var room = res.data.roomTypeBases[0].roomTypePrices[0];
                if (room.isBook) {
                    window.location.href = goToOrderConfirmPage(room, hotelQueryParams);
                } else {
                    if (room.roomStatus == 3) {
                        alert("有日期为满房，请检查");
                    } else {
                        var bookingTerms = getBookingTerms(room.nightlyPriceList);
                        var html = '';
                        for (var index = 0; index < bookingTerms.length; index++) {
                            var element = bookingTerms[index];
                            html += '<h4>' + element.tip + '</h4>';
                        }
                        if (html) {
                            alert(html + "选择时间段中不符合预订条款或房间剩余数量不足");
                        } else {
                            alert("查价数据为空，请检查房间剩余数量和预订条款！");
                        }
                    }
                }
            } else {
                $.post('/hotel/getHotelPriceRealTime.do', params, function (res) {
                    if (res.returnCode === 1) {
                        if (res.data.roomTypeBases) {
                            var _room = res.data.roomTypeBases[0].roomTypePrices[0];
                            if (_room.isBook) {
                                window.location.href = goToOrderConfirmPage(_room, hotelQueryParams);
                            } else {
                                if (_room.roomStatus == 3) {
                                    alert("有日期为满房，请检查");
                                } else {
                                    var _bookingTerms = getBookingTerms(_room.nightlyPriceList);
                                    var _html = '';
                                    for (var _index = 0; _index < _bookingTerms.length; _index++) {
                                        var _element = _bookingTerms[_index];
                                        _html += '<h4>' + _element.tip + '</h4>';
                                    }
                                    if (_html) {
                                        alert(_html + "选择时间段中不符合预订条款或房间剩余数量不足");
                                    } else {
                                        alert("查价数据为空，请检查房间剩余数量和预订条款！");
                                    }
                                }
                            }
                        } else {
                            alert("查价数据为空！");
                        }
                    } else {
                        alert(res.returnMsg);
                    }
                });
            }
        } else {
            alert(res.returnMsg);
        }
    });
}

goToOrderConfirmPage = function goToOrderConfirmPage(_this, hotelQueryParams) {

    var nightlyPriceList = _this.nightlyPriceList;
    var ifInvoice = nightlyPriceList && nightlyPriceList[0] && nightlyPriceList[0].ifInvoice;

    var priceStrs = encodeURIComponent(window.JSON.stringify(_this));

    var priceStrs_key = "hotelPriceStrs_" + +new Date();

    var params = ['staticInfoId=' + _this.hotelId, 'hotelId=' + _this.hotelId, 'supplierId=' + _this.supplierId, 'roomId=' + _this.roomId, 'breakFastId=' + _this.breakFastId, 'paymentType=' + _this.paymentType, 'rateType=' + _this.rateType, 'isQueryPrice=true', hotelQueryParams.marketingStr, 'startDate=' + hotelQueryParams.checkInDate, 'endDate=' + hotelQueryParams.checkOutDate, 'citytype=' + $.queryingHotelParams.type || '0', 'adultNum=' + $.queryingHotelParams.adultNum, 'childrenNum=' + $.queryingHotelParams.childrenNum, 'childrenAgeStr=' + $.queryingHotelParams.childrenAgesStr, 'roomNum=' + $.queryingHotelParams.selRoomNum, 'ch=' + $.queryingHotelParams.type || '0', 'hotelPriceStrsKey=' + priceStrs_key, 'isTicket=' + (!ifInvoice || ifInvoice === 1 || ifInvoice === 3 ? 0 : 1)];

    sessionStorage.setItem(priceStrs_key, priceStrs);

    var url = "/order/orderConfirm.do?" + params.join('&');

    return url;
};

function initCalendarDayClick() {
    $(document).delegate('.cp-td-inner', 'click', function () {

        if ($(this).hasClass('disabled') || $(this).hasClass('disabled-checkout')) return;

        if ($('.jump-order-btn').length !== 0) {

            var _this = $(this),
                thisDayStr = _this.attr('data-day'),
                dayArr = _this.closest('.calendar-price-wrap').find('.cp-td-inner'),
                checkin = $($.grep(dayArr, function (o) {
                return $(o).hasClass('checkin');
            })),
                checkout = $($.grep(dayArr, function (o) {
                return $(o).hasClass('checkout');
            })),
                checkBetween = $($.grep(dayArr, function (o) {
                return $(o).hasClass('between-check');
            })),
                parent = _this.closest('.calendar-price-wrap').parent(),
                checkinInput = parent.find('.oop-date-input.checkin'),
                thisDayprice = _this.find('.calendar-p-price').text();
            checkinText = _this.find('.check-in-span');
            checkoutText = _this.find('.check-out-span');

            if (!checkin.length) {
                _this.addClass('checkin');
                checkinText.removeClass("hidden");
                setTmpGray(dayArr, thisDayStr);
            } else if (checkin.length && !checkout.length) {
                    if (_this.hasClass('checkin')) {
                        _this.removeClass('checkin');
                        checkinText.addClass("hidden");
                        removeTmpGray(dayArr);
                        return;
                    }

                    if (new Date(thisDayStr) < new Date(checkin.attr('data-day'))) {
                        checkin.removeClass('checkin');
                        checkin.find(".check-in-span").addClass("hidden");
                        removeTmpGray(dayArr);

                        _this.addClass('checkin');
                        checkinText.removeClass("hidden");
                        setTmpGray(dayArr, thisDayStr);
                        return;
                    }

                    _this.addClass('checkout');
                    checkoutText.removeClass("hidden");
                    setCheckBetween(checkin.attr("data-day"), thisDayStr, dayArr);

                    getRoomPrice(checkin.attr('data-day'), thisDayStr);
                    setTimeout(function () {
                        $('.calendar-price-wrap').hide();
                    }, 200);
                } else {}
        } else {
            var _this = $(this),
                thisDayStr = _this.attr('data-day'),
                dayArr = _this.closest('.calendar-price-wrap').find('.cp-td-inner'),
                checkin = $($.grep(dayArr, function (o) {
                return $(o).hasClass('checkin');
            })),
                parent = _this.closest('.calendar-price-wrap').parent(),
                checkinInput = parent.find('.oop-date-input.checkin'),
                thisDayprice = _this.find('.calendar-p-price').text();

            if (!checkin.length) {
                _this.addClass('checkin');
                checkinInput.val(thisDayStr).attr('data-v', thisDayStr);
                $('#ticketCalenderPrice').val(addDays(thisDayStr, 0, '-'));
                var aimDom = _this.find('#paramsStore');
                var params = {
                    carType: aimDom.attr('data-carType'),
                    isRealName: aimDom.attr('data-isRealName'),
                    ticketRangeId: aimDom.attr('data-ticketRangeId'),
                    stockId: aimDom.attr('data-stockId'),
                    formulaType: aimDom.attr('data-formulaType'),
                    paymentType: aimDom.attr('data-paymentType'),
                    priceType: aimDom.attr('data-priceType'),
                    ticketType: aimDom.attr('data-ticketType'),
                    suppName: aimDom.attr('data-suppName'),
                    suppId: aimDom.attr('data-suppId'),
                    itemId: aimDom.attr('data-itemId'),
                    infoId: aimDom.attr('data-infoId')
                };
                comfirmPrice(addDays(thisDayStr, 0, '-'), params, function (res) {
                    if (res.returnCode === 1) {
                        $.orderInfo = res;
                        $('.t-o-c-price').empty().text(thisDayprice);
                        changeTotalMoney();
                        $('.calendar-price-wrap').hide();
                        $('.chidren-select-wrap').slideToggle('fast');
                    } else if (res.returnCode === -400001) {
                        alert('请先登录', { closeBtn: 0 }, function () {
                            location.href = '/user/bookHotel.do?';
                        });
                    } else {
                        alert(res.errinfo, function () {
                            changeToPage();
                        });
                    }
                });
            }
        }
    });
}

function initMonthSwitchLeftClick() {
    $(document).delegate('.month-switch-bar.month-left', 'click', function () {
        var _this = $(this),
            parent = _this.closest('.calendar-price-wrap'),
            currentMonthArr = parent.find('.cp-one-month-wrap.current'),
            hiddenAhead = $(currentMonthArr[0]).prevAll('.cp-one-month-wrap.hidden');

        var $ele = $(".month-right");
        if ($ele.hasClass('hidden')) {
            $ele.removeClass('hidden');
        }

        if (hiddenAhead.length < 2) {
            parent.find('.month-left').addClass('hidden');
        }

        $(currentMonthArr[currentMonthArr.length - 1]).removeClass('current').addClass('hidden');
        $(currentMonthArr[0]).prev('.cp-one-month-wrap.hidden').removeClass('hidden').addClass('current');
    });
}

function initMonthSwitchRightClick(option) {
    $(document).delegate('.calendar-price-wrap .month-switch-bar.month-right', 'click', function () {
        var _this = $(this),
            parent = _this.closest('.calendar-price-wrap'),
            currentMonthArr = parent.find('.cp-one-month-wrap.current'),
            hiddenAhead = $(currentMonthArr[0]).prevAll('.cp-one-month-wrap.hidden'),
            hiddenBehind = $(currentMonthArr[currentMonthArr.length - 1]).nextAll('.cp-one-month-wrap.hidden');

        parent.find('.month-left').removeClass('hidden');
        $(currentMonthArr[0]).removeClass('current').addClass('hidden');

        var lastMonthStr = $(currentMonthArr[currentMonthArr.length - 1]).attr('data-month'),
            cYear = +lastMonthStr.split('/')[0],
            cMonth = +lastMonthStr.split('/')[1],
            newMonthStr = cMonth == 12 ? cYear + 1 + '-01' : cYear + '-' + (cMonth + 1),
            newMonthHTML = cMonth == 12 ? buildMonths(cYear + 1, 1) : buildMonths(cYear, cMonth + 1);
        var checkin = addDays(newMonthStr, 0, '-');
        var date1 = addDays(new Date(), 0, '-');
        var BetweenDates = getMonthsBetweenDates(new Date(date1), new Date(checkin));
        if (BetweenDates == 6) {
            $(".month-right").addClass('hidden');
        }

        if (hiddenBehind.length > 0) {
            $(hiddenBehind[0]).removeClass('hidden').addClass('current');
        } else {
            parent.append(newMonthHTML);

            var _this = $(this),
                checkout = addDays(newMonthStr, 30, '-'),
                hotelId = _this.next('.hiddenOrderPrice').attr('data-hotelId'),
                suppId = _this.next('.hiddenOrderPrice').attr('data-suppId'),
                roomType = _this.next('.hiddenOrderPrice').attr('data-roomType'),
                priceType = _this.next('.hiddenOrderPrice').attr('data-priceType'),
                currency = _this.next('.hiddenOrderPrice').attr('data-currency');

            var orderParam = {
                hotelId: hotelId,
                suppId: suppId,
                roomType: roomType,
                priceType: priceType,
                currency: currency,

                startDateStr: checkin,
                endDateStr: checkout
            };

            queryPriceForCalendar(orderParam, newMonthStr, option);
        }
    });
}

function setCheckBetween(checkin, checkout, dayArr) {
    checkin = +new Date(checkin);
    checkout = +new Date(checkout);

    for (var i = 0; i < dayArr.length; i++) {
        var o = dayArr[i],
            oTime = +new Date($(o).attr('data-day'));

        if (checkin <= oTime && oTime <= checkout && !$(o).hasClass('day-grayed')) {
            $(o).addClass('between-check');
        }
    }
}

function setTmpGray(dayArr, checkin) {
    if (dayArr && checkin) {

        var lastValidDay = new Date(addDays(checkin, 15, '/') + ' 23:59:59');
        var checkinDate = new Date(checkin);

        var hasNoPrice;

        for (var i = 0; i < dayArr.length; i++) {
            var _date = new Date($(dayArr[i]).attr('data-day'));

            if (hasNoPrice) {
                $(dayArr[i]).addClass('disabled-checkout');

                $(dayArr[i]).find(".calendar-p-price").addClass('calendar-d-price');
                continue;
            }

            if (_date > checkinDate && _date < lastValidDay && $(dayArr[i]).hasClass('disabled')) {
                $(dayArr[i]).removeClass('disabled');

                $(dayArr[i]).addClass('temporary-cancel-disabled');
                hasNoPrice = new Date($(dayArr[i]).attr('data-day'));
            }

            if (lastValidDay < _date) {
                $(dayArr[i]).addClass('disabled-checkout');

                $(dayArr[i]).find(".calendar-p-price").addClass('calendar-d-price');
            }
        }
    }
}

function removeTmpGray(dayArr) {
    if (dayArr) {
        $(dayArr).removeClass('disabled-checkout');
        $(dayArr).find(".calendar-d-price").removeClass('calendar-d-price');
        $(dayArr).each(function () {
            if ($(this).hasClass('temporary-cancel-disabled')) {
                $(this).removeClass('temporary-cancel-disabled').addClass('disabled');
            }
        });
    }
}

function getMonthsBetweenDates(date1, date2) {
    var months = (date2.getFullYear() - date1.getFullYear()) * 12;
    months += date2.getMonth() - date1.getMonth();
    return months + 1;
}

getBookingTerms = function getBookingTerms(pList) {
    var dataObj = {},
        clauses = [];

    for (var i = 0; i < pList.length; i++) {
        var reserveShowArr = pList[i].reserveShow.split(/[|;]/);
        for (var j = 0; j < reserveShowArr.length; j++) {
            var o = reserveShowArr[j];
            ~o.indexOf('限住') ? dataObj['限制晚数'] = o : ~o.indexOf('提前') ? dataObj['提前预订'] = o : ~o.indexOf('至少连住') ? dataObj['至少连住'] = o : ~o.indexOf('最大连住') ? dataObj['最大连住'] = o : ~o.indexOf('连住') ? dataObj['连住多晚'] = o : ~o.indexOf('时间') ? dataObj['限时预订'] = o : ~o.indexOf('间数') ? dataObj['限制间数'] = o : dataObj['无预订条款'] = o;
        }
    }

    for (key in dataObj) {
        if (key !== '无预订条款') clauses.push({ name: key, tip: dataObj[key] });
    }

    return clauses;
}, module.exports = function (option) {
    initCalendarDayClick(option);

    initMonthSwitchLeftClick(option);

    initMonthSwitchRightClick(option);
};

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[331]);


// WEBPACK FOOTER //
// js/hotelDetail/hotelDetail.4f18eea6a908b14628ea.js